/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as R403RouteImport } from './routes/403'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as AccessRouteRouteImport } from './routes/access_/route'
import { Route as AuthenticationRouteImport } from './routes/authentication'
import { Route as CompanyRouteRouteImport } from './routes/company_/route'
import { Route as PartnerRouteRouteImport } from './routes/partner_/route'
import { Route as PersonalRouteRouteImport } from './routes/personal_/route'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as SupervisorRouteRouteImport } from './routes/supervisor_/route'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as AdminSiteIdRouteRouteImport } from './routes/_admin/$siteId/route'
import { Route as Admin401RouteImport } from './routes/_admin/401'
import { Route as Admin404RouteImport } from './routes/_admin/404'
import { Route as AdminErrorRouteImport } from './routes/_admin/error'
import { Route as AdminOverviewRouteImport } from './routes/_admin/overview'
import { Route as AccessIndexRouteImport } from './routes/access_/index'
import { Route as Access401RouteImport } from './routes/access_/401'
import { Route as AccessAuthenticationRouteImport } from './routes/access_/authentication'
import { Route as AccessErrorRouteImport } from './routes/access_/error'
import { Route as AccessOverviewRouteImport } from './routes/access_/overview'
import { Route as AppOnboardingRouteImport } from './routes/app/onboarding'
import { Route as AuthenticationForgotPasswordRouteImport } from './routes/authentication/forgot-password'
import { Route as AuthenticationLoginRouteImport } from './routes/authentication/login'
import { Route as AuthenticationLogoutRouteImport } from './routes/authentication/logout'
import { Route as AuthenticationResetPasswordRouteImport } from './routes/authentication/reset-password'
import { Route as CompanyIndexRouteImport } from './routes/company_/index'
import { Route as CompanyGroupIdRouteRouteImport } from './routes/company_/$groupId/route'
import { Route as PartnerPartnerIdRouteRouteImport } from './routes/partner_/$partnerId/route'
import { Route as PersonalIndexRouteImport } from './routes/personal_/index'
import { Route as PersonalOverviewRouteImport } from './routes/personal_/overview'
import { Route as PersonalTasksRouteImport } from './routes/personal_/tasks'
import { Route as SupervisorIndexRouteImport } from './routes/supervisor_/index'
import { Route as SupervisorLogsRouteImport } from './routes/supervisor_/logs'
import { Route as SupervisorUsersRouteImport } from './routes/supervisor_/users'
import { Route as AdminSiteIdOverviewRouteRouteImport } from './routes/_admin/$siteId/overview/route'
import { Route as AdminConfigZonesRouteImport } from './routes/_admin/config/zones'
import { Route as AdminEventsIndexRouteImport } from './routes/_admin/events/index'
import { Route as AdminEventsEventIdRouteRouteImport } from './routes/_admin/events/$eventId/route'
import { Route as AdminGroupsIndexRouteImport } from './routes/_admin/groups/index'
import { Route as AdminGroupsGroupIdRouteRouteImport } from './routes/_admin/groups/$groupId/route'
import { Route as AdminLogsIndexRouteImport } from './routes/_admin/logs/index'
import { Route as AdminProjectsIndexRouteImport } from './routes/_admin/projects/index'
import { Route as AdminProjectsProjectIdRouteRouteImport } from './routes/_admin/projects/$projectId/route'
import { Route as AdminReportsIndexRouteImport } from './routes/_admin/reports/index'
import { Route as AdminReportsAccessLogsRouteImport } from './routes/_admin/reports/access-logs'
import { Route as AdminReportsDocumentsRouteImport } from './routes/_admin/reports/documents'
import { Route as AdminReportsOccupancyRouteImport } from './routes/_admin/reports/occupancy'
import { Route as AdminReportsSiteStatusRouteImport } from './routes/_admin/reports/site-status'
import { Route as AdminReportsTimeOnSiteRouteImport } from './routes/_admin/reports/time-on-site'
import { Route as AdminSystemAgenticParsingRouteImport } from './routes/_admin/system/agentic-parsing'
import { Route as AdminSystemAssetsRouteImport } from './routes/_admin/system/assets'
import { Route as AdminSystemDatasourcesRouteImport } from './routes/_admin/system/datasources'
import { Route as AdminSystemDocumentTypesRouteImport } from './routes/_admin/system/document-types'
import { Route as AdminSystemImportRouteImport } from './routes/_admin/system/import'
import { Route as AdminSystemIntegrationsRouteImport } from './routes/_admin/system/integrations'
import { Route as AdminSystemOverviewRouteImport } from './routes/_admin/system/overview'
import { Route as AdminSystemSettingsRouteImport } from './routes/_admin/system/settings'
import { Route as AdminUsersIndexRouteImport } from './routes/_admin/users/index'
import { Route as AdminUsersUserIdRouteRouteImport } from './routes/_admin/users/$userId/route'
import { Route as AccessTasksTaskIdRouteImport } from './routes/access_/tasks/$taskId'
import { Route as AppRegistrationIndexRouteImport } from './routes/app/registration/index'
import { Route as AppRegistrationFixedRouteImport } from './routes/app/registration/fixed'
import { Route as AppTasksTaskIdRouteImport } from './routes/app/tasks/$taskId'
import { Route as CompanyGroupIdInformationRouteImport } from './routes/company_/$groupId/information'
import { Route as CompanyBlockedGroupIdRouteImport } from './routes/company_/blocked.$groupId'
import { Route as CompanyVerifyGroupIdRouteImport } from './routes/company_/verify.$groupId'
import { Route as PartnerPartnerIdInformationRouteImport } from './routes/partner_/$partnerId/information'
import { Route as PersonalEventsIndexRouteImport } from './routes/personal_/events/index'
import { Route as PersonalEventsEventIdRouteRouteImport } from './routes/personal_/events/$eventId/route'
import { Route as PersonalGroupsIndexRouteImport } from './routes/personal_/groups/index'
import { Route as PersonalGroupsGroupIdRouteRouteImport } from './routes/personal_/groups/$groupId/route'
import { Route as PersonalProjectsIndexRouteImport } from './routes/personal_/projects/index'
import { Route as PersonalProjectsProjectIdRouteRouteImport } from './routes/personal_/projects/$projectId/route'
import { Route as AdminSiteIdOverviewIndexRouteImport } from './routes/_admin/$siteId/overview/index'
import { Route as AdminSiteIdOverviewApprovalsRouteImport } from './routes/_admin/$siteId/overview/approvals'
import { Route as AdminSiteIdOverviewAttendanceRouteImport } from './routes/_admin/$siteId/overview/attendance'
import { Route as AdminSiteIdOverviewToReviewRouteImport } from './routes/_admin/$siteId/overview/to-review'
import { Route as AdminConfigBlocklistIndexRouteImport } from './routes/_admin/config/blocklist/index'
import { Route as AdminConfigDevicesIndexRouteImport } from './routes/_admin/config/devices/index'
import { Route as AdminConfigDevicesDeviceIdRouteImport } from './routes/_admin/config/devices/$deviceId'
import { Route as AdminConfigDevicesTopologyRouteImport } from './routes/_admin/config/devices/topology'
import { Route as AdminConfigGeneralIndexRouteImport } from './routes/_admin/config/general/index'
import { Route as AdminConfigIntegrationsIndexRouteImport } from './routes/_admin/config/integrations/index'
import { Route as AdminConfigRolesIndexRouteImport } from './routes/_admin/config/roles/index'
import { Route as AdminConfigRolesRoleIdRouteImport } from './routes/_admin/config/roles/$roleId'
import { Route as AdminConfigRolesAccessRouteImport } from './routes/_admin/config/roles/access'
import { Route as AdminConfigTasksIndexRouteImport } from './routes/_admin/config/tasks/index'
import { Route as AdminEventsEventIdIndexRouteImport } from './routes/_admin/events/$eventId/index'
import { Route as AdminEventsEventIdDetailsRouteImport } from './routes/_admin/events/$eventId/details'
import { Route as AdminEventsEventIdLogsRouteImport } from './routes/_admin/events/$eventId/logs'
import { Route as AdminEventsEventIdSubcontractingRouteImport } from './routes/_admin/events/$eventId/subcontracting'
import { Route as AdminEventsEventIdUsersRouteImport } from './routes/_admin/events/$eventId/users'
import { Route as AdminGroupsGroupIdIndexRouteImport } from './routes/_admin/groups/$groupId/index'
import { Route as AdminGroupsGroupIdContactDetailsRouteImport } from './routes/_admin/groups/$groupId/contact-details'
import { Route as AdminGroupsGroupIdDetailsRouteImport } from './routes/_admin/groups/$groupId/details'
import { Route as AdminGroupsGroupIdEventsRouteImport } from './routes/_admin/groups/$groupId/events'
import { Route as AdminGroupsGroupIdLogsRouteImport } from './routes/_admin/groups/$groupId/logs'
import { Route as AdminGroupsGroupIdUsersRouteImport } from './routes/_admin/groups/$groupId/users'
import { Route as AdminProjectsProjectIdIndexRouteImport } from './routes/_admin/projects/$projectId/index'
import { Route as AdminProjectsProjectIdEventsRouteImport } from './routes/_admin/projects/$projectId/events'
import { Route as AdminProjectsProjectIdLogsRouteImport } from './routes/_admin/projects/$projectId/logs'
import { Route as AdminSystemFormsIndexRouteImport } from './routes/_admin/system/forms/index'
import { Route as AdminSystemFormsIdRouteImport } from './routes/_admin/system/forms/$id'
import { Route as AdminSystemSitesIndexRouteImport } from './routes/_admin/system/sites/index'
import { Route as AdminSystemSitesIdRouteImport } from './routes/_admin/system/sites/$id'
import { Route as AdminSystemTemplatesIndexRouteImport } from './routes/_admin/system/templates/index'
import { Route as AdminSystemTemplatesIdRouteImport } from './routes/_admin/system/templates/$id'
import { Route as AdminUsersUserIdIndexRouteImport } from './routes/_admin/users/$userId/index'
import { Route as AdminUsersUserIdAccessRouteImport } from './routes/_admin/users/$userId/access'
import { Route as AdminUsersUserIdBadgesRouteImport } from './routes/_admin/users/$userId/badges'
import { Route as AdminUsersUserIdDetailsRouteImport } from './routes/_admin/users/$userId/details'
import { Route as AdminUsersUserIdEventsRouteImport } from './routes/_admin/users/$userId/events'
import { Route as AdminUsersUserIdLogsRouteImport } from './routes/_admin/users/$userId/logs'
import { Route as AdminUsersUserIdRolesRouteImport } from './routes/_admin/users/$userId/roles'
import { Route as CompanyGroupIdApprovalsIndexRouteImport } from './routes/company_/$groupId/approvals/index'
import { Route as CompanyGroupIdApprovalsTaskIdRouteImport } from './routes/company_/$groupId/approvals/$taskId'
import { Route as CompanyGroupIdDocumentsIndexRouteImport } from './routes/company_/$groupId/documents/index'
import { Route as CompanyGroupIdDocumentsDocumentIdRouteImport } from './routes/company_/$groupId/documents/$documentId'
import { Route as CompanyGroupIdEventsIndexRouteImport } from './routes/company_/$groupId/events/index'
import { Route as CompanyGroupIdEventsEventIdRouteRouteImport } from './routes/company_/$groupId/events/$eventId/route'
import { Route as CompanyGroupIdProjectsIndexRouteImport } from './routes/company_/$groupId/projects/index'
import { Route as CompanyGroupIdProjectsProjectIdRouteRouteImport } from './routes/company_/$groupId/projects/$projectId/route'
import { Route as CompanyGroupIdTasksIndexRouteImport } from './routes/company_/$groupId/tasks/index'
import { Route as CompanyGroupIdTasksTaskIdRouteImport } from './routes/company_/$groupId/tasks/$taskId'
import { Route as CompanyGroupIdUsersIndexRouteImport } from './routes/company_/$groupId/users/index'
import { Route as PartnerPartnerIdApprovalsIndexRouteImport } from './routes/partner_/$partnerId/approvals/index'
import { Route as PartnerPartnerIdApprovalsApprovalIdRouteImport } from './routes/partner_/$partnerId/approvals/$approvalId'
import { Route as PartnerPartnerIdDocumentsIndexRouteImport } from './routes/partner_/$partnerId/documents/index'
import { Route as PartnerPartnerIdDocumentsDocumentIdRouteImport } from './routes/partner_/$partnerId/documents/$documentId'
import { Route as PartnerPartnerIdEventsIndexRouteImport } from './routes/partner_/$partnerId/events/index'
import { Route as PartnerPartnerIdEventsEventIdRouteRouteImport } from './routes/partner_/$partnerId/events/$eventId/route'
import { Route as PartnerPartnerIdProjectsIndexRouteImport } from './routes/partner_/$partnerId/projects/index'
import { Route as PartnerPartnerIdProjectsProjectIdRouteImport } from './routes/partner_/$partnerId/projects/$projectId'
import { Route as PartnerPartnerIdTasksIndexRouteImport } from './routes/partner_/$partnerId/tasks/index'
import { Route as PartnerPartnerIdTasksTaskIdRouteImport } from './routes/partner_/$partnerId/tasks/$taskId'
import { Route as PartnerPartnerIdUsersIndexRouteImport } from './routes/partner_/$partnerId/users/index'
import { Route as PersonalEventsEventIdIndexRouteImport } from './routes/personal_/events/$eventId/index'
import { Route as PersonalEventsEventIdDetailsRouteImport } from './routes/personal_/events/$eventId/details'
import { Route as PersonalEventsEventIdLogsRouteImport } from './routes/personal_/events/$eventId/logs'
import { Route as PersonalEventsEventIdSubcontractingRouteImport } from './routes/personal_/events/$eventId/subcontracting'
import { Route as PersonalEventsEventIdUsersRouteImport } from './routes/personal_/events/$eventId/users'
import { Route as PersonalGroupsGroupIdIndexRouteImport } from './routes/personal_/groups/$groupId/index'
import { Route as PersonalGroupsGroupIdDetailsRouteImport } from './routes/personal_/groups/$groupId/details'
import { Route as PersonalGroupsGroupIdEventsRouteImport } from './routes/personal_/groups/$groupId/events'
import { Route as PersonalGroupsGroupIdLogsRouteImport } from './routes/personal_/groups/$groupId/logs'
import { Route as PersonalGroupsGroupIdUsersRouteImport } from './routes/personal_/groups/$groupId/users'
import { Route as PersonalProjectsProjectIdIndexRouteImport } from './routes/personal_/projects/$projectId/index'
import { Route as PersonalProjectsProjectIdEventsRouteImport } from './routes/personal_/projects/$projectId/events'
import { Route as PersonalProjectsProjectIdLogsRouteImport } from './routes/personal_/projects/$projectId/logs'
import { Route as AdminConfigFormsSlugOrIdBuildRouteImport } from './routes/_admin/config/forms/$slugOrId/build'
import { Route as AdminConfigTasksSlugIndexRouteImport } from './routes/_admin/config/tasks/$slug/index'
import { Route as AdminConfigTasksSlugTranslateRouteImport } from './routes/_admin/config/tasks/$slug/translate'
import { Route as AdminConfigTypesEventIndexRouteImport } from './routes/_admin/config/types/event/index'
import { Route as AdminConfigTypesEventTypeIdRouteImport } from './routes/_admin/config/types/event/$typeId'
import { Route as AdminConfigTypesGroupIndexRouteImport } from './routes/_admin/config/types/group/index'
import { Route as AdminConfigTypesGroupTypeIdRouteImport } from './routes/_admin/config/types/group/$typeId'
import { Route as AdminEventsEventIdApprovalsIndexRouteImport } from './routes/_admin/events/$eventId/approvals/index'
import { Route as AdminEventsEventIdApprovalsTaskIdRouteImport } from './routes/_admin/events/$eventId/approvals/$taskId'
import { Route as AdminEventsEventIdDocumentsIndexRouteImport } from './routes/_admin/events/$eventId/documents/index'
import { Route as AdminEventsEventIdDocumentsDocumentIdRouteImport } from './routes/_admin/events/$eventId/documents/$documentId'
import { Route as AdminEventsEventIdTasksIndexRouteImport } from './routes/_admin/events/$eventId/tasks/index'
import { Route as AdminEventsEventIdTasksTaskIdRouteImport } from './routes/_admin/events/$eventId/tasks/$taskId'
import { Route as AdminGroupsGroupIdApprovalsIndexRouteImport } from './routes/_admin/groups/$groupId/approvals/index'
import { Route as AdminGroupsGroupIdApprovalsApprovalIdRouteImport } from './routes/_admin/groups/$groupId/approvals/$approvalId'
import { Route as AdminGroupsGroupIdDocumentsIndexRouteImport } from './routes/_admin/groups/$groupId/documents/index'
import { Route as AdminGroupsGroupIdDocumentsDocumentIdRouteImport } from './routes/_admin/groups/$groupId/documents/$documentId'
import { Route as AdminGroupsGroupIdTasksIndexRouteImport } from './routes/_admin/groups/$groupId/tasks/index'
import { Route as AdminGroupsGroupIdTasksTaskIdRouteImport } from './routes/_admin/groups/$groupId/tasks/$taskId'
import { Route as AdminUsersUserIdApprovalsIndexRouteImport } from './routes/_admin/users/$userId/approvals/index'
import { Route as AdminUsersUserIdApprovalsApprovalIdRouteImport } from './routes/_admin/users/$userId/approvals/$approvalId'
import { Route as AdminUsersUserIdDocumentsIndexRouteImport } from './routes/_admin/users/$userId/documents/index'
import { Route as AdminUsersUserIdDocumentsDocumentIdRouteImport } from './routes/_admin/users/$userId/documents/$documentId'
import { Route as AdminUsersUserIdTasksIndexRouteImport } from './routes/_admin/users/$userId/tasks/index'
import { Route as AdminUsersUserIdTasksTaskIdRouteImport } from './routes/_admin/users/$userId/tasks/$taskId'
import { Route as CompanyGroupIdEventsEventIdDetailsRouteImport } from './routes/company_/$groupId/events/$eventId/details'
import { Route as CompanyGroupIdEventsEventIdGroupsRouteImport } from './routes/company_/$groupId/events/$eventId/groups'
import { Route as CompanyGroupIdEventsEventIdLogsRouteImport } from './routes/company_/$groupId/events/$eventId/logs'
import { Route as CompanyGroupIdEventsEventIdSubcontractingRouteImport } from './routes/company_/$groupId/events/$eventId/subcontracting'
import { Route as CompanyGroupIdEventsEventIdUsersRouteImport } from './routes/company_/$groupId/events/$eventId/users'
import { Route as CompanyGroupIdProjectsProjectIdEventsRouteImport } from './routes/company_/$groupId/projects/$projectId/events'
import { Route as PartnerPartnerIdEventsEventIdDetailsRouteImport } from './routes/partner_/$partnerId/events/$eventId/details'
import { Route as PartnerPartnerIdEventsEventIdLogsRouteImport } from './routes/partner_/$partnerId/events/$eventId/logs'
import { Route as PartnerPartnerIdEventsEventIdSubcontractingRouteImport } from './routes/partner_/$partnerId/events/$eventId/subcontracting'
import { Route as PartnerPartnerIdEventsEventIdUsersRouteImport } from './routes/partner_/$partnerId/events/$eventId/users'
import { Route as PartnerPartnerIdUsersUserIdDocumentIdRouteImport } from './routes/partner_/$partnerId/users/$userId.$documentId'
import { Route as PersonalEventsEventIdApprovalsIndexRouteImport } from './routes/personal_/events/$eventId/approvals/index'
import { Route as PersonalEventsEventIdApprovalsTaskIdRouteImport } from './routes/personal_/events/$eventId/approvals/$taskId'
import { Route as PersonalEventsEventIdDocumentsIndexRouteImport } from './routes/personal_/events/$eventId/documents/index'
import { Route as PersonalEventsEventIdDocumentsDocumentIdRouteImport } from './routes/personal_/events/$eventId/documents/$documentId'
import { Route as PersonalEventsEventIdTasksIndexRouteImport } from './routes/personal_/events/$eventId/tasks/index'
import { Route as PersonalEventsEventIdTasksTaskIdRouteImport } from './routes/personal_/events/$eventId/tasks/$taskId'
import { Route as PersonalGroupsGroupIdDocumentsIndexRouteImport } from './routes/personal_/groups/$groupId/documents/index'
import { Route as PersonalGroupsGroupIdDocumentsDocumentIdRouteImport } from './routes/personal_/groups/$groupId/documents/$documentId'
import { Route as PersonalGroupsGroupIdTasksIndexRouteImport } from './routes/personal_/groups/$groupId/tasks/index'
import { Route as PersonalGroupsGroupIdTasksTaskIdRouteImport } from './routes/personal_/groups/$groupId/tasks/$taskId'
import { Route as CompanyGroupIdEventsEventIdDocumentsIndexRouteImport } from './routes/company_/$groupId/events/$eventId/documents/index'
import { Route as CompanyGroupIdEventsEventIdDocumentsDocumentIdRouteImport } from './routes/company_/$groupId/events/$eventId/documents/$documentId'
import { Route as CompanyGroupIdEventsEventIdTasksIndexRouteImport } from './routes/company_/$groupId/events/$eventId/tasks/index'
import { Route as CompanyGroupIdEventsEventIdTasksTaskIdRouteImport } from './routes/company_/$groupId/events/$eventId/tasks/$taskId'
import { Route as PartnerPartnerIdEventsEventIdApprovalsIndexRouteImport } from './routes/partner_/$partnerId/events/$eventId/approvals/index'
import { Route as PartnerPartnerIdEventsEventIdApprovalsTaskIdRouteImport } from './routes/partner_/$partnerId/events/$eventId/approvals/$taskId'
import { Route as PartnerPartnerIdEventsEventIdDocumentsIndexRouteImport } from './routes/partner_/$partnerId/events/$eventId/documents/index'
import { Route as PartnerPartnerIdEventsEventIdDocumentsDocumentIdRouteImport } from './routes/partner_/$partnerId/events/$eventId/documents/$documentId'
import { Route as PartnerPartnerIdEventsEventIdTasksIndexRouteImport } from './routes/partner_/$partnerId/events/$eventId/tasks/index'
import { Route as PartnerPartnerIdEventsEventIdTasksTaskIdRouteImport } from './routes/partner_/$partnerId/events/$eventId/tasks/$taskId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessRouteRoute = AccessRouteRouteImport.update({
  id: '/access_',
  path: '/access',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticationRoute = AuthenticationRouteImport.update({
  id: '/authentication',
  path: '/authentication',
  getParentRoute: () => rootRouteImport,
} as any)
const CompanyRouteRoute = CompanyRouteRouteImport.update({
  id: '/company_',
  path: '/company',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnerRouteRoute = PartnerRouteRouteImport.update({
  id: '/partner_',
  path: '/partner',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalRouteRoute = PersonalRouteRouteImport.update({
  id: '/personal_',
  path: '/personal',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const SupervisorRouteRoute = SupervisorRouteRouteImport.update({
  id: '/supervisor_',
  path: '/supervisor',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSiteIdRouteRoute = AdminSiteIdRouteRouteImport.update({
  id: '/$siteId',
  path: '/$siteId',
  getParentRoute: () => AdminRoute,
} as any)
const Admin401Route = Admin401RouteImport.update({
  id: '/401',
  path: '/401',
  getParentRoute: () => AdminRoute,
} as any)
const Admin404Route = Admin404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => AdminRoute,
} as any)
const AdminErrorRoute = AdminErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOverviewRoute = AdminOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AdminRoute,
} as any)
const AccessIndexRoute = AccessIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccessRouteRoute,
} as any)
const Access401Route = Access401RouteImport.update({
  id: '/401',
  path: '/401',
  getParentRoute: () => AccessRouteRoute,
} as any)
const AccessAuthenticationRoute = AccessAuthenticationRouteImport.update({
  id: '/authentication',
  path: '/authentication',
  getParentRoute: () => AccessRouteRoute,
} as any)
const AccessErrorRoute = AccessErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => AccessRouteRoute,
} as any)
const AccessOverviewRoute = AccessOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AccessRouteRoute,
} as any)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: '/app/onboarding',
  path: '/app/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticationForgotPasswordRoute =
  AuthenticationForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => AuthenticationRoute,
  } as any)
const AuthenticationLoginRoute = AuthenticationLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthenticationRoute,
} as any)
const AuthenticationLogoutRoute = AuthenticationLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthenticationRoute,
} as any)
const AuthenticationResetPasswordRoute =
  AuthenticationResetPasswordRouteImport.update({
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => AuthenticationRoute,
  } as any)
const CompanyIndexRoute = CompanyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CompanyRouteRoute,
} as any)
const CompanyGroupIdRouteRoute = CompanyGroupIdRouteRouteImport.update({
  id: '/$groupId',
  path: '/$groupId',
  getParentRoute: () => CompanyRouteRoute,
} as any)
const PartnerPartnerIdRouteRoute = PartnerPartnerIdRouteRouteImport.update({
  id: '/$partnerId',
  path: '/$partnerId',
  getParentRoute: () => PartnerRouteRoute,
} as any)
const PersonalIndexRoute = PersonalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PersonalRouteRoute,
} as any)
const PersonalOverviewRoute = PersonalOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => PersonalRouteRoute,
} as any)
const PersonalTasksRoute = PersonalTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => PersonalRouteRoute,
} as any)
const SupervisorIndexRoute = SupervisorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SupervisorRouteRoute,
} as any)
const SupervisorLogsRoute = SupervisorLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => SupervisorRouteRoute,
} as any)
const SupervisorUsersRoute = SupervisorUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => SupervisorRouteRoute,
} as any)
const AdminSiteIdOverviewRouteRoute =
  AdminSiteIdOverviewRouteRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AdminSiteIdRouteRoute,
  } as any)
const AdminConfigZonesRoute = AdminConfigZonesRouteImport.update({
  id: '/config/zones',
  path: '/config/zones',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEventsIndexRoute = AdminEventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEventsEventIdRouteRoute = AdminEventsEventIdRouteRouteImport.update({
  id: '/events/$eventId',
  path: '/events/$eventId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminGroupsIndexRoute = AdminGroupsIndexRouteImport.update({
  id: '/groups/',
  path: '/groups/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminGroupsGroupIdRouteRoute = AdminGroupsGroupIdRouteRouteImport.update({
  id: '/groups/$groupId',
  path: '/groups/$groupId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLogsIndexRoute = AdminLogsIndexRouteImport.update({
  id: '/logs/',
  path: '/logs/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProjectsIndexRoute = AdminProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProjectsProjectIdRouteRoute =
  AdminProjectsProjectIdRouteRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminReportsIndexRoute = AdminReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReportsAccessLogsRoute = AdminReportsAccessLogsRouteImport.update({
  id: '/reports/access-logs',
  path: '/reports/access-logs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReportsDocumentsRoute = AdminReportsDocumentsRouteImport.update({
  id: '/reports/documents',
  path: '/reports/documents',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReportsOccupancyRoute = AdminReportsOccupancyRouteImport.update({
  id: '/reports/occupancy',
  path: '/reports/occupancy',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReportsSiteStatusRoute = AdminReportsSiteStatusRouteImport.update({
  id: '/reports/site-status',
  path: '/reports/site-status',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReportsTimeOnSiteRoute = AdminReportsTimeOnSiteRouteImport.update({
  id: '/reports/time-on-site',
  path: '/reports/time-on-site',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSystemAgenticParsingRoute =
  AdminSystemAgenticParsingRouteImport.update({
    id: '/system/agentic-parsing',
    path: '/system/agentic-parsing',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSystemAssetsRoute = AdminSystemAssetsRouteImport.update({
  id: '/system/assets',
  path: '/system/assets',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSystemDatasourcesRoute = AdminSystemDatasourcesRouteImport.update({
  id: '/system/datasources',
  path: '/system/datasources',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSystemDocumentTypesRoute =
  AdminSystemDocumentTypesRouteImport.update({
    id: '/system/document-types',
    path: '/system/document-types',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSystemImportRoute = AdminSystemImportRouteImport.update({
  id: '/system/import',
  path: '/system/import',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSystemIntegrationsRoute = AdminSystemIntegrationsRouteImport.update({
  id: '/system/integrations',
  path: '/system/integrations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSystemOverviewRoute = AdminSystemOverviewRouteImport.update({
  id: '/system/overview',
  path: '/system/overview',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSystemSettingsRoute = AdminSystemSettingsRouteImport.update({
  id: '/system/settings',
  path: '/system/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersUserIdRouteRoute = AdminUsersUserIdRouteRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AdminRoute,
} as any)
const AccessTasksTaskIdRoute = AccessTasksTaskIdRouteImport.update({
  id: '/tasks/$taskId',
  path: '/tasks/$taskId',
  getParentRoute: () => AccessRouteRoute,
} as any)
const AppRegistrationIndexRoute = AppRegistrationIndexRouteImport.update({
  id: '/app/registration/',
  path: '/app/registration/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRegistrationFixedRoute = AppRegistrationFixedRouteImport.update({
  id: '/app/registration/fixed',
  path: '/app/registration/fixed',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTasksTaskIdRoute = AppTasksTaskIdRouteImport.update({
  id: '/app/tasks/$taskId',
  path: '/app/tasks/$taskId',
  getParentRoute: () => rootRouteImport,
} as any)
const CompanyGroupIdInformationRoute =
  CompanyGroupIdInformationRouteImport.update({
    id: '/information',
    path: '/information',
    getParentRoute: () => CompanyGroupIdRouteRoute,
  } as any)
const CompanyBlockedGroupIdRoute = CompanyBlockedGroupIdRouteImport.update({
  id: '/blocked/$groupId',
  path: '/blocked/$groupId',
  getParentRoute: () => CompanyRouteRoute,
} as any)
const CompanyVerifyGroupIdRoute = CompanyVerifyGroupIdRouteImport.update({
  id: '/verify/$groupId',
  path: '/verify/$groupId',
  getParentRoute: () => CompanyRouteRoute,
} as any)
const PartnerPartnerIdInformationRoute =
  PartnerPartnerIdInformationRouteImport.update({
    id: '/information',
    path: '/information',
    getParentRoute: () => PartnerPartnerIdRouteRoute,
  } as any)
const PersonalEventsIndexRoute = PersonalEventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => PersonalRouteRoute,
} as any)
const PersonalEventsEventIdRouteRoute =
  PersonalEventsEventIdRouteRouteImport.update({
    id: '/events/$eventId',
    path: '/events/$eventId',
    getParentRoute: () => PersonalRouteRoute,
  } as any)
const PersonalGroupsIndexRoute = PersonalGroupsIndexRouteImport.update({
  id: '/groups/',
  path: '/groups/',
  getParentRoute: () => PersonalRouteRoute,
} as any)
const PersonalGroupsGroupIdRouteRoute =
  PersonalGroupsGroupIdRouteRouteImport.update({
    id: '/groups/$groupId',
    path: '/groups/$groupId',
    getParentRoute: () => PersonalRouteRoute,
  } as any)
const PersonalProjectsIndexRoute = PersonalProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => PersonalRouteRoute,
} as any)
const PersonalProjectsProjectIdRouteRoute =
  PersonalProjectsProjectIdRouteRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => PersonalRouteRoute,
  } as any)
const AdminSiteIdOverviewIndexRoute =
  AdminSiteIdOverviewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminSiteIdOverviewRouteRoute,
  } as any)
const AdminSiteIdOverviewApprovalsRoute =
  AdminSiteIdOverviewApprovalsRouteImport.update({
    id: '/approvals',
    path: '/approvals',
    getParentRoute: () => AdminSiteIdOverviewRouteRoute,
  } as any)
const AdminSiteIdOverviewAttendanceRoute =
  AdminSiteIdOverviewAttendanceRouteImport.update({
    id: '/attendance',
    path: '/attendance',
    getParentRoute: () => AdminSiteIdOverviewRouteRoute,
  } as any)
const AdminSiteIdOverviewToReviewRoute =
  AdminSiteIdOverviewToReviewRouteImport.update({
    id: '/to-review',
    path: '/to-review',
    getParentRoute: () => AdminSiteIdOverviewRouteRoute,
  } as any)
const AdminConfigBlocklistIndexRoute =
  AdminConfigBlocklistIndexRouteImport.update({
    id: '/config/blocklist/',
    path: '/config/blocklist/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminConfigDevicesIndexRoute = AdminConfigDevicesIndexRouteImport.update({
  id: '/config/devices/',
  path: '/config/devices/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminConfigDevicesDeviceIdRoute =
  AdminConfigDevicesDeviceIdRouteImport.update({
    id: '/config/devices/$deviceId',
    path: '/config/devices/$deviceId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminConfigDevicesTopologyRoute =
  AdminConfigDevicesTopologyRouteImport.update({
    id: '/config/devices/topology',
    path: '/config/devices/topology',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminConfigGeneralIndexRoute = AdminConfigGeneralIndexRouteImport.update({
  id: '/config/general/',
  path: '/config/general/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminConfigIntegrationsIndexRoute =
  AdminConfigIntegrationsIndexRouteImport.update({
    id: '/config/integrations/',
    path: '/config/integrations/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminConfigRolesIndexRoute = AdminConfigRolesIndexRouteImport.update({
  id: '/config/roles/',
  path: '/config/roles/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminConfigRolesRoleIdRoute = AdminConfigRolesRoleIdRouteImport.update({
  id: '/config/roles/$roleId',
  path: '/config/roles/$roleId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminConfigRolesAccessRoute = AdminConfigRolesAccessRouteImport.update({
  id: '/config/roles/access',
  path: '/config/roles/access',
  getParentRoute: () => AdminRoute,
} as any)
const AdminConfigTasksIndexRoute = AdminConfigTasksIndexRouteImport.update({
  id: '/config/tasks/',
  path: '/config/tasks/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEventsEventIdIndexRoute = AdminEventsEventIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminEventsEventIdRouteRoute,
} as any)
const AdminEventsEventIdDetailsRoute =
  AdminEventsEventIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AdminEventsEventIdRouteRoute,
  } as any)
const AdminEventsEventIdLogsRoute = AdminEventsEventIdLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => AdminEventsEventIdRouteRoute,
} as any)
const AdminEventsEventIdSubcontractingRoute =
  AdminEventsEventIdSubcontractingRouteImport.update({
    id: '/subcontracting',
    path: '/subcontracting',
    getParentRoute: () => AdminEventsEventIdRouteRoute,
  } as any)
const AdminEventsEventIdUsersRoute = AdminEventsEventIdUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminEventsEventIdRouteRoute,
} as any)
const AdminGroupsGroupIdIndexRoute = AdminGroupsGroupIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminGroupsGroupIdRouteRoute,
} as any)
const AdminGroupsGroupIdContactDetailsRoute =
  AdminGroupsGroupIdContactDetailsRouteImport.update({
    id: '/contact-details',
    path: '/contact-details',
    getParentRoute: () => AdminGroupsGroupIdRouteRoute,
  } as any)
const AdminGroupsGroupIdDetailsRoute =
  AdminGroupsGroupIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AdminGroupsGroupIdRouteRoute,
  } as any)
const AdminGroupsGroupIdEventsRoute =
  AdminGroupsGroupIdEventsRouteImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => AdminGroupsGroupIdRouteRoute,
  } as any)
const AdminGroupsGroupIdLogsRoute = AdminGroupsGroupIdLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => AdminGroupsGroupIdRouteRoute,
} as any)
const AdminGroupsGroupIdUsersRoute = AdminGroupsGroupIdUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminGroupsGroupIdRouteRoute,
} as any)
const AdminProjectsProjectIdIndexRoute =
  AdminProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminProjectsProjectIdRouteRoute,
  } as any)
const AdminProjectsProjectIdEventsRoute =
  AdminProjectsProjectIdEventsRouteImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => AdminProjectsProjectIdRouteRoute,
  } as any)
const AdminProjectsProjectIdLogsRoute =
  AdminProjectsProjectIdLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => AdminProjectsProjectIdRouteRoute,
  } as any)
const AdminSystemFormsIndexRoute = AdminSystemFormsIndexRouteImport.update({
  id: '/system/forms/',
  path: '/system/forms/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSystemFormsIdRoute = AdminSystemFormsIdRouteImport.update({
  id: '/system/forms/$id',
  path: '/system/forms/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSystemSitesIndexRoute = AdminSystemSitesIndexRouteImport.update({
  id: '/system/sites/',
  path: '/system/sites/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSystemSitesIdRoute = AdminSystemSitesIdRouteImport.update({
  id: '/system/sites/$id',
  path: '/system/sites/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSystemTemplatesIndexRoute =
  AdminSystemTemplatesIndexRouteImport.update({
    id: '/system/templates/',
    path: '/system/templates/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSystemTemplatesIdRoute = AdminSystemTemplatesIdRouteImport.update({
  id: '/system/templates/$id',
  path: '/system/templates/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersUserIdIndexRoute = AdminUsersUserIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminUsersUserIdRouteRoute,
} as any)
const AdminUsersUserIdAccessRoute = AdminUsersUserIdAccessRouteImport.update({
  id: '/access',
  path: '/access',
  getParentRoute: () => AdminUsersUserIdRouteRoute,
} as any)
const AdminUsersUserIdBadgesRoute = AdminUsersUserIdBadgesRouteImport.update({
  id: '/badges',
  path: '/badges',
  getParentRoute: () => AdminUsersUserIdRouteRoute,
} as any)
const AdminUsersUserIdDetailsRoute = AdminUsersUserIdDetailsRouteImport.update({
  id: '/details',
  path: '/details',
  getParentRoute: () => AdminUsersUserIdRouteRoute,
} as any)
const AdminUsersUserIdEventsRoute = AdminUsersUserIdEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AdminUsersUserIdRouteRoute,
} as any)
const AdminUsersUserIdLogsRoute = AdminUsersUserIdLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => AdminUsersUserIdRouteRoute,
} as any)
const AdminUsersUserIdRolesRoute = AdminUsersUserIdRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AdminUsersUserIdRouteRoute,
} as any)
const CompanyGroupIdApprovalsIndexRoute =
  CompanyGroupIdApprovalsIndexRouteImport.update({
    id: '/approvals/',
    path: '/approvals/',
    getParentRoute: () => CompanyGroupIdRouteRoute,
  } as any)
const CompanyGroupIdApprovalsTaskIdRoute =
  CompanyGroupIdApprovalsTaskIdRouteImport.update({
    id: '/approvals/$taskId',
    path: '/approvals/$taskId',
    getParentRoute: () => CompanyGroupIdRouteRoute,
  } as any)
const CompanyGroupIdDocumentsIndexRoute =
  CompanyGroupIdDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => CompanyGroupIdRouteRoute,
  } as any)
const CompanyGroupIdDocumentsDocumentIdRoute =
  CompanyGroupIdDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => CompanyGroupIdRouteRoute,
  } as any)
const CompanyGroupIdEventsIndexRoute =
  CompanyGroupIdEventsIndexRouteImport.update({
    id: '/events/',
    path: '/events/',
    getParentRoute: () => CompanyGroupIdRouteRoute,
  } as any)
const CompanyGroupIdEventsEventIdRouteRoute =
  CompanyGroupIdEventsEventIdRouteRouteImport.update({
    id: '/events/$eventId',
    path: '/events/$eventId',
    getParentRoute: () => CompanyGroupIdRouteRoute,
  } as any)
const CompanyGroupIdProjectsIndexRoute =
  CompanyGroupIdProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => CompanyGroupIdRouteRoute,
  } as any)
const CompanyGroupIdProjectsProjectIdRouteRoute =
  CompanyGroupIdProjectsProjectIdRouteRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => CompanyGroupIdRouteRoute,
  } as any)
const CompanyGroupIdTasksIndexRoute =
  CompanyGroupIdTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => CompanyGroupIdRouteRoute,
  } as any)
const CompanyGroupIdTasksTaskIdRoute =
  CompanyGroupIdTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => CompanyGroupIdRouteRoute,
  } as any)
const CompanyGroupIdUsersIndexRoute =
  CompanyGroupIdUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => CompanyGroupIdRouteRoute,
  } as any)
const PartnerPartnerIdApprovalsIndexRoute =
  PartnerPartnerIdApprovalsIndexRouteImport.update({
    id: '/approvals/',
    path: '/approvals/',
    getParentRoute: () => PartnerPartnerIdRouteRoute,
  } as any)
const PartnerPartnerIdApprovalsApprovalIdRoute =
  PartnerPartnerIdApprovalsApprovalIdRouteImport.update({
    id: '/approvals/$approvalId',
    path: '/approvals/$approvalId',
    getParentRoute: () => PartnerPartnerIdRouteRoute,
  } as any)
const PartnerPartnerIdDocumentsIndexRoute =
  PartnerPartnerIdDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => PartnerPartnerIdRouteRoute,
  } as any)
const PartnerPartnerIdDocumentsDocumentIdRoute =
  PartnerPartnerIdDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => PartnerPartnerIdRouteRoute,
  } as any)
const PartnerPartnerIdEventsIndexRoute =
  PartnerPartnerIdEventsIndexRouteImport.update({
    id: '/events/',
    path: '/events/',
    getParentRoute: () => PartnerPartnerIdRouteRoute,
  } as any)
const PartnerPartnerIdEventsEventIdRouteRoute =
  PartnerPartnerIdEventsEventIdRouteRouteImport.update({
    id: '/events/$eventId',
    path: '/events/$eventId',
    getParentRoute: () => PartnerPartnerIdRouteRoute,
  } as any)
const PartnerPartnerIdProjectsIndexRoute =
  PartnerPartnerIdProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => PartnerPartnerIdRouteRoute,
  } as any)
const PartnerPartnerIdProjectsProjectIdRoute =
  PartnerPartnerIdProjectsProjectIdRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => PartnerPartnerIdRouteRoute,
  } as any)
const PartnerPartnerIdTasksIndexRoute =
  PartnerPartnerIdTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => PartnerPartnerIdRouteRoute,
  } as any)
const PartnerPartnerIdTasksTaskIdRoute =
  PartnerPartnerIdTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => PartnerPartnerIdRouteRoute,
  } as any)
const PartnerPartnerIdUsersIndexRoute =
  PartnerPartnerIdUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => PartnerPartnerIdRouteRoute,
  } as any)
const PersonalEventsEventIdIndexRoute =
  PersonalEventsEventIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PersonalEventsEventIdRouteRoute,
  } as any)
const PersonalEventsEventIdDetailsRoute =
  PersonalEventsEventIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => PersonalEventsEventIdRouteRoute,
  } as any)
const PersonalEventsEventIdLogsRoute =
  PersonalEventsEventIdLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => PersonalEventsEventIdRouteRoute,
  } as any)
const PersonalEventsEventIdSubcontractingRoute =
  PersonalEventsEventIdSubcontractingRouteImport.update({
    id: '/subcontracting',
    path: '/subcontracting',
    getParentRoute: () => PersonalEventsEventIdRouteRoute,
  } as any)
const PersonalEventsEventIdUsersRoute =
  PersonalEventsEventIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => PersonalEventsEventIdRouteRoute,
  } as any)
const PersonalGroupsGroupIdIndexRoute =
  PersonalGroupsGroupIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PersonalGroupsGroupIdRouteRoute,
  } as any)
const PersonalGroupsGroupIdDetailsRoute =
  PersonalGroupsGroupIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => PersonalGroupsGroupIdRouteRoute,
  } as any)
const PersonalGroupsGroupIdEventsRoute =
  PersonalGroupsGroupIdEventsRouteImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => PersonalGroupsGroupIdRouteRoute,
  } as any)
const PersonalGroupsGroupIdLogsRoute =
  PersonalGroupsGroupIdLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => PersonalGroupsGroupIdRouteRoute,
  } as any)
const PersonalGroupsGroupIdUsersRoute =
  PersonalGroupsGroupIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => PersonalGroupsGroupIdRouteRoute,
  } as any)
const PersonalProjectsProjectIdIndexRoute =
  PersonalProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PersonalProjectsProjectIdRouteRoute,
  } as any)
const PersonalProjectsProjectIdEventsRoute =
  PersonalProjectsProjectIdEventsRouteImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => PersonalProjectsProjectIdRouteRoute,
  } as any)
const PersonalProjectsProjectIdLogsRoute =
  PersonalProjectsProjectIdLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => PersonalProjectsProjectIdRouteRoute,
  } as any)
const AdminConfigFormsSlugOrIdBuildRoute =
  AdminConfigFormsSlugOrIdBuildRouteImport.update({
    id: '/config/forms/$slugOrId/build',
    path: '/config/forms/$slugOrId/build',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminConfigTasksSlugIndexRoute =
  AdminConfigTasksSlugIndexRouteImport.update({
    id: '/config/tasks/$slug/',
    path: '/config/tasks/$slug/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminConfigTasksSlugTranslateRoute =
  AdminConfigTasksSlugTranslateRouteImport.update({
    id: '/config/tasks/$slug/translate',
    path: '/config/tasks/$slug/translate',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminConfigTypesEventIndexRoute =
  AdminConfigTypesEventIndexRouteImport.update({
    id: '/config/types/event/',
    path: '/config/types/event/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminConfigTypesEventTypeIdRoute =
  AdminConfigTypesEventTypeIdRouteImport.update({
    id: '/config/types/event/$typeId',
    path: '/config/types/event/$typeId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminConfigTypesGroupIndexRoute =
  AdminConfigTypesGroupIndexRouteImport.update({
    id: '/config/types/group/',
    path: '/config/types/group/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminConfigTypesGroupTypeIdRoute =
  AdminConfigTypesGroupTypeIdRouteImport.update({
    id: '/config/types/group/$typeId',
    path: '/config/types/group/$typeId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminEventsEventIdApprovalsIndexRoute =
  AdminEventsEventIdApprovalsIndexRouteImport.update({
    id: '/approvals/',
    path: '/approvals/',
    getParentRoute: () => AdminEventsEventIdRouteRoute,
  } as any)
const AdminEventsEventIdApprovalsTaskIdRoute =
  AdminEventsEventIdApprovalsTaskIdRouteImport.update({
    id: '/approvals/$taskId',
    path: '/approvals/$taskId',
    getParentRoute: () => AdminEventsEventIdRouteRoute,
  } as any)
const AdminEventsEventIdDocumentsIndexRoute =
  AdminEventsEventIdDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => AdminEventsEventIdRouteRoute,
  } as any)
const AdminEventsEventIdDocumentsDocumentIdRoute =
  AdminEventsEventIdDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => AdminEventsEventIdRouteRoute,
  } as any)
const AdminEventsEventIdTasksIndexRoute =
  AdminEventsEventIdTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => AdminEventsEventIdRouteRoute,
  } as any)
const AdminEventsEventIdTasksTaskIdRoute =
  AdminEventsEventIdTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => AdminEventsEventIdRouteRoute,
  } as any)
const AdminGroupsGroupIdApprovalsIndexRoute =
  AdminGroupsGroupIdApprovalsIndexRouteImport.update({
    id: '/approvals/',
    path: '/approvals/',
    getParentRoute: () => AdminGroupsGroupIdRouteRoute,
  } as any)
const AdminGroupsGroupIdApprovalsApprovalIdRoute =
  AdminGroupsGroupIdApprovalsApprovalIdRouteImport.update({
    id: '/approvals/$approvalId',
    path: '/approvals/$approvalId',
    getParentRoute: () => AdminGroupsGroupIdRouteRoute,
  } as any)
const AdminGroupsGroupIdDocumentsIndexRoute =
  AdminGroupsGroupIdDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => AdminGroupsGroupIdRouteRoute,
  } as any)
const AdminGroupsGroupIdDocumentsDocumentIdRoute =
  AdminGroupsGroupIdDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => AdminGroupsGroupIdRouteRoute,
  } as any)
const AdminGroupsGroupIdTasksIndexRoute =
  AdminGroupsGroupIdTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => AdminGroupsGroupIdRouteRoute,
  } as any)
const AdminGroupsGroupIdTasksTaskIdRoute =
  AdminGroupsGroupIdTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => AdminGroupsGroupIdRouteRoute,
  } as any)
const AdminUsersUserIdApprovalsIndexRoute =
  AdminUsersUserIdApprovalsIndexRouteImport.update({
    id: '/approvals/',
    path: '/approvals/',
    getParentRoute: () => AdminUsersUserIdRouteRoute,
  } as any)
const AdminUsersUserIdApprovalsApprovalIdRoute =
  AdminUsersUserIdApprovalsApprovalIdRouteImport.update({
    id: '/approvals/$approvalId',
    path: '/approvals/$approvalId',
    getParentRoute: () => AdminUsersUserIdRouteRoute,
  } as any)
const AdminUsersUserIdDocumentsIndexRoute =
  AdminUsersUserIdDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => AdminUsersUserIdRouteRoute,
  } as any)
const AdminUsersUserIdDocumentsDocumentIdRoute =
  AdminUsersUserIdDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => AdminUsersUserIdRouteRoute,
  } as any)
const AdminUsersUserIdTasksIndexRoute =
  AdminUsersUserIdTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => AdminUsersUserIdRouteRoute,
  } as any)
const AdminUsersUserIdTasksTaskIdRoute =
  AdminUsersUserIdTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => AdminUsersUserIdRouteRoute,
  } as any)
const CompanyGroupIdEventsEventIdDetailsRoute =
  CompanyGroupIdEventsEventIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => CompanyGroupIdEventsEventIdRouteRoute,
  } as any)
const CompanyGroupIdEventsEventIdGroupsRoute =
  CompanyGroupIdEventsEventIdGroupsRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => CompanyGroupIdEventsEventIdRouteRoute,
  } as any)
const CompanyGroupIdEventsEventIdLogsRoute =
  CompanyGroupIdEventsEventIdLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => CompanyGroupIdEventsEventIdRouteRoute,
  } as any)
const CompanyGroupIdEventsEventIdSubcontractingRoute =
  CompanyGroupIdEventsEventIdSubcontractingRouteImport.update({
    id: '/subcontracting',
    path: '/subcontracting',
    getParentRoute: () => CompanyGroupIdEventsEventIdRouteRoute,
  } as any)
const CompanyGroupIdEventsEventIdUsersRoute =
  CompanyGroupIdEventsEventIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => CompanyGroupIdEventsEventIdRouteRoute,
  } as any)
const CompanyGroupIdProjectsProjectIdEventsRoute =
  CompanyGroupIdProjectsProjectIdEventsRouteImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => CompanyGroupIdProjectsProjectIdRouteRoute,
  } as any)
const PartnerPartnerIdEventsEventIdDetailsRoute =
  PartnerPartnerIdEventsEventIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => PartnerPartnerIdEventsEventIdRouteRoute,
  } as any)
const PartnerPartnerIdEventsEventIdLogsRoute =
  PartnerPartnerIdEventsEventIdLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => PartnerPartnerIdEventsEventIdRouteRoute,
  } as any)
const PartnerPartnerIdEventsEventIdSubcontractingRoute =
  PartnerPartnerIdEventsEventIdSubcontractingRouteImport.update({
    id: '/subcontracting',
    path: '/subcontracting',
    getParentRoute: () => PartnerPartnerIdEventsEventIdRouteRoute,
  } as any)
const PartnerPartnerIdEventsEventIdUsersRoute =
  PartnerPartnerIdEventsEventIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => PartnerPartnerIdEventsEventIdRouteRoute,
  } as any)
const PartnerPartnerIdUsersUserIdDocumentIdRoute =
  PartnerPartnerIdUsersUserIdDocumentIdRouteImport.update({
    id: '/users/$userId/$documentId',
    path: '/users/$userId/$documentId',
    getParentRoute: () => PartnerPartnerIdRouteRoute,
  } as any)
const PersonalEventsEventIdApprovalsIndexRoute =
  PersonalEventsEventIdApprovalsIndexRouteImport.update({
    id: '/approvals/',
    path: '/approvals/',
    getParentRoute: () => PersonalEventsEventIdRouteRoute,
  } as any)
const PersonalEventsEventIdApprovalsTaskIdRoute =
  PersonalEventsEventIdApprovalsTaskIdRouteImport.update({
    id: '/approvals/$taskId',
    path: '/approvals/$taskId',
    getParentRoute: () => PersonalEventsEventIdRouteRoute,
  } as any)
const PersonalEventsEventIdDocumentsIndexRoute =
  PersonalEventsEventIdDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => PersonalEventsEventIdRouteRoute,
  } as any)
const PersonalEventsEventIdDocumentsDocumentIdRoute =
  PersonalEventsEventIdDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => PersonalEventsEventIdRouteRoute,
  } as any)
const PersonalEventsEventIdTasksIndexRoute =
  PersonalEventsEventIdTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => PersonalEventsEventIdRouteRoute,
  } as any)
const PersonalEventsEventIdTasksTaskIdRoute =
  PersonalEventsEventIdTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => PersonalEventsEventIdRouteRoute,
  } as any)
const PersonalGroupsGroupIdDocumentsIndexRoute =
  PersonalGroupsGroupIdDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => PersonalGroupsGroupIdRouteRoute,
  } as any)
const PersonalGroupsGroupIdDocumentsDocumentIdRoute =
  PersonalGroupsGroupIdDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => PersonalGroupsGroupIdRouteRoute,
  } as any)
const PersonalGroupsGroupIdTasksIndexRoute =
  PersonalGroupsGroupIdTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => PersonalGroupsGroupIdRouteRoute,
  } as any)
const PersonalGroupsGroupIdTasksTaskIdRoute =
  PersonalGroupsGroupIdTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => PersonalGroupsGroupIdRouteRoute,
  } as any)
const CompanyGroupIdEventsEventIdDocumentsIndexRoute =
  CompanyGroupIdEventsEventIdDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => CompanyGroupIdEventsEventIdRouteRoute,
  } as any)
const CompanyGroupIdEventsEventIdDocumentsDocumentIdRoute =
  CompanyGroupIdEventsEventIdDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => CompanyGroupIdEventsEventIdRouteRoute,
  } as any)
const CompanyGroupIdEventsEventIdTasksIndexRoute =
  CompanyGroupIdEventsEventIdTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => CompanyGroupIdEventsEventIdRouteRoute,
  } as any)
const CompanyGroupIdEventsEventIdTasksTaskIdRoute =
  CompanyGroupIdEventsEventIdTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => CompanyGroupIdEventsEventIdRouteRoute,
  } as any)
const PartnerPartnerIdEventsEventIdApprovalsIndexRoute =
  PartnerPartnerIdEventsEventIdApprovalsIndexRouteImport.update({
    id: '/approvals/',
    path: '/approvals/',
    getParentRoute: () => PartnerPartnerIdEventsEventIdRouteRoute,
  } as any)
const PartnerPartnerIdEventsEventIdApprovalsTaskIdRoute =
  PartnerPartnerIdEventsEventIdApprovalsTaskIdRouteImport.update({
    id: '/approvals/$taskId',
    path: '/approvals/$taskId',
    getParentRoute: () => PartnerPartnerIdEventsEventIdRouteRoute,
  } as any)
const PartnerPartnerIdEventsEventIdDocumentsIndexRoute =
  PartnerPartnerIdEventsEventIdDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => PartnerPartnerIdEventsEventIdRouteRoute,
  } as any)
const PartnerPartnerIdEventsEventIdDocumentsDocumentIdRoute =
  PartnerPartnerIdEventsEventIdDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => PartnerPartnerIdEventsEventIdRouteRoute,
  } as any)
const PartnerPartnerIdEventsEventIdTasksIndexRoute =
  PartnerPartnerIdEventsEventIdTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => PartnerPartnerIdEventsEventIdRouteRoute,
  } as any)
const PartnerPartnerIdEventsEventIdTasksTaskIdRoute =
  PartnerPartnerIdEventsEventIdTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => PartnerPartnerIdEventsEventIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/access': typeof AccessRouteRouteWithChildren
  '/company': typeof CompanyRouteRouteWithChildren
  '/partner': typeof PartnerRouteRouteWithChildren
  '/personal': typeof PersonalRouteRouteWithChildren
  '/supervisor': typeof SupervisorRouteRouteWithChildren
  '/403': typeof R403Route
  '/authentication': typeof AuthenticationRouteWithChildren
  '/profile': typeof ProfileRoute
  '/welcome': typeof WelcomeRoute
  '/$siteId': typeof AdminSiteIdRouteRouteWithChildren
  '/company/$groupId': typeof CompanyGroupIdRouteRouteWithChildren
  '/partner/$partnerId': typeof PartnerPartnerIdRouteRouteWithChildren
  '/401': typeof Admin401Route
  '/404': typeof Admin404Route
  '/error': typeof AdminErrorRoute
  '/overview': typeof AdminOverviewRoute
  '/access/401': typeof Access401Route
  '/access/authentication': typeof AccessAuthenticationRoute
  '/access/error': typeof AccessErrorRoute
  '/access/overview': typeof AccessOverviewRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/authentication/forgot-password': typeof AuthenticationForgotPasswordRoute
  '/authentication/login': typeof AuthenticationLoginRoute
  '/authentication/logout': typeof AuthenticationLogoutRoute
  '/authentication/reset-password': typeof AuthenticationResetPasswordRoute
  '/personal/overview': typeof PersonalOverviewRoute
  '/personal/tasks': typeof PersonalTasksRoute
  '/supervisor/logs': typeof SupervisorLogsRoute
  '/supervisor/users': typeof SupervisorUsersRoute
  '/access/': typeof AccessIndexRoute
  '/company/': typeof CompanyIndexRoute
  '/personal/': typeof PersonalIndexRoute
  '/supervisor/': typeof SupervisorIndexRoute
  '/$siteId/overview': typeof AdminSiteIdOverviewRouteRouteWithChildren
  '/events/$eventId': typeof AdminEventsEventIdRouteRouteWithChildren
  '/groups/$groupId': typeof AdminGroupsGroupIdRouteRouteWithChildren
  '/projects/$projectId': typeof AdminProjectsProjectIdRouteRouteWithChildren
  '/users/$userId': typeof AdminUsersUserIdRouteRouteWithChildren
  '/personal/events/$eventId': typeof PersonalEventsEventIdRouteRouteWithChildren
  '/personal/groups/$groupId': typeof PersonalGroupsGroupIdRouteRouteWithChildren
  '/personal/projects/$projectId': typeof PersonalProjectsProjectIdRouteRouteWithChildren
  '/config/zones': typeof AdminConfigZonesRoute
  '/reports/access-logs': typeof AdminReportsAccessLogsRoute
  '/reports/documents': typeof AdminReportsDocumentsRoute
  '/reports/occupancy': typeof AdminReportsOccupancyRoute
  '/reports/site-status': typeof AdminReportsSiteStatusRoute
  '/reports/time-on-site': typeof AdminReportsTimeOnSiteRoute
  '/system/agentic-parsing': typeof AdminSystemAgenticParsingRoute
  '/system/assets': typeof AdminSystemAssetsRoute
  '/system/datasources': typeof AdminSystemDatasourcesRoute
  '/system/document-types': typeof AdminSystemDocumentTypesRoute
  '/system/import': typeof AdminSystemImportRoute
  '/system/integrations': typeof AdminSystemIntegrationsRoute
  '/system/overview': typeof AdminSystemOverviewRoute
  '/system/settings': typeof AdminSystemSettingsRoute
  '/access/tasks/$taskId': typeof AccessTasksTaskIdRoute
  '/app/registration/fixed': typeof AppRegistrationFixedRoute
  '/app/tasks/$taskId': typeof AppTasksTaskIdRoute
  '/company/$groupId/information': typeof CompanyGroupIdInformationRoute
  '/company/blocked/$groupId': typeof CompanyBlockedGroupIdRoute
  '/company/verify/$groupId': typeof CompanyVerifyGroupIdRoute
  '/partner/$partnerId/information': typeof PartnerPartnerIdInformationRoute
  '/events/': typeof AdminEventsIndexRoute
  '/groups/': typeof AdminGroupsIndexRoute
  '/logs/': typeof AdminLogsIndexRoute
  '/projects/': typeof AdminProjectsIndexRoute
  '/reports/': typeof AdminReportsIndexRoute
  '/users/': typeof AdminUsersIndexRoute
  '/app/registration/': typeof AppRegistrationIndexRoute
  '/personal/events/': typeof PersonalEventsIndexRoute
  '/personal/groups/': typeof PersonalGroupsIndexRoute
  '/personal/projects/': typeof PersonalProjectsIndexRoute
  '/company/$groupId/events/$eventId': typeof CompanyGroupIdEventsEventIdRouteRouteWithChildren
  '/company/$groupId/projects/$projectId': typeof CompanyGroupIdProjectsProjectIdRouteRouteWithChildren
  '/partner/$partnerId/events/$eventId': typeof PartnerPartnerIdEventsEventIdRouteRouteWithChildren
  '/$siteId/overview/approvals': typeof AdminSiteIdOverviewApprovalsRoute
  '/$siteId/overview/attendance': typeof AdminSiteIdOverviewAttendanceRoute
  '/$siteId/overview/to-review': typeof AdminSiteIdOverviewToReviewRoute
  '/config/devices/$deviceId': typeof AdminConfigDevicesDeviceIdRoute
  '/config/devices/topology': typeof AdminConfigDevicesTopologyRoute
  '/config/roles/$roleId': typeof AdminConfigRolesRoleIdRoute
  '/config/roles/access': typeof AdminConfigRolesAccessRoute
  '/events/$eventId/details': typeof AdminEventsEventIdDetailsRoute
  '/events/$eventId/logs': typeof AdminEventsEventIdLogsRoute
  '/events/$eventId/subcontracting': typeof AdminEventsEventIdSubcontractingRoute
  '/events/$eventId/users': typeof AdminEventsEventIdUsersRoute
  '/groups/$groupId/contact-details': typeof AdminGroupsGroupIdContactDetailsRoute
  '/groups/$groupId/details': typeof AdminGroupsGroupIdDetailsRoute
  '/groups/$groupId/events': typeof AdminGroupsGroupIdEventsRoute
  '/groups/$groupId/logs': typeof AdminGroupsGroupIdLogsRoute
  '/groups/$groupId/users': typeof AdminGroupsGroupIdUsersRoute
  '/projects/$projectId/events': typeof AdminProjectsProjectIdEventsRoute
  '/projects/$projectId/logs': typeof AdminProjectsProjectIdLogsRoute
  '/system/forms/$id': typeof AdminSystemFormsIdRoute
  '/system/sites/$id': typeof AdminSystemSitesIdRoute
  '/system/templates/$id': typeof AdminSystemTemplatesIdRoute
  '/users/$userId/access': typeof AdminUsersUserIdAccessRoute
  '/users/$userId/badges': typeof AdminUsersUserIdBadgesRoute
  '/users/$userId/details': typeof AdminUsersUserIdDetailsRoute
  '/users/$userId/events': typeof AdminUsersUserIdEventsRoute
  '/users/$userId/logs': typeof AdminUsersUserIdLogsRoute
  '/users/$userId/roles': typeof AdminUsersUserIdRolesRoute
  '/company/$groupId/approvals/$taskId': typeof CompanyGroupIdApprovalsTaskIdRoute
  '/company/$groupId/documents/$documentId': typeof CompanyGroupIdDocumentsDocumentIdRoute
  '/company/$groupId/tasks/$taskId': typeof CompanyGroupIdTasksTaskIdRoute
  '/partner/$partnerId/approvals/$approvalId': typeof PartnerPartnerIdApprovalsApprovalIdRoute
  '/partner/$partnerId/documents/$documentId': typeof PartnerPartnerIdDocumentsDocumentIdRoute
  '/partner/$partnerId/projects/$projectId': typeof PartnerPartnerIdProjectsProjectIdRoute
  '/partner/$partnerId/tasks/$taskId': typeof PartnerPartnerIdTasksTaskIdRoute
  '/personal/events/$eventId/details': typeof PersonalEventsEventIdDetailsRoute
  '/personal/events/$eventId/logs': typeof PersonalEventsEventIdLogsRoute
  '/personal/events/$eventId/subcontracting': typeof PersonalEventsEventIdSubcontractingRoute
  '/personal/events/$eventId/users': typeof PersonalEventsEventIdUsersRoute
  '/personal/groups/$groupId/details': typeof PersonalGroupsGroupIdDetailsRoute
  '/personal/groups/$groupId/events': typeof PersonalGroupsGroupIdEventsRoute
  '/personal/groups/$groupId/logs': typeof PersonalGroupsGroupIdLogsRoute
  '/personal/groups/$groupId/users': typeof PersonalGroupsGroupIdUsersRoute
  '/personal/projects/$projectId/events': typeof PersonalProjectsProjectIdEventsRoute
  '/personal/projects/$projectId/logs': typeof PersonalProjectsProjectIdLogsRoute
  '/$siteId/overview/': typeof AdminSiteIdOverviewIndexRoute
  '/config/blocklist/': typeof AdminConfigBlocklistIndexRoute
  '/config/devices/': typeof AdminConfigDevicesIndexRoute
  '/config/general/': typeof AdminConfigGeneralIndexRoute
  '/config/integrations/': typeof AdminConfigIntegrationsIndexRoute
  '/config/roles/': typeof AdminConfigRolesIndexRoute
  '/config/tasks/': typeof AdminConfigTasksIndexRoute
  '/events/$eventId/': typeof AdminEventsEventIdIndexRoute
  '/groups/$groupId/': typeof AdminGroupsGroupIdIndexRoute
  '/projects/$projectId/': typeof AdminProjectsProjectIdIndexRoute
  '/system/forms/': typeof AdminSystemFormsIndexRoute
  '/system/sites/': typeof AdminSystemSitesIndexRoute
  '/system/templates/': typeof AdminSystemTemplatesIndexRoute
  '/users/$userId/': typeof AdminUsersUserIdIndexRoute
  '/company/$groupId/approvals/': typeof CompanyGroupIdApprovalsIndexRoute
  '/company/$groupId/documents/': typeof CompanyGroupIdDocumentsIndexRoute
  '/company/$groupId/events/': typeof CompanyGroupIdEventsIndexRoute
  '/company/$groupId/projects/': typeof CompanyGroupIdProjectsIndexRoute
  '/company/$groupId/tasks/': typeof CompanyGroupIdTasksIndexRoute
  '/company/$groupId/users/': typeof CompanyGroupIdUsersIndexRoute
  '/partner/$partnerId/approvals/': typeof PartnerPartnerIdApprovalsIndexRoute
  '/partner/$partnerId/documents/': typeof PartnerPartnerIdDocumentsIndexRoute
  '/partner/$partnerId/events/': typeof PartnerPartnerIdEventsIndexRoute
  '/partner/$partnerId/projects/': typeof PartnerPartnerIdProjectsIndexRoute
  '/partner/$partnerId/tasks/': typeof PartnerPartnerIdTasksIndexRoute
  '/partner/$partnerId/users/': typeof PartnerPartnerIdUsersIndexRoute
  '/personal/events/$eventId/': typeof PersonalEventsEventIdIndexRoute
  '/personal/groups/$groupId/': typeof PersonalGroupsGroupIdIndexRoute
  '/personal/projects/$projectId/': typeof PersonalProjectsProjectIdIndexRoute
  '/config/forms/$slugOrId/build': typeof AdminConfigFormsSlugOrIdBuildRoute
  '/config/tasks/$slug/translate': typeof AdminConfigTasksSlugTranslateRoute
  '/config/types/event/$typeId': typeof AdminConfigTypesEventTypeIdRoute
  '/config/types/group/$typeId': typeof AdminConfigTypesGroupTypeIdRoute
  '/events/$eventId/approvals/$taskId': typeof AdminEventsEventIdApprovalsTaskIdRoute
  '/events/$eventId/documents/$documentId': typeof AdminEventsEventIdDocumentsDocumentIdRoute
  '/events/$eventId/tasks/$taskId': typeof AdminEventsEventIdTasksTaskIdRoute
  '/groups/$groupId/approvals/$approvalId': typeof AdminGroupsGroupIdApprovalsApprovalIdRoute
  '/groups/$groupId/documents/$documentId': typeof AdminGroupsGroupIdDocumentsDocumentIdRoute
  '/groups/$groupId/tasks/$taskId': typeof AdminGroupsGroupIdTasksTaskIdRoute
  '/users/$userId/approvals/$approvalId': typeof AdminUsersUserIdApprovalsApprovalIdRoute
  '/users/$userId/documents/$documentId': typeof AdminUsersUserIdDocumentsDocumentIdRoute
  '/users/$userId/tasks/$taskId': typeof AdminUsersUserIdTasksTaskIdRoute
  '/company/$groupId/events/$eventId/details': typeof CompanyGroupIdEventsEventIdDetailsRoute
  '/company/$groupId/events/$eventId/groups': typeof CompanyGroupIdEventsEventIdGroupsRoute
  '/company/$groupId/events/$eventId/logs': typeof CompanyGroupIdEventsEventIdLogsRoute
  '/company/$groupId/events/$eventId/subcontracting': typeof CompanyGroupIdEventsEventIdSubcontractingRoute
  '/company/$groupId/events/$eventId/users': typeof CompanyGroupIdEventsEventIdUsersRoute
  '/company/$groupId/projects/$projectId/events': typeof CompanyGroupIdProjectsProjectIdEventsRoute
  '/partner/$partnerId/events/$eventId/details': typeof PartnerPartnerIdEventsEventIdDetailsRoute
  '/partner/$partnerId/events/$eventId/logs': typeof PartnerPartnerIdEventsEventIdLogsRoute
  '/partner/$partnerId/events/$eventId/subcontracting': typeof PartnerPartnerIdEventsEventIdSubcontractingRoute
  '/partner/$partnerId/events/$eventId/users': typeof PartnerPartnerIdEventsEventIdUsersRoute
  '/partner/$partnerId/users/$userId/$documentId': typeof PartnerPartnerIdUsersUserIdDocumentIdRoute
  '/personal/events/$eventId/approvals/$taskId': typeof PersonalEventsEventIdApprovalsTaskIdRoute
  '/personal/events/$eventId/documents/$documentId': typeof PersonalEventsEventIdDocumentsDocumentIdRoute
  '/personal/events/$eventId/tasks/$taskId': typeof PersonalEventsEventIdTasksTaskIdRoute
  '/personal/groups/$groupId/documents/$documentId': typeof PersonalGroupsGroupIdDocumentsDocumentIdRoute
  '/personal/groups/$groupId/tasks/$taskId': typeof PersonalGroupsGroupIdTasksTaskIdRoute
  '/config/tasks/$slug/': typeof AdminConfigTasksSlugIndexRoute
  '/config/types/event/': typeof AdminConfigTypesEventIndexRoute
  '/config/types/group/': typeof AdminConfigTypesGroupIndexRoute
  '/events/$eventId/approvals/': typeof AdminEventsEventIdApprovalsIndexRoute
  '/events/$eventId/documents/': typeof AdminEventsEventIdDocumentsIndexRoute
  '/events/$eventId/tasks/': typeof AdminEventsEventIdTasksIndexRoute
  '/groups/$groupId/approvals/': typeof AdminGroupsGroupIdApprovalsIndexRoute
  '/groups/$groupId/documents/': typeof AdminGroupsGroupIdDocumentsIndexRoute
  '/groups/$groupId/tasks/': typeof AdminGroupsGroupIdTasksIndexRoute
  '/users/$userId/approvals/': typeof AdminUsersUserIdApprovalsIndexRoute
  '/users/$userId/documents/': typeof AdminUsersUserIdDocumentsIndexRoute
  '/users/$userId/tasks/': typeof AdminUsersUserIdTasksIndexRoute
  '/personal/events/$eventId/approvals/': typeof PersonalEventsEventIdApprovalsIndexRoute
  '/personal/events/$eventId/documents/': typeof PersonalEventsEventIdDocumentsIndexRoute
  '/personal/events/$eventId/tasks/': typeof PersonalEventsEventIdTasksIndexRoute
  '/personal/groups/$groupId/documents/': typeof PersonalGroupsGroupIdDocumentsIndexRoute
  '/personal/groups/$groupId/tasks/': typeof PersonalGroupsGroupIdTasksIndexRoute
  '/company/$groupId/events/$eventId/documents/$documentId': typeof CompanyGroupIdEventsEventIdDocumentsDocumentIdRoute
  '/company/$groupId/events/$eventId/tasks/$taskId': typeof CompanyGroupIdEventsEventIdTasksTaskIdRoute
  '/partner/$partnerId/events/$eventId/approvals/$taskId': typeof PartnerPartnerIdEventsEventIdApprovalsTaskIdRoute
  '/partner/$partnerId/events/$eventId/documents/$documentId': typeof PartnerPartnerIdEventsEventIdDocumentsDocumentIdRoute
  '/partner/$partnerId/events/$eventId/tasks/$taskId': typeof PartnerPartnerIdEventsEventIdTasksTaskIdRoute
  '/company/$groupId/events/$eventId/documents/': typeof CompanyGroupIdEventsEventIdDocumentsIndexRoute
  '/company/$groupId/events/$eventId/tasks/': typeof CompanyGroupIdEventsEventIdTasksIndexRoute
  '/partner/$partnerId/events/$eventId/approvals/': typeof PartnerPartnerIdEventsEventIdApprovalsIndexRoute
  '/partner/$partnerId/events/$eventId/documents/': typeof PartnerPartnerIdEventsEventIdDocumentsIndexRoute
  '/partner/$partnerId/events/$eventId/tasks/': typeof PartnerPartnerIdEventsEventIdTasksIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/partner': typeof PartnerRouteRouteWithChildren
  '/403': typeof R403Route
  '/authentication': typeof AuthenticationRouteWithChildren
  '/profile': typeof ProfileRoute
  '/welcome': typeof WelcomeRoute
  '/$siteId': typeof AdminSiteIdRouteRouteWithChildren
  '/company/$groupId': typeof CompanyGroupIdRouteRouteWithChildren
  '/partner/$partnerId': typeof PartnerPartnerIdRouteRouteWithChildren
  '/401': typeof Admin401Route
  '/404': typeof Admin404Route
  '/error': typeof AdminErrorRoute
  '/overview': typeof AdminOverviewRoute
  '/access/401': typeof Access401Route
  '/access/authentication': typeof AccessAuthenticationRoute
  '/access/error': typeof AccessErrorRoute
  '/access/overview': typeof AccessOverviewRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/authentication/forgot-password': typeof AuthenticationForgotPasswordRoute
  '/authentication/login': typeof AuthenticationLoginRoute
  '/authentication/logout': typeof AuthenticationLogoutRoute
  '/authentication/reset-password': typeof AuthenticationResetPasswordRoute
  '/personal/overview': typeof PersonalOverviewRoute
  '/personal/tasks': typeof PersonalTasksRoute
  '/supervisor/logs': typeof SupervisorLogsRoute
  '/supervisor/users': typeof SupervisorUsersRoute
  '/access': typeof AccessIndexRoute
  '/company': typeof CompanyIndexRoute
  '/personal': typeof PersonalIndexRoute
  '/supervisor': typeof SupervisorIndexRoute
  '/config/zones': typeof AdminConfigZonesRoute
  '/reports/access-logs': typeof AdminReportsAccessLogsRoute
  '/reports/documents': typeof AdminReportsDocumentsRoute
  '/reports/occupancy': typeof AdminReportsOccupancyRoute
  '/reports/site-status': typeof AdminReportsSiteStatusRoute
  '/reports/time-on-site': typeof AdminReportsTimeOnSiteRoute
  '/system/agentic-parsing': typeof AdminSystemAgenticParsingRoute
  '/system/assets': typeof AdminSystemAssetsRoute
  '/system/datasources': typeof AdminSystemDatasourcesRoute
  '/system/document-types': typeof AdminSystemDocumentTypesRoute
  '/system/import': typeof AdminSystemImportRoute
  '/system/integrations': typeof AdminSystemIntegrationsRoute
  '/system/overview': typeof AdminSystemOverviewRoute
  '/system/settings': typeof AdminSystemSettingsRoute
  '/access/tasks/$taskId': typeof AccessTasksTaskIdRoute
  '/app/registration/fixed': typeof AppRegistrationFixedRoute
  '/app/tasks/$taskId': typeof AppTasksTaskIdRoute
  '/company/$groupId/information': typeof CompanyGroupIdInformationRoute
  '/company/blocked/$groupId': typeof CompanyBlockedGroupIdRoute
  '/company/verify/$groupId': typeof CompanyVerifyGroupIdRoute
  '/partner/$partnerId/information': typeof PartnerPartnerIdInformationRoute
  '/events': typeof AdminEventsIndexRoute
  '/groups': typeof AdminGroupsIndexRoute
  '/logs': typeof AdminLogsIndexRoute
  '/projects': typeof AdminProjectsIndexRoute
  '/reports': typeof AdminReportsIndexRoute
  '/users': typeof AdminUsersIndexRoute
  '/app/registration': typeof AppRegistrationIndexRoute
  '/personal/events': typeof PersonalEventsIndexRoute
  '/personal/groups': typeof PersonalGroupsIndexRoute
  '/personal/projects': typeof PersonalProjectsIndexRoute
  '/company/$groupId/events/$eventId': typeof CompanyGroupIdEventsEventIdRouteRouteWithChildren
  '/company/$groupId/projects/$projectId': typeof CompanyGroupIdProjectsProjectIdRouteRouteWithChildren
  '/partner/$partnerId/events/$eventId': typeof PartnerPartnerIdEventsEventIdRouteRouteWithChildren
  '/$siteId/overview/approvals': typeof AdminSiteIdOverviewApprovalsRoute
  '/$siteId/overview/attendance': typeof AdminSiteIdOverviewAttendanceRoute
  '/$siteId/overview/to-review': typeof AdminSiteIdOverviewToReviewRoute
  '/config/devices/$deviceId': typeof AdminConfigDevicesDeviceIdRoute
  '/config/devices/topology': typeof AdminConfigDevicesTopologyRoute
  '/config/roles/$roleId': typeof AdminConfigRolesRoleIdRoute
  '/config/roles/access': typeof AdminConfigRolesAccessRoute
  '/events/$eventId/details': typeof AdminEventsEventIdDetailsRoute
  '/events/$eventId/logs': typeof AdminEventsEventIdLogsRoute
  '/events/$eventId/subcontracting': typeof AdminEventsEventIdSubcontractingRoute
  '/events/$eventId/users': typeof AdminEventsEventIdUsersRoute
  '/groups/$groupId/contact-details': typeof AdminGroupsGroupIdContactDetailsRoute
  '/groups/$groupId/details': typeof AdminGroupsGroupIdDetailsRoute
  '/groups/$groupId/events': typeof AdminGroupsGroupIdEventsRoute
  '/groups/$groupId/logs': typeof AdminGroupsGroupIdLogsRoute
  '/groups/$groupId/users': typeof AdminGroupsGroupIdUsersRoute
  '/projects/$projectId/events': typeof AdminProjectsProjectIdEventsRoute
  '/projects/$projectId/logs': typeof AdminProjectsProjectIdLogsRoute
  '/system/forms/$id': typeof AdminSystemFormsIdRoute
  '/system/sites/$id': typeof AdminSystemSitesIdRoute
  '/system/templates/$id': typeof AdminSystemTemplatesIdRoute
  '/users/$userId/access': typeof AdminUsersUserIdAccessRoute
  '/users/$userId/badges': typeof AdminUsersUserIdBadgesRoute
  '/users/$userId/details': typeof AdminUsersUserIdDetailsRoute
  '/users/$userId/events': typeof AdminUsersUserIdEventsRoute
  '/users/$userId/logs': typeof AdminUsersUserIdLogsRoute
  '/users/$userId/roles': typeof AdminUsersUserIdRolesRoute
  '/company/$groupId/approvals/$taskId': typeof CompanyGroupIdApprovalsTaskIdRoute
  '/company/$groupId/documents/$documentId': typeof CompanyGroupIdDocumentsDocumentIdRoute
  '/company/$groupId/tasks/$taskId': typeof CompanyGroupIdTasksTaskIdRoute
  '/partner/$partnerId/approvals/$approvalId': typeof PartnerPartnerIdApprovalsApprovalIdRoute
  '/partner/$partnerId/documents/$documentId': typeof PartnerPartnerIdDocumentsDocumentIdRoute
  '/partner/$partnerId/projects/$projectId': typeof PartnerPartnerIdProjectsProjectIdRoute
  '/partner/$partnerId/tasks/$taskId': typeof PartnerPartnerIdTasksTaskIdRoute
  '/personal/events/$eventId/details': typeof PersonalEventsEventIdDetailsRoute
  '/personal/events/$eventId/logs': typeof PersonalEventsEventIdLogsRoute
  '/personal/events/$eventId/subcontracting': typeof PersonalEventsEventIdSubcontractingRoute
  '/personal/events/$eventId/users': typeof PersonalEventsEventIdUsersRoute
  '/personal/groups/$groupId/details': typeof PersonalGroupsGroupIdDetailsRoute
  '/personal/groups/$groupId/events': typeof PersonalGroupsGroupIdEventsRoute
  '/personal/groups/$groupId/logs': typeof PersonalGroupsGroupIdLogsRoute
  '/personal/groups/$groupId/users': typeof PersonalGroupsGroupIdUsersRoute
  '/personal/projects/$projectId/events': typeof PersonalProjectsProjectIdEventsRoute
  '/personal/projects/$projectId/logs': typeof PersonalProjectsProjectIdLogsRoute
  '/$siteId/overview': typeof AdminSiteIdOverviewIndexRoute
  '/config/blocklist': typeof AdminConfigBlocklistIndexRoute
  '/config/devices': typeof AdminConfigDevicesIndexRoute
  '/config/general': typeof AdminConfigGeneralIndexRoute
  '/config/integrations': typeof AdminConfigIntegrationsIndexRoute
  '/config/roles': typeof AdminConfigRolesIndexRoute
  '/config/tasks': typeof AdminConfigTasksIndexRoute
  '/events/$eventId': typeof AdminEventsEventIdIndexRoute
  '/groups/$groupId': typeof AdminGroupsGroupIdIndexRoute
  '/projects/$projectId': typeof AdminProjectsProjectIdIndexRoute
  '/system/forms': typeof AdminSystemFormsIndexRoute
  '/system/sites': typeof AdminSystemSitesIndexRoute
  '/system/templates': typeof AdminSystemTemplatesIndexRoute
  '/users/$userId': typeof AdminUsersUserIdIndexRoute
  '/company/$groupId/approvals': typeof CompanyGroupIdApprovalsIndexRoute
  '/company/$groupId/documents': typeof CompanyGroupIdDocumentsIndexRoute
  '/company/$groupId/events': typeof CompanyGroupIdEventsIndexRoute
  '/company/$groupId/projects': typeof CompanyGroupIdProjectsIndexRoute
  '/company/$groupId/tasks': typeof CompanyGroupIdTasksIndexRoute
  '/company/$groupId/users': typeof CompanyGroupIdUsersIndexRoute
  '/partner/$partnerId/approvals': typeof PartnerPartnerIdApprovalsIndexRoute
  '/partner/$partnerId/documents': typeof PartnerPartnerIdDocumentsIndexRoute
  '/partner/$partnerId/events': typeof PartnerPartnerIdEventsIndexRoute
  '/partner/$partnerId/projects': typeof PartnerPartnerIdProjectsIndexRoute
  '/partner/$partnerId/tasks': typeof PartnerPartnerIdTasksIndexRoute
  '/partner/$partnerId/users': typeof PartnerPartnerIdUsersIndexRoute
  '/personal/events/$eventId': typeof PersonalEventsEventIdIndexRoute
  '/personal/groups/$groupId': typeof PersonalGroupsGroupIdIndexRoute
  '/personal/projects/$projectId': typeof PersonalProjectsProjectIdIndexRoute
  '/config/forms/$slugOrId/build': typeof AdminConfigFormsSlugOrIdBuildRoute
  '/config/tasks/$slug/translate': typeof AdminConfigTasksSlugTranslateRoute
  '/config/types/event/$typeId': typeof AdminConfigTypesEventTypeIdRoute
  '/config/types/group/$typeId': typeof AdminConfigTypesGroupTypeIdRoute
  '/events/$eventId/approvals/$taskId': typeof AdminEventsEventIdApprovalsTaskIdRoute
  '/events/$eventId/documents/$documentId': typeof AdminEventsEventIdDocumentsDocumentIdRoute
  '/events/$eventId/tasks/$taskId': typeof AdminEventsEventIdTasksTaskIdRoute
  '/groups/$groupId/approvals/$approvalId': typeof AdminGroupsGroupIdApprovalsApprovalIdRoute
  '/groups/$groupId/documents/$documentId': typeof AdminGroupsGroupIdDocumentsDocumentIdRoute
  '/groups/$groupId/tasks/$taskId': typeof AdminGroupsGroupIdTasksTaskIdRoute
  '/users/$userId/approvals/$approvalId': typeof AdminUsersUserIdApprovalsApprovalIdRoute
  '/users/$userId/documents/$documentId': typeof AdminUsersUserIdDocumentsDocumentIdRoute
  '/users/$userId/tasks/$taskId': typeof AdminUsersUserIdTasksTaskIdRoute
  '/company/$groupId/events/$eventId/details': typeof CompanyGroupIdEventsEventIdDetailsRoute
  '/company/$groupId/events/$eventId/groups': typeof CompanyGroupIdEventsEventIdGroupsRoute
  '/company/$groupId/events/$eventId/logs': typeof CompanyGroupIdEventsEventIdLogsRoute
  '/company/$groupId/events/$eventId/subcontracting': typeof CompanyGroupIdEventsEventIdSubcontractingRoute
  '/company/$groupId/events/$eventId/users': typeof CompanyGroupIdEventsEventIdUsersRoute
  '/company/$groupId/projects/$projectId/events': typeof CompanyGroupIdProjectsProjectIdEventsRoute
  '/partner/$partnerId/events/$eventId/details': typeof PartnerPartnerIdEventsEventIdDetailsRoute
  '/partner/$partnerId/events/$eventId/logs': typeof PartnerPartnerIdEventsEventIdLogsRoute
  '/partner/$partnerId/events/$eventId/subcontracting': typeof PartnerPartnerIdEventsEventIdSubcontractingRoute
  '/partner/$partnerId/events/$eventId/users': typeof PartnerPartnerIdEventsEventIdUsersRoute
  '/partner/$partnerId/users/$userId/$documentId': typeof PartnerPartnerIdUsersUserIdDocumentIdRoute
  '/personal/events/$eventId/approvals/$taskId': typeof PersonalEventsEventIdApprovalsTaskIdRoute
  '/personal/events/$eventId/documents/$documentId': typeof PersonalEventsEventIdDocumentsDocumentIdRoute
  '/personal/events/$eventId/tasks/$taskId': typeof PersonalEventsEventIdTasksTaskIdRoute
  '/personal/groups/$groupId/documents/$documentId': typeof PersonalGroupsGroupIdDocumentsDocumentIdRoute
  '/personal/groups/$groupId/tasks/$taskId': typeof PersonalGroupsGroupIdTasksTaskIdRoute
  '/config/tasks/$slug': typeof AdminConfigTasksSlugIndexRoute
  '/config/types/event': typeof AdminConfigTypesEventIndexRoute
  '/config/types/group': typeof AdminConfigTypesGroupIndexRoute
  '/events/$eventId/approvals': typeof AdminEventsEventIdApprovalsIndexRoute
  '/events/$eventId/documents': typeof AdminEventsEventIdDocumentsIndexRoute
  '/events/$eventId/tasks': typeof AdminEventsEventIdTasksIndexRoute
  '/groups/$groupId/approvals': typeof AdminGroupsGroupIdApprovalsIndexRoute
  '/groups/$groupId/documents': typeof AdminGroupsGroupIdDocumentsIndexRoute
  '/groups/$groupId/tasks': typeof AdminGroupsGroupIdTasksIndexRoute
  '/users/$userId/approvals': typeof AdminUsersUserIdApprovalsIndexRoute
  '/users/$userId/documents': typeof AdminUsersUserIdDocumentsIndexRoute
  '/users/$userId/tasks': typeof AdminUsersUserIdTasksIndexRoute
  '/personal/events/$eventId/approvals': typeof PersonalEventsEventIdApprovalsIndexRoute
  '/personal/events/$eventId/documents': typeof PersonalEventsEventIdDocumentsIndexRoute
  '/personal/events/$eventId/tasks': typeof PersonalEventsEventIdTasksIndexRoute
  '/personal/groups/$groupId/documents': typeof PersonalGroupsGroupIdDocumentsIndexRoute
  '/personal/groups/$groupId/tasks': typeof PersonalGroupsGroupIdTasksIndexRoute
  '/company/$groupId/events/$eventId/documents/$documentId': typeof CompanyGroupIdEventsEventIdDocumentsDocumentIdRoute
  '/company/$groupId/events/$eventId/tasks/$taskId': typeof CompanyGroupIdEventsEventIdTasksTaskIdRoute
  '/partner/$partnerId/events/$eventId/approvals/$taskId': typeof PartnerPartnerIdEventsEventIdApprovalsTaskIdRoute
  '/partner/$partnerId/events/$eventId/documents/$documentId': typeof PartnerPartnerIdEventsEventIdDocumentsDocumentIdRoute
  '/partner/$partnerId/events/$eventId/tasks/$taskId': typeof PartnerPartnerIdEventsEventIdTasksTaskIdRoute
  '/company/$groupId/events/$eventId/documents': typeof CompanyGroupIdEventsEventIdDocumentsIndexRoute
  '/company/$groupId/events/$eventId/tasks': typeof CompanyGroupIdEventsEventIdTasksIndexRoute
  '/partner/$partnerId/events/$eventId/approvals': typeof PartnerPartnerIdEventsEventIdApprovalsIndexRoute
  '/partner/$partnerId/events/$eventId/documents': typeof PartnerPartnerIdEventsEventIdDocumentsIndexRoute
  '/partner/$partnerId/events/$eventId/tasks': typeof PartnerPartnerIdEventsEventIdTasksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/access_': typeof AccessRouteRouteWithChildren
  '/company_': typeof CompanyRouteRouteWithChildren
  '/partner_': typeof PartnerRouteRouteWithChildren
  '/personal_': typeof PersonalRouteRouteWithChildren
  '/supervisor_': typeof SupervisorRouteRouteWithChildren
  '/403': typeof R403Route
  '/_admin': typeof AdminRouteWithChildren
  '/authentication': typeof AuthenticationRouteWithChildren
  '/profile': typeof ProfileRoute
  '/welcome': typeof WelcomeRoute
  '/_admin/$siteId': typeof AdminSiteIdRouteRouteWithChildren
  '/company_/$groupId': typeof CompanyGroupIdRouteRouteWithChildren
  '/partner_/$partnerId': typeof PartnerPartnerIdRouteRouteWithChildren
  '/_admin/401': typeof Admin401Route
  '/_admin/404': typeof Admin404Route
  '/_admin/error': typeof AdminErrorRoute
  '/_admin/overview': typeof AdminOverviewRoute
  '/access_/401': typeof Access401Route
  '/access_/authentication': typeof AccessAuthenticationRoute
  '/access_/error': typeof AccessErrorRoute
  '/access_/overview': typeof AccessOverviewRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/authentication/forgot-password': typeof AuthenticationForgotPasswordRoute
  '/authentication/login': typeof AuthenticationLoginRoute
  '/authentication/logout': typeof AuthenticationLogoutRoute
  '/authentication/reset-password': typeof AuthenticationResetPasswordRoute
  '/personal_/overview': typeof PersonalOverviewRoute
  '/personal_/tasks': typeof PersonalTasksRoute
  '/supervisor_/logs': typeof SupervisorLogsRoute
  '/supervisor_/users': typeof SupervisorUsersRoute
  '/access_/': typeof AccessIndexRoute
  '/company_/': typeof CompanyIndexRoute
  '/personal_/': typeof PersonalIndexRoute
  '/supervisor_/': typeof SupervisorIndexRoute
  '/_admin/$siteId/overview': typeof AdminSiteIdOverviewRouteRouteWithChildren
  '/_admin/events/$eventId': typeof AdminEventsEventIdRouteRouteWithChildren
  '/_admin/groups/$groupId': typeof AdminGroupsGroupIdRouteRouteWithChildren
  '/_admin/projects/$projectId': typeof AdminProjectsProjectIdRouteRouteWithChildren
  '/_admin/users/$userId': typeof AdminUsersUserIdRouteRouteWithChildren
  '/personal_/events/$eventId': typeof PersonalEventsEventIdRouteRouteWithChildren
  '/personal_/groups/$groupId': typeof PersonalGroupsGroupIdRouteRouteWithChildren
  '/personal_/projects/$projectId': typeof PersonalProjectsProjectIdRouteRouteWithChildren
  '/_admin/config/zones': typeof AdminConfigZonesRoute
  '/_admin/reports/access-logs': typeof AdminReportsAccessLogsRoute
  '/_admin/reports/documents': typeof AdminReportsDocumentsRoute
  '/_admin/reports/occupancy': typeof AdminReportsOccupancyRoute
  '/_admin/reports/site-status': typeof AdminReportsSiteStatusRoute
  '/_admin/reports/time-on-site': typeof AdminReportsTimeOnSiteRoute
  '/_admin/system/agentic-parsing': typeof AdminSystemAgenticParsingRoute
  '/_admin/system/assets': typeof AdminSystemAssetsRoute
  '/_admin/system/datasources': typeof AdminSystemDatasourcesRoute
  '/_admin/system/document-types': typeof AdminSystemDocumentTypesRoute
  '/_admin/system/import': typeof AdminSystemImportRoute
  '/_admin/system/integrations': typeof AdminSystemIntegrationsRoute
  '/_admin/system/overview': typeof AdminSystemOverviewRoute
  '/_admin/system/settings': typeof AdminSystemSettingsRoute
  '/access_/tasks/$taskId': typeof AccessTasksTaskIdRoute
  '/app/registration/fixed': typeof AppRegistrationFixedRoute
  '/app/tasks/$taskId': typeof AppTasksTaskIdRoute
  '/company_/$groupId/information': typeof CompanyGroupIdInformationRoute
  '/company_/blocked/$groupId': typeof CompanyBlockedGroupIdRoute
  '/company_/verify/$groupId': typeof CompanyVerifyGroupIdRoute
  '/partner_/$partnerId/information': typeof PartnerPartnerIdInformationRoute
  '/_admin/events/': typeof AdminEventsIndexRoute
  '/_admin/groups/': typeof AdminGroupsIndexRoute
  '/_admin/logs/': typeof AdminLogsIndexRoute
  '/_admin/projects/': typeof AdminProjectsIndexRoute
  '/_admin/reports/': typeof AdminReportsIndexRoute
  '/_admin/users/': typeof AdminUsersIndexRoute
  '/app/registration/': typeof AppRegistrationIndexRoute
  '/personal_/events/': typeof PersonalEventsIndexRoute
  '/personal_/groups/': typeof PersonalGroupsIndexRoute
  '/personal_/projects/': typeof PersonalProjectsIndexRoute
  '/company_/$groupId/events/$eventId': typeof CompanyGroupIdEventsEventIdRouteRouteWithChildren
  '/company_/$groupId/projects/$projectId': typeof CompanyGroupIdProjectsProjectIdRouteRouteWithChildren
  '/partner_/$partnerId/events/$eventId': typeof PartnerPartnerIdEventsEventIdRouteRouteWithChildren
  '/_admin/$siteId/overview/approvals': typeof AdminSiteIdOverviewApprovalsRoute
  '/_admin/$siteId/overview/attendance': typeof AdminSiteIdOverviewAttendanceRoute
  '/_admin/$siteId/overview/to-review': typeof AdminSiteIdOverviewToReviewRoute
  '/_admin/config/devices/$deviceId': typeof AdminConfigDevicesDeviceIdRoute
  '/_admin/config/devices/topology': typeof AdminConfigDevicesTopologyRoute
  '/_admin/config/roles/$roleId': typeof AdminConfigRolesRoleIdRoute
  '/_admin/config/roles/access': typeof AdminConfigRolesAccessRoute
  '/_admin/events/$eventId/details': typeof AdminEventsEventIdDetailsRoute
  '/_admin/events/$eventId/logs': typeof AdminEventsEventIdLogsRoute
  '/_admin/events/$eventId/subcontracting': typeof AdminEventsEventIdSubcontractingRoute
  '/_admin/events/$eventId/users': typeof AdminEventsEventIdUsersRoute
  '/_admin/groups/$groupId/contact-details': typeof AdminGroupsGroupIdContactDetailsRoute
  '/_admin/groups/$groupId/details': typeof AdminGroupsGroupIdDetailsRoute
  '/_admin/groups/$groupId/events': typeof AdminGroupsGroupIdEventsRoute
  '/_admin/groups/$groupId/logs': typeof AdminGroupsGroupIdLogsRoute
  '/_admin/groups/$groupId/users': typeof AdminGroupsGroupIdUsersRoute
  '/_admin/projects/$projectId/events': typeof AdminProjectsProjectIdEventsRoute
  '/_admin/projects/$projectId/logs': typeof AdminProjectsProjectIdLogsRoute
  '/_admin/system/forms/$id': typeof AdminSystemFormsIdRoute
  '/_admin/system/sites/$id': typeof AdminSystemSitesIdRoute
  '/_admin/system/templates/$id': typeof AdminSystemTemplatesIdRoute
  '/_admin/users/$userId/access': typeof AdminUsersUserIdAccessRoute
  '/_admin/users/$userId/badges': typeof AdminUsersUserIdBadgesRoute
  '/_admin/users/$userId/details': typeof AdminUsersUserIdDetailsRoute
  '/_admin/users/$userId/events': typeof AdminUsersUserIdEventsRoute
  '/_admin/users/$userId/logs': typeof AdminUsersUserIdLogsRoute
  '/_admin/users/$userId/roles': typeof AdminUsersUserIdRolesRoute
  '/company_/$groupId/approvals/$taskId': typeof CompanyGroupIdApprovalsTaskIdRoute
  '/company_/$groupId/documents/$documentId': typeof CompanyGroupIdDocumentsDocumentIdRoute
  '/company_/$groupId/tasks/$taskId': typeof CompanyGroupIdTasksTaskIdRoute
  '/partner_/$partnerId/approvals/$approvalId': typeof PartnerPartnerIdApprovalsApprovalIdRoute
  '/partner_/$partnerId/documents/$documentId': typeof PartnerPartnerIdDocumentsDocumentIdRoute
  '/partner_/$partnerId/projects/$projectId': typeof PartnerPartnerIdProjectsProjectIdRoute
  '/partner_/$partnerId/tasks/$taskId': typeof PartnerPartnerIdTasksTaskIdRoute
  '/personal_/events/$eventId/details': typeof PersonalEventsEventIdDetailsRoute
  '/personal_/events/$eventId/logs': typeof PersonalEventsEventIdLogsRoute
  '/personal_/events/$eventId/subcontracting': typeof PersonalEventsEventIdSubcontractingRoute
  '/personal_/events/$eventId/users': typeof PersonalEventsEventIdUsersRoute
  '/personal_/groups/$groupId/details': typeof PersonalGroupsGroupIdDetailsRoute
  '/personal_/groups/$groupId/events': typeof PersonalGroupsGroupIdEventsRoute
  '/personal_/groups/$groupId/logs': typeof PersonalGroupsGroupIdLogsRoute
  '/personal_/groups/$groupId/users': typeof PersonalGroupsGroupIdUsersRoute
  '/personal_/projects/$projectId/events': typeof PersonalProjectsProjectIdEventsRoute
  '/personal_/projects/$projectId/logs': typeof PersonalProjectsProjectIdLogsRoute
  '/_admin/$siteId/overview/': typeof AdminSiteIdOverviewIndexRoute
  '/_admin/config/blocklist/': typeof AdminConfigBlocklistIndexRoute
  '/_admin/config/devices/': typeof AdminConfigDevicesIndexRoute
  '/_admin/config/general/': typeof AdminConfigGeneralIndexRoute
  '/_admin/config/integrations/': typeof AdminConfigIntegrationsIndexRoute
  '/_admin/config/roles/': typeof AdminConfigRolesIndexRoute
  '/_admin/config/tasks/': typeof AdminConfigTasksIndexRoute
  '/_admin/events/$eventId/': typeof AdminEventsEventIdIndexRoute
  '/_admin/groups/$groupId/': typeof AdminGroupsGroupIdIndexRoute
  '/_admin/projects/$projectId/': typeof AdminProjectsProjectIdIndexRoute
  '/_admin/system/forms/': typeof AdminSystemFormsIndexRoute
  '/_admin/system/sites/': typeof AdminSystemSitesIndexRoute
  '/_admin/system/templates/': typeof AdminSystemTemplatesIndexRoute
  '/_admin/users/$userId/': typeof AdminUsersUserIdIndexRoute
  '/company_/$groupId/approvals/': typeof CompanyGroupIdApprovalsIndexRoute
  '/company_/$groupId/documents/': typeof CompanyGroupIdDocumentsIndexRoute
  '/company_/$groupId/events/': typeof CompanyGroupIdEventsIndexRoute
  '/company_/$groupId/projects/': typeof CompanyGroupIdProjectsIndexRoute
  '/company_/$groupId/tasks/': typeof CompanyGroupIdTasksIndexRoute
  '/company_/$groupId/users/': typeof CompanyGroupIdUsersIndexRoute
  '/partner_/$partnerId/approvals/': typeof PartnerPartnerIdApprovalsIndexRoute
  '/partner_/$partnerId/documents/': typeof PartnerPartnerIdDocumentsIndexRoute
  '/partner_/$partnerId/events/': typeof PartnerPartnerIdEventsIndexRoute
  '/partner_/$partnerId/projects/': typeof PartnerPartnerIdProjectsIndexRoute
  '/partner_/$partnerId/tasks/': typeof PartnerPartnerIdTasksIndexRoute
  '/partner_/$partnerId/users/': typeof PartnerPartnerIdUsersIndexRoute
  '/personal_/events/$eventId/': typeof PersonalEventsEventIdIndexRoute
  '/personal_/groups/$groupId/': typeof PersonalGroupsGroupIdIndexRoute
  '/personal_/projects/$projectId/': typeof PersonalProjectsProjectIdIndexRoute
  '/_admin/config/forms/$slugOrId/build': typeof AdminConfigFormsSlugOrIdBuildRoute
  '/_admin/config/tasks/$slug/translate': typeof AdminConfigTasksSlugTranslateRoute
  '/_admin/config/types/event/$typeId': typeof AdminConfigTypesEventTypeIdRoute
  '/_admin/config/types/group/$typeId': typeof AdminConfigTypesGroupTypeIdRoute
  '/_admin/events/$eventId/approvals/$taskId': typeof AdminEventsEventIdApprovalsTaskIdRoute
  '/_admin/events/$eventId/documents/$documentId': typeof AdminEventsEventIdDocumentsDocumentIdRoute
  '/_admin/events/$eventId/tasks/$taskId': typeof AdminEventsEventIdTasksTaskIdRoute
  '/_admin/groups/$groupId/approvals/$approvalId': typeof AdminGroupsGroupIdApprovalsApprovalIdRoute
  '/_admin/groups/$groupId/documents/$documentId': typeof AdminGroupsGroupIdDocumentsDocumentIdRoute
  '/_admin/groups/$groupId/tasks/$taskId': typeof AdminGroupsGroupIdTasksTaskIdRoute
  '/_admin/users/$userId/approvals/$approvalId': typeof AdminUsersUserIdApprovalsApprovalIdRoute
  '/_admin/users/$userId/documents/$documentId': typeof AdminUsersUserIdDocumentsDocumentIdRoute
  '/_admin/users/$userId/tasks/$taskId': typeof AdminUsersUserIdTasksTaskIdRoute
  '/company_/$groupId/events/$eventId/details': typeof CompanyGroupIdEventsEventIdDetailsRoute
  '/company_/$groupId/events/$eventId/groups': typeof CompanyGroupIdEventsEventIdGroupsRoute
  '/company_/$groupId/events/$eventId/logs': typeof CompanyGroupIdEventsEventIdLogsRoute
  '/company_/$groupId/events/$eventId/subcontracting': typeof CompanyGroupIdEventsEventIdSubcontractingRoute
  '/company_/$groupId/events/$eventId/users': typeof CompanyGroupIdEventsEventIdUsersRoute
  '/company_/$groupId/projects/$projectId/events': typeof CompanyGroupIdProjectsProjectIdEventsRoute
  '/partner_/$partnerId/events/$eventId/details': typeof PartnerPartnerIdEventsEventIdDetailsRoute
  '/partner_/$partnerId/events/$eventId/logs': typeof PartnerPartnerIdEventsEventIdLogsRoute
  '/partner_/$partnerId/events/$eventId/subcontracting': typeof PartnerPartnerIdEventsEventIdSubcontractingRoute
  '/partner_/$partnerId/events/$eventId/users': typeof PartnerPartnerIdEventsEventIdUsersRoute
  '/partner_/$partnerId/users/$userId/$documentId': typeof PartnerPartnerIdUsersUserIdDocumentIdRoute
  '/personal_/events/$eventId/approvals/$taskId': typeof PersonalEventsEventIdApprovalsTaskIdRoute
  '/personal_/events/$eventId/documents/$documentId': typeof PersonalEventsEventIdDocumentsDocumentIdRoute
  '/personal_/events/$eventId/tasks/$taskId': typeof PersonalEventsEventIdTasksTaskIdRoute
  '/personal_/groups/$groupId/documents/$documentId': typeof PersonalGroupsGroupIdDocumentsDocumentIdRoute
  '/personal_/groups/$groupId/tasks/$taskId': typeof PersonalGroupsGroupIdTasksTaskIdRoute
  '/_admin/config/tasks/$slug/': typeof AdminConfigTasksSlugIndexRoute
  '/_admin/config/types/event/': typeof AdminConfigTypesEventIndexRoute
  '/_admin/config/types/group/': typeof AdminConfigTypesGroupIndexRoute
  '/_admin/events/$eventId/approvals/': typeof AdminEventsEventIdApprovalsIndexRoute
  '/_admin/events/$eventId/documents/': typeof AdminEventsEventIdDocumentsIndexRoute
  '/_admin/events/$eventId/tasks/': typeof AdminEventsEventIdTasksIndexRoute
  '/_admin/groups/$groupId/approvals/': typeof AdminGroupsGroupIdApprovalsIndexRoute
  '/_admin/groups/$groupId/documents/': typeof AdminGroupsGroupIdDocumentsIndexRoute
  '/_admin/groups/$groupId/tasks/': typeof AdminGroupsGroupIdTasksIndexRoute
  '/_admin/users/$userId/approvals/': typeof AdminUsersUserIdApprovalsIndexRoute
  '/_admin/users/$userId/documents/': typeof AdminUsersUserIdDocumentsIndexRoute
  '/_admin/users/$userId/tasks/': typeof AdminUsersUserIdTasksIndexRoute
  '/personal_/events/$eventId/approvals/': typeof PersonalEventsEventIdApprovalsIndexRoute
  '/personal_/events/$eventId/documents/': typeof PersonalEventsEventIdDocumentsIndexRoute
  '/personal_/events/$eventId/tasks/': typeof PersonalEventsEventIdTasksIndexRoute
  '/personal_/groups/$groupId/documents/': typeof PersonalGroupsGroupIdDocumentsIndexRoute
  '/personal_/groups/$groupId/tasks/': typeof PersonalGroupsGroupIdTasksIndexRoute
  '/company_/$groupId/events/$eventId/documents/$documentId': typeof CompanyGroupIdEventsEventIdDocumentsDocumentIdRoute
  '/company_/$groupId/events/$eventId/tasks/$taskId': typeof CompanyGroupIdEventsEventIdTasksTaskIdRoute
  '/partner_/$partnerId/events/$eventId/approvals/$taskId': typeof PartnerPartnerIdEventsEventIdApprovalsTaskIdRoute
  '/partner_/$partnerId/events/$eventId/documents/$documentId': typeof PartnerPartnerIdEventsEventIdDocumentsDocumentIdRoute
  '/partner_/$partnerId/events/$eventId/tasks/$taskId': typeof PartnerPartnerIdEventsEventIdTasksTaskIdRoute
  '/company_/$groupId/events/$eventId/documents/': typeof CompanyGroupIdEventsEventIdDocumentsIndexRoute
  '/company_/$groupId/events/$eventId/tasks/': typeof CompanyGroupIdEventsEventIdTasksIndexRoute
  '/partner_/$partnerId/events/$eventId/approvals/': typeof PartnerPartnerIdEventsEventIdApprovalsIndexRoute
  '/partner_/$partnerId/events/$eventId/documents/': typeof PartnerPartnerIdEventsEventIdDocumentsIndexRoute
  '/partner_/$partnerId/events/$eventId/tasks/': typeof PartnerPartnerIdEventsEventIdTasksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/access'
    | '/company'
    | '/partner'
    | '/personal'
    | '/supervisor'
    | '/403'
    | '/authentication'
    | '/profile'
    | '/welcome'
    | '/$siteId'
    | '/company/$groupId'
    | '/partner/$partnerId'
    | '/401'
    | '/404'
    | '/error'
    | '/overview'
    | '/access/401'
    | '/access/authentication'
    | '/access/error'
    | '/access/overview'
    | '/app/onboarding'
    | '/authentication/forgot-password'
    | '/authentication/login'
    | '/authentication/logout'
    | '/authentication/reset-password'
    | '/personal/overview'
    | '/personal/tasks'
    | '/supervisor/logs'
    | '/supervisor/users'
    | '/access/'
    | '/company/'
    | '/personal/'
    | '/supervisor/'
    | '/$siteId/overview'
    | '/events/$eventId'
    | '/groups/$groupId'
    | '/projects/$projectId'
    | '/users/$userId'
    | '/personal/events/$eventId'
    | '/personal/groups/$groupId'
    | '/personal/projects/$projectId'
    | '/config/zones'
    | '/reports/access-logs'
    | '/reports/documents'
    | '/reports/occupancy'
    | '/reports/site-status'
    | '/reports/time-on-site'
    | '/system/agentic-parsing'
    | '/system/assets'
    | '/system/datasources'
    | '/system/document-types'
    | '/system/import'
    | '/system/integrations'
    | '/system/overview'
    | '/system/settings'
    | '/access/tasks/$taskId'
    | '/app/registration/fixed'
    | '/app/tasks/$taskId'
    | '/company/$groupId/information'
    | '/company/blocked/$groupId'
    | '/company/verify/$groupId'
    | '/partner/$partnerId/information'
    | '/events/'
    | '/groups/'
    | '/logs/'
    | '/projects/'
    | '/reports/'
    | '/users/'
    | '/app/registration/'
    | '/personal/events/'
    | '/personal/groups/'
    | '/personal/projects/'
    | '/company/$groupId/events/$eventId'
    | '/company/$groupId/projects/$projectId'
    | '/partner/$partnerId/events/$eventId'
    | '/$siteId/overview/approvals'
    | '/$siteId/overview/attendance'
    | '/$siteId/overview/to-review'
    | '/config/devices/$deviceId'
    | '/config/devices/topology'
    | '/config/roles/$roleId'
    | '/config/roles/access'
    | '/events/$eventId/details'
    | '/events/$eventId/logs'
    | '/events/$eventId/subcontracting'
    | '/events/$eventId/users'
    | '/groups/$groupId/contact-details'
    | '/groups/$groupId/details'
    | '/groups/$groupId/events'
    | '/groups/$groupId/logs'
    | '/groups/$groupId/users'
    | '/projects/$projectId/events'
    | '/projects/$projectId/logs'
    | '/system/forms/$id'
    | '/system/sites/$id'
    | '/system/templates/$id'
    | '/users/$userId/access'
    | '/users/$userId/badges'
    | '/users/$userId/details'
    | '/users/$userId/events'
    | '/users/$userId/logs'
    | '/users/$userId/roles'
    | '/company/$groupId/approvals/$taskId'
    | '/company/$groupId/documents/$documentId'
    | '/company/$groupId/tasks/$taskId'
    | '/partner/$partnerId/approvals/$approvalId'
    | '/partner/$partnerId/documents/$documentId'
    | '/partner/$partnerId/projects/$projectId'
    | '/partner/$partnerId/tasks/$taskId'
    | '/personal/events/$eventId/details'
    | '/personal/events/$eventId/logs'
    | '/personal/events/$eventId/subcontracting'
    | '/personal/events/$eventId/users'
    | '/personal/groups/$groupId/details'
    | '/personal/groups/$groupId/events'
    | '/personal/groups/$groupId/logs'
    | '/personal/groups/$groupId/users'
    | '/personal/projects/$projectId/events'
    | '/personal/projects/$projectId/logs'
    | '/$siteId/overview/'
    | '/config/blocklist/'
    | '/config/devices/'
    | '/config/general/'
    | '/config/integrations/'
    | '/config/roles/'
    | '/config/tasks/'
    | '/events/$eventId/'
    | '/groups/$groupId/'
    | '/projects/$projectId/'
    | '/system/forms/'
    | '/system/sites/'
    | '/system/templates/'
    | '/users/$userId/'
    | '/company/$groupId/approvals/'
    | '/company/$groupId/documents/'
    | '/company/$groupId/events/'
    | '/company/$groupId/projects/'
    | '/company/$groupId/tasks/'
    | '/company/$groupId/users/'
    | '/partner/$partnerId/approvals/'
    | '/partner/$partnerId/documents/'
    | '/partner/$partnerId/events/'
    | '/partner/$partnerId/projects/'
    | '/partner/$partnerId/tasks/'
    | '/partner/$partnerId/users/'
    | '/personal/events/$eventId/'
    | '/personal/groups/$groupId/'
    | '/personal/projects/$projectId/'
    | '/config/forms/$slugOrId/build'
    | '/config/tasks/$slug/translate'
    | '/config/types/event/$typeId'
    | '/config/types/group/$typeId'
    | '/events/$eventId/approvals/$taskId'
    | '/events/$eventId/documents/$documentId'
    | '/events/$eventId/tasks/$taskId'
    | '/groups/$groupId/approvals/$approvalId'
    | '/groups/$groupId/documents/$documentId'
    | '/groups/$groupId/tasks/$taskId'
    | '/users/$userId/approvals/$approvalId'
    | '/users/$userId/documents/$documentId'
    | '/users/$userId/tasks/$taskId'
    | '/company/$groupId/events/$eventId/details'
    | '/company/$groupId/events/$eventId/groups'
    | '/company/$groupId/events/$eventId/logs'
    | '/company/$groupId/events/$eventId/subcontracting'
    | '/company/$groupId/events/$eventId/users'
    | '/company/$groupId/projects/$projectId/events'
    | '/partner/$partnerId/events/$eventId/details'
    | '/partner/$partnerId/events/$eventId/logs'
    | '/partner/$partnerId/events/$eventId/subcontracting'
    | '/partner/$partnerId/events/$eventId/users'
    | '/partner/$partnerId/users/$userId/$documentId'
    | '/personal/events/$eventId/approvals/$taskId'
    | '/personal/events/$eventId/documents/$documentId'
    | '/personal/events/$eventId/tasks/$taskId'
    | '/personal/groups/$groupId/documents/$documentId'
    | '/personal/groups/$groupId/tasks/$taskId'
    | '/config/tasks/$slug/'
    | '/config/types/event/'
    | '/config/types/group/'
    | '/events/$eventId/approvals/'
    | '/events/$eventId/documents/'
    | '/events/$eventId/tasks/'
    | '/groups/$groupId/approvals/'
    | '/groups/$groupId/documents/'
    | '/groups/$groupId/tasks/'
    | '/users/$userId/approvals/'
    | '/users/$userId/documents/'
    | '/users/$userId/tasks/'
    | '/personal/events/$eventId/approvals/'
    | '/personal/events/$eventId/documents/'
    | '/personal/events/$eventId/tasks/'
    | '/personal/groups/$groupId/documents/'
    | '/personal/groups/$groupId/tasks/'
    | '/company/$groupId/events/$eventId/documents/$documentId'
    | '/company/$groupId/events/$eventId/tasks/$taskId'
    | '/partner/$partnerId/events/$eventId/approvals/$taskId'
    | '/partner/$partnerId/events/$eventId/documents/$documentId'
    | '/partner/$partnerId/events/$eventId/tasks/$taskId'
    | '/company/$groupId/events/$eventId/documents/'
    | '/company/$groupId/events/$eventId/tasks/'
    | '/partner/$partnerId/events/$eventId/approvals/'
    | '/partner/$partnerId/events/$eventId/documents/'
    | '/partner/$partnerId/events/$eventId/tasks/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/partner'
    | '/403'
    | '/authentication'
    | '/profile'
    | '/welcome'
    | '/$siteId'
    | '/company/$groupId'
    | '/partner/$partnerId'
    | '/401'
    | '/404'
    | '/error'
    | '/overview'
    | '/access/401'
    | '/access/authentication'
    | '/access/error'
    | '/access/overview'
    | '/app/onboarding'
    | '/authentication/forgot-password'
    | '/authentication/login'
    | '/authentication/logout'
    | '/authentication/reset-password'
    | '/personal/overview'
    | '/personal/tasks'
    | '/supervisor/logs'
    | '/supervisor/users'
    | '/access'
    | '/company'
    | '/personal'
    | '/supervisor'
    | '/config/zones'
    | '/reports/access-logs'
    | '/reports/documents'
    | '/reports/occupancy'
    | '/reports/site-status'
    | '/reports/time-on-site'
    | '/system/agentic-parsing'
    | '/system/assets'
    | '/system/datasources'
    | '/system/document-types'
    | '/system/import'
    | '/system/integrations'
    | '/system/overview'
    | '/system/settings'
    | '/access/tasks/$taskId'
    | '/app/registration/fixed'
    | '/app/tasks/$taskId'
    | '/company/$groupId/information'
    | '/company/blocked/$groupId'
    | '/company/verify/$groupId'
    | '/partner/$partnerId/information'
    | '/events'
    | '/groups'
    | '/logs'
    | '/projects'
    | '/reports'
    | '/users'
    | '/app/registration'
    | '/personal/events'
    | '/personal/groups'
    | '/personal/projects'
    | '/company/$groupId/events/$eventId'
    | '/company/$groupId/projects/$projectId'
    | '/partner/$partnerId/events/$eventId'
    | '/$siteId/overview/approvals'
    | '/$siteId/overview/attendance'
    | '/$siteId/overview/to-review'
    | '/config/devices/$deviceId'
    | '/config/devices/topology'
    | '/config/roles/$roleId'
    | '/config/roles/access'
    | '/events/$eventId/details'
    | '/events/$eventId/logs'
    | '/events/$eventId/subcontracting'
    | '/events/$eventId/users'
    | '/groups/$groupId/contact-details'
    | '/groups/$groupId/details'
    | '/groups/$groupId/events'
    | '/groups/$groupId/logs'
    | '/groups/$groupId/users'
    | '/projects/$projectId/events'
    | '/projects/$projectId/logs'
    | '/system/forms/$id'
    | '/system/sites/$id'
    | '/system/templates/$id'
    | '/users/$userId/access'
    | '/users/$userId/badges'
    | '/users/$userId/details'
    | '/users/$userId/events'
    | '/users/$userId/logs'
    | '/users/$userId/roles'
    | '/company/$groupId/approvals/$taskId'
    | '/company/$groupId/documents/$documentId'
    | '/company/$groupId/tasks/$taskId'
    | '/partner/$partnerId/approvals/$approvalId'
    | '/partner/$partnerId/documents/$documentId'
    | '/partner/$partnerId/projects/$projectId'
    | '/partner/$partnerId/tasks/$taskId'
    | '/personal/events/$eventId/details'
    | '/personal/events/$eventId/logs'
    | '/personal/events/$eventId/subcontracting'
    | '/personal/events/$eventId/users'
    | '/personal/groups/$groupId/details'
    | '/personal/groups/$groupId/events'
    | '/personal/groups/$groupId/logs'
    | '/personal/groups/$groupId/users'
    | '/personal/projects/$projectId/events'
    | '/personal/projects/$projectId/logs'
    | '/$siteId/overview'
    | '/config/blocklist'
    | '/config/devices'
    | '/config/general'
    | '/config/integrations'
    | '/config/roles'
    | '/config/tasks'
    | '/events/$eventId'
    | '/groups/$groupId'
    | '/projects/$projectId'
    | '/system/forms'
    | '/system/sites'
    | '/system/templates'
    | '/users/$userId'
    | '/company/$groupId/approvals'
    | '/company/$groupId/documents'
    | '/company/$groupId/events'
    | '/company/$groupId/projects'
    | '/company/$groupId/tasks'
    | '/company/$groupId/users'
    | '/partner/$partnerId/approvals'
    | '/partner/$partnerId/documents'
    | '/partner/$partnerId/events'
    | '/partner/$partnerId/projects'
    | '/partner/$partnerId/tasks'
    | '/partner/$partnerId/users'
    | '/personal/events/$eventId'
    | '/personal/groups/$groupId'
    | '/personal/projects/$projectId'
    | '/config/forms/$slugOrId/build'
    | '/config/tasks/$slug/translate'
    | '/config/types/event/$typeId'
    | '/config/types/group/$typeId'
    | '/events/$eventId/approvals/$taskId'
    | '/events/$eventId/documents/$documentId'
    | '/events/$eventId/tasks/$taskId'
    | '/groups/$groupId/approvals/$approvalId'
    | '/groups/$groupId/documents/$documentId'
    | '/groups/$groupId/tasks/$taskId'
    | '/users/$userId/approvals/$approvalId'
    | '/users/$userId/documents/$documentId'
    | '/users/$userId/tasks/$taskId'
    | '/company/$groupId/events/$eventId/details'
    | '/company/$groupId/events/$eventId/groups'
    | '/company/$groupId/events/$eventId/logs'
    | '/company/$groupId/events/$eventId/subcontracting'
    | '/company/$groupId/events/$eventId/users'
    | '/company/$groupId/projects/$projectId/events'
    | '/partner/$partnerId/events/$eventId/details'
    | '/partner/$partnerId/events/$eventId/logs'
    | '/partner/$partnerId/events/$eventId/subcontracting'
    | '/partner/$partnerId/events/$eventId/users'
    | '/partner/$partnerId/users/$userId/$documentId'
    | '/personal/events/$eventId/approvals/$taskId'
    | '/personal/events/$eventId/documents/$documentId'
    | '/personal/events/$eventId/tasks/$taskId'
    | '/personal/groups/$groupId/documents/$documentId'
    | '/personal/groups/$groupId/tasks/$taskId'
    | '/config/tasks/$slug'
    | '/config/types/event'
    | '/config/types/group'
    | '/events/$eventId/approvals'
    | '/events/$eventId/documents'
    | '/events/$eventId/tasks'
    | '/groups/$groupId/approvals'
    | '/groups/$groupId/documents'
    | '/groups/$groupId/tasks'
    | '/users/$userId/approvals'
    | '/users/$userId/documents'
    | '/users/$userId/tasks'
    | '/personal/events/$eventId/approvals'
    | '/personal/events/$eventId/documents'
    | '/personal/events/$eventId/tasks'
    | '/personal/groups/$groupId/documents'
    | '/personal/groups/$groupId/tasks'
    | '/company/$groupId/events/$eventId/documents/$documentId'
    | '/company/$groupId/events/$eventId/tasks/$taskId'
    | '/partner/$partnerId/events/$eventId/approvals/$taskId'
    | '/partner/$partnerId/events/$eventId/documents/$documentId'
    | '/partner/$partnerId/events/$eventId/tasks/$taskId'
    | '/company/$groupId/events/$eventId/documents'
    | '/company/$groupId/events/$eventId/tasks'
    | '/partner/$partnerId/events/$eventId/approvals'
    | '/partner/$partnerId/events/$eventId/documents'
    | '/partner/$partnerId/events/$eventId/tasks'
  id:
    | '__root__'
    | '/'
    | '/access_'
    | '/company_'
    | '/partner_'
    | '/personal_'
    | '/supervisor_'
    | '/403'
    | '/_admin'
    | '/authentication'
    | '/profile'
    | '/welcome'
    | '/_admin/$siteId'
    | '/company_/$groupId'
    | '/partner_/$partnerId'
    | '/_admin/401'
    | '/_admin/404'
    | '/_admin/error'
    | '/_admin/overview'
    | '/access_/401'
    | '/access_/authentication'
    | '/access_/error'
    | '/access_/overview'
    | '/app/onboarding'
    | '/authentication/forgot-password'
    | '/authentication/login'
    | '/authentication/logout'
    | '/authentication/reset-password'
    | '/personal_/overview'
    | '/personal_/tasks'
    | '/supervisor_/logs'
    | '/supervisor_/users'
    | '/access_/'
    | '/company_/'
    | '/personal_/'
    | '/supervisor_/'
    | '/_admin/$siteId/overview'
    | '/_admin/events/$eventId'
    | '/_admin/groups/$groupId'
    | '/_admin/projects/$projectId'
    | '/_admin/users/$userId'
    | '/personal_/events/$eventId'
    | '/personal_/groups/$groupId'
    | '/personal_/projects/$projectId'
    | '/_admin/config/zones'
    | '/_admin/reports/access-logs'
    | '/_admin/reports/documents'
    | '/_admin/reports/occupancy'
    | '/_admin/reports/site-status'
    | '/_admin/reports/time-on-site'
    | '/_admin/system/agentic-parsing'
    | '/_admin/system/assets'
    | '/_admin/system/datasources'
    | '/_admin/system/document-types'
    | '/_admin/system/import'
    | '/_admin/system/integrations'
    | '/_admin/system/overview'
    | '/_admin/system/settings'
    | '/access_/tasks/$taskId'
    | '/app/registration/fixed'
    | '/app/tasks/$taskId'
    | '/company_/$groupId/information'
    | '/company_/blocked/$groupId'
    | '/company_/verify/$groupId'
    | '/partner_/$partnerId/information'
    | '/_admin/events/'
    | '/_admin/groups/'
    | '/_admin/logs/'
    | '/_admin/projects/'
    | '/_admin/reports/'
    | '/_admin/users/'
    | '/app/registration/'
    | '/personal_/events/'
    | '/personal_/groups/'
    | '/personal_/projects/'
    | '/company_/$groupId/events/$eventId'
    | '/company_/$groupId/projects/$projectId'
    | '/partner_/$partnerId/events/$eventId'
    | '/_admin/$siteId/overview/approvals'
    | '/_admin/$siteId/overview/attendance'
    | '/_admin/$siteId/overview/to-review'
    | '/_admin/config/devices/$deviceId'
    | '/_admin/config/devices/topology'
    | '/_admin/config/roles/$roleId'
    | '/_admin/config/roles/access'
    | '/_admin/events/$eventId/details'
    | '/_admin/events/$eventId/logs'
    | '/_admin/events/$eventId/subcontracting'
    | '/_admin/events/$eventId/users'
    | '/_admin/groups/$groupId/contact-details'
    | '/_admin/groups/$groupId/details'
    | '/_admin/groups/$groupId/events'
    | '/_admin/groups/$groupId/logs'
    | '/_admin/groups/$groupId/users'
    | '/_admin/projects/$projectId/events'
    | '/_admin/projects/$projectId/logs'
    | '/_admin/system/forms/$id'
    | '/_admin/system/sites/$id'
    | '/_admin/system/templates/$id'
    | '/_admin/users/$userId/access'
    | '/_admin/users/$userId/badges'
    | '/_admin/users/$userId/details'
    | '/_admin/users/$userId/events'
    | '/_admin/users/$userId/logs'
    | '/_admin/users/$userId/roles'
    | '/company_/$groupId/approvals/$taskId'
    | '/company_/$groupId/documents/$documentId'
    | '/company_/$groupId/tasks/$taskId'
    | '/partner_/$partnerId/approvals/$approvalId'
    | '/partner_/$partnerId/documents/$documentId'
    | '/partner_/$partnerId/projects/$projectId'
    | '/partner_/$partnerId/tasks/$taskId'
    | '/personal_/events/$eventId/details'
    | '/personal_/events/$eventId/logs'
    | '/personal_/events/$eventId/subcontracting'
    | '/personal_/events/$eventId/users'
    | '/personal_/groups/$groupId/details'
    | '/personal_/groups/$groupId/events'
    | '/personal_/groups/$groupId/logs'
    | '/personal_/groups/$groupId/users'
    | '/personal_/projects/$projectId/events'
    | '/personal_/projects/$projectId/logs'
    | '/_admin/$siteId/overview/'
    | '/_admin/config/blocklist/'
    | '/_admin/config/devices/'
    | '/_admin/config/general/'
    | '/_admin/config/integrations/'
    | '/_admin/config/roles/'
    | '/_admin/config/tasks/'
    | '/_admin/events/$eventId/'
    | '/_admin/groups/$groupId/'
    | '/_admin/projects/$projectId/'
    | '/_admin/system/forms/'
    | '/_admin/system/sites/'
    | '/_admin/system/templates/'
    | '/_admin/users/$userId/'
    | '/company_/$groupId/approvals/'
    | '/company_/$groupId/documents/'
    | '/company_/$groupId/events/'
    | '/company_/$groupId/projects/'
    | '/company_/$groupId/tasks/'
    | '/company_/$groupId/users/'
    | '/partner_/$partnerId/approvals/'
    | '/partner_/$partnerId/documents/'
    | '/partner_/$partnerId/events/'
    | '/partner_/$partnerId/projects/'
    | '/partner_/$partnerId/tasks/'
    | '/partner_/$partnerId/users/'
    | '/personal_/events/$eventId/'
    | '/personal_/groups/$groupId/'
    | '/personal_/projects/$projectId/'
    | '/_admin/config/forms/$slugOrId/build'
    | '/_admin/config/tasks/$slug/translate'
    | '/_admin/config/types/event/$typeId'
    | '/_admin/config/types/group/$typeId'
    | '/_admin/events/$eventId/approvals/$taskId'
    | '/_admin/events/$eventId/documents/$documentId'
    | '/_admin/events/$eventId/tasks/$taskId'
    | '/_admin/groups/$groupId/approvals/$approvalId'
    | '/_admin/groups/$groupId/documents/$documentId'
    | '/_admin/groups/$groupId/tasks/$taskId'
    | '/_admin/users/$userId/approvals/$approvalId'
    | '/_admin/users/$userId/documents/$documentId'
    | '/_admin/users/$userId/tasks/$taskId'
    | '/company_/$groupId/events/$eventId/details'
    | '/company_/$groupId/events/$eventId/groups'
    | '/company_/$groupId/events/$eventId/logs'
    | '/company_/$groupId/events/$eventId/subcontracting'
    | '/company_/$groupId/events/$eventId/users'
    | '/company_/$groupId/projects/$projectId/events'
    | '/partner_/$partnerId/events/$eventId/details'
    | '/partner_/$partnerId/events/$eventId/logs'
    | '/partner_/$partnerId/events/$eventId/subcontracting'
    | '/partner_/$partnerId/events/$eventId/users'
    | '/partner_/$partnerId/users/$userId/$documentId'
    | '/personal_/events/$eventId/approvals/$taskId'
    | '/personal_/events/$eventId/documents/$documentId'
    | '/personal_/events/$eventId/tasks/$taskId'
    | '/personal_/groups/$groupId/documents/$documentId'
    | '/personal_/groups/$groupId/tasks/$taskId'
    | '/_admin/config/tasks/$slug/'
    | '/_admin/config/types/event/'
    | '/_admin/config/types/group/'
    | '/_admin/events/$eventId/approvals/'
    | '/_admin/events/$eventId/documents/'
    | '/_admin/events/$eventId/tasks/'
    | '/_admin/groups/$groupId/approvals/'
    | '/_admin/groups/$groupId/documents/'
    | '/_admin/groups/$groupId/tasks/'
    | '/_admin/users/$userId/approvals/'
    | '/_admin/users/$userId/documents/'
    | '/_admin/users/$userId/tasks/'
    | '/personal_/events/$eventId/approvals/'
    | '/personal_/events/$eventId/documents/'
    | '/personal_/events/$eventId/tasks/'
    | '/personal_/groups/$groupId/documents/'
    | '/personal_/groups/$groupId/tasks/'
    | '/company_/$groupId/events/$eventId/documents/$documentId'
    | '/company_/$groupId/events/$eventId/tasks/$taskId'
    | '/partner_/$partnerId/events/$eventId/approvals/$taskId'
    | '/partner_/$partnerId/events/$eventId/documents/$documentId'
    | '/partner_/$partnerId/events/$eventId/tasks/$taskId'
    | '/company_/$groupId/events/$eventId/documents/'
    | '/company_/$groupId/events/$eventId/tasks/'
    | '/partner_/$partnerId/events/$eventId/approvals/'
    | '/partner_/$partnerId/events/$eventId/documents/'
    | '/partner_/$partnerId/events/$eventId/tasks/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccessRouteRoute: typeof AccessRouteRouteWithChildren
  CompanyRouteRoute: typeof CompanyRouteRouteWithChildren
  PartnerRouteRoute: typeof PartnerRouteRouteWithChildren
  PersonalRouteRoute: typeof PersonalRouteRouteWithChildren
  SupervisorRouteRoute: typeof SupervisorRouteRouteWithChildren
  R403Route: typeof R403Route
  AdminRoute: typeof AdminRouteWithChildren
  AuthenticationRoute: typeof AuthenticationRouteWithChildren
  ProfileRoute: typeof ProfileRoute
  WelcomeRoute: typeof WelcomeRoute
  AppOnboardingRoute: typeof AppOnboardingRoute
  AppRegistrationFixedRoute: typeof AppRegistrationFixedRoute
  AppTasksTaskIdRoute: typeof AppTasksTaskIdRoute
  AppRegistrationIndexRoute: typeof AppRegistrationIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access_': {
      id: '/access_'
      path: '/access'
      fullPath: '/access'
      preLoaderRoute: typeof AccessRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authentication': {
      id: '/authentication'
      path: '/authentication'
      fullPath: '/authentication'
      preLoaderRoute: typeof AuthenticationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/company_': {
      id: '/company_'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof CompanyRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partner_': {
      id: '/partner_'
      path: '/partner'
      fullPath: '/partner'
      preLoaderRoute: typeof PartnerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personal_': {
      id: '/personal_'
      path: '/personal'
      fullPath: '/personal'
      preLoaderRoute: typeof PersonalRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/supervisor_': {
      id: '/supervisor_'
      path: '/supervisor'
      fullPath: '/supervisor'
      preLoaderRoute: typeof SupervisorRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/$siteId': {
      id: '/_admin/$siteId'
      path: '/$siteId'
      fullPath: '/$siteId'
      preLoaderRoute: typeof AdminSiteIdRouteRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/401': {
      id: '/_admin/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof Admin401RouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/404': {
      id: '/_admin/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof Admin404RouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/error': {
      id: '/_admin/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof AdminErrorRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/overview': {
      id: '/_admin/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof AdminOverviewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/access_/': {
      id: '/access_/'
      path: '/'
      fullPath: '/access/'
      preLoaderRoute: typeof AccessIndexRouteImport
      parentRoute: typeof AccessRouteRoute
    }
    '/access_/401': {
      id: '/access_/401'
      path: '/401'
      fullPath: '/access/401'
      preLoaderRoute: typeof Access401RouteImport
      parentRoute: typeof AccessRouteRoute
    }
    '/access_/authentication': {
      id: '/access_/authentication'
      path: '/authentication'
      fullPath: '/access/authentication'
      preLoaderRoute: typeof AccessAuthenticationRouteImport
      parentRoute: typeof AccessRouteRoute
    }
    '/access_/error': {
      id: '/access_/error'
      path: '/error'
      fullPath: '/access/error'
      preLoaderRoute: typeof AccessErrorRouteImport
      parentRoute: typeof AccessRouteRoute
    }
    '/access_/overview': {
      id: '/access_/overview'
      path: '/overview'
      fullPath: '/access/overview'
      preLoaderRoute: typeof AccessOverviewRouteImport
      parentRoute: typeof AccessRouteRoute
    }
    '/app/onboarding': {
      id: '/app/onboarding'
      path: '/app/onboarding'
      fullPath: '/app/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authentication/forgot-password': {
      id: '/authentication/forgot-password'
      path: '/forgot-password'
      fullPath: '/authentication/forgot-password'
      preLoaderRoute: typeof AuthenticationForgotPasswordRouteImport
      parentRoute: typeof AuthenticationRoute
    }
    '/authentication/login': {
      id: '/authentication/login'
      path: '/login'
      fullPath: '/authentication/login'
      preLoaderRoute: typeof AuthenticationLoginRouteImport
      parentRoute: typeof AuthenticationRoute
    }
    '/authentication/logout': {
      id: '/authentication/logout'
      path: '/logout'
      fullPath: '/authentication/logout'
      preLoaderRoute: typeof AuthenticationLogoutRouteImport
      parentRoute: typeof AuthenticationRoute
    }
    '/authentication/reset-password': {
      id: '/authentication/reset-password'
      path: '/reset-password'
      fullPath: '/authentication/reset-password'
      preLoaderRoute: typeof AuthenticationResetPasswordRouteImport
      parentRoute: typeof AuthenticationRoute
    }
    '/company_/': {
      id: '/company_/'
      path: '/'
      fullPath: '/company/'
      preLoaderRoute: typeof CompanyIndexRouteImport
      parentRoute: typeof CompanyRouteRoute
    }
    '/company_/$groupId': {
      id: '/company_/$groupId'
      path: '/$groupId'
      fullPath: '/company/$groupId'
      preLoaderRoute: typeof CompanyGroupIdRouteRouteImport
      parentRoute: typeof CompanyRouteRoute
    }
    '/partner_/$partnerId': {
      id: '/partner_/$partnerId'
      path: '/$partnerId'
      fullPath: '/partner/$partnerId'
      preLoaderRoute: typeof PartnerPartnerIdRouteRouteImport
      parentRoute: typeof PartnerRouteRoute
    }
    '/personal_/': {
      id: '/personal_/'
      path: '/'
      fullPath: '/personal/'
      preLoaderRoute: typeof PersonalIndexRouteImport
      parentRoute: typeof PersonalRouteRoute
    }
    '/personal_/overview': {
      id: '/personal_/overview'
      path: '/overview'
      fullPath: '/personal/overview'
      preLoaderRoute: typeof PersonalOverviewRouteImport
      parentRoute: typeof PersonalRouteRoute
    }
    '/personal_/tasks': {
      id: '/personal_/tasks'
      path: '/tasks'
      fullPath: '/personal/tasks'
      preLoaderRoute: typeof PersonalTasksRouteImport
      parentRoute: typeof PersonalRouteRoute
    }
    '/supervisor_/': {
      id: '/supervisor_/'
      path: '/'
      fullPath: '/supervisor/'
      preLoaderRoute: typeof SupervisorIndexRouteImport
      parentRoute: typeof SupervisorRouteRoute
    }
    '/supervisor_/logs': {
      id: '/supervisor_/logs'
      path: '/logs'
      fullPath: '/supervisor/logs'
      preLoaderRoute: typeof SupervisorLogsRouteImport
      parentRoute: typeof SupervisorRouteRoute
    }
    '/supervisor_/users': {
      id: '/supervisor_/users'
      path: '/users'
      fullPath: '/supervisor/users'
      preLoaderRoute: typeof SupervisorUsersRouteImport
      parentRoute: typeof SupervisorRouteRoute
    }
    '/_admin/$siteId/overview': {
      id: '/_admin/$siteId/overview'
      path: '/overview'
      fullPath: '/$siteId/overview'
      preLoaderRoute: typeof AdminSiteIdOverviewRouteRouteImport
      parentRoute: typeof AdminSiteIdRouteRoute
    }
    '/_admin/config/zones': {
      id: '/_admin/config/zones'
      path: '/config/zones'
      fullPath: '/config/zones'
      preLoaderRoute: typeof AdminConfigZonesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/events/': {
      id: '/_admin/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof AdminEventsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/events/$eventId': {
      id: '/_admin/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof AdminEventsEventIdRouteRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/groups/': {
      id: '/_admin/groups/'
      path: '/groups'
      fullPath: '/groups/'
      preLoaderRoute: typeof AdminGroupsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/groups/$groupId': {
      id: '/_admin/groups/$groupId'
      path: '/groups/$groupId'
      fullPath: '/groups/$groupId'
      preLoaderRoute: typeof AdminGroupsGroupIdRouteRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/logs/': {
      id: '/_admin/logs/'
      path: '/logs'
      fullPath: '/logs/'
      preLoaderRoute: typeof AdminLogsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/projects/': {
      id: '/_admin/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AdminProjectsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/projects/$projectId': {
      id: '/_admin/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AdminProjectsProjectIdRouteRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/reports/': {
      id: '/_admin/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AdminReportsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/reports/access-logs': {
      id: '/_admin/reports/access-logs'
      path: '/reports/access-logs'
      fullPath: '/reports/access-logs'
      preLoaderRoute: typeof AdminReportsAccessLogsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/reports/documents': {
      id: '/_admin/reports/documents'
      path: '/reports/documents'
      fullPath: '/reports/documents'
      preLoaderRoute: typeof AdminReportsDocumentsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/reports/occupancy': {
      id: '/_admin/reports/occupancy'
      path: '/reports/occupancy'
      fullPath: '/reports/occupancy'
      preLoaderRoute: typeof AdminReportsOccupancyRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/reports/site-status': {
      id: '/_admin/reports/site-status'
      path: '/reports/site-status'
      fullPath: '/reports/site-status'
      preLoaderRoute: typeof AdminReportsSiteStatusRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/reports/time-on-site': {
      id: '/_admin/reports/time-on-site'
      path: '/reports/time-on-site'
      fullPath: '/reports/time-on-site'
      preLoaderRoute: typeof AdminReportsTimeOnSiteRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/system/agentic-parsing': {
      id: '/_admin/system/agentic-parsing'
      path: '/system/agentic-parsing'
      fullPath: '/system/agentic-parsing'
      preLoaderRoute: typeof AdminSystemAgenticParsingRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/system/assets': {
      id: '/_admin/system/assets'
      path: '/system/assets'
      fullPath: '/system/assets'
      preLoaderRoute: typeof AdminSystemAssetsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/system/datasources': {
      id: '/_admin/system/datasources'
      path: '/system/datasources'
      fullPath: '/system/datasources'
      preLoaderRoute: typeof AdminSystemDatasourcesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/system/document-types': {
      id: '/_admin/system/document-types'
      path: '/system/document-types'
      fullPath: '/system/document-types'
      preLoaderRoute: typeof AdminSystemDocumentTypesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/system/import': {
      id: '/_admin/system/import'
      path: '/system/import'
      fullPath: '/system/import'
      preLoaderRoute: typeof AdminSystemImportRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/system/integrations': {
      id: '/_admin/system/integrations'
      path: '/system/integrations'
      fullPath: '/system/integrations'
      preLoaderRoute: typeof AdminSystemIntegrationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/system/overview': {
      id: '/_admin/system/overview'
      path: '/system/overview'
      fullPath: '/system/overview'
      preLoaderRoute: typeof AdminSystemOverviewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/system/settings': {
      id: '/_admin/system/settings'
      path: '/system/settings'
      fullPath: '/system/settings'
      preLoaderRoute: typeof AdminSystemSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/users/': {
      id: '/_admin/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/users/$userId': {
      id: '/_admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AdminUsersUserIdRouteRouteImport
      parentRoute: typeof AdminRoute
    }
    '/access_/tasks/$taskId': {
      id: '/access_/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/access/tasks/$taskId'
      preLoaderRoute: typeof AccessTasksTaskIdRouteImport
      parentRoute: typeof AccessRouteRoute
    }
    '/app/registration/': {
      id: '/app/registration/'
      path: '/app/registration'
      fullPath: '/app/registration/'
      preLoaderRoute: typeof AppRegistrationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/registration/fixed': {
      id: '/app/registration/fixed'
      path: '/app/registration/fixed'
      fullPath: '/app/registration/fixed'
      preLoaderRoute: typeof AppRegistrationFixedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/tasks/$taskId': {
      id: '/app/tasks/$taskId'
      path: '/app/tasks/$taskId'
      fullPath: '/app/tasks/$taskId'
      preLoaderRoute: typeof AppTasksTaskIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/company_/$groupId/information': {
      id: '/company_/$groupId/information'
      path: '/information'
      fullPath: '/company/$groupId/information'
      preLoaderRoute: typeof CompanyGroupIdInformationRouteImport
      parentRoute: typeof CompanyGroupIdRouteRoute
    }
    '/company_/blocked/$groupId': {
      id: '/company_/blocked/$groupId'
      path: '/blocked/$groupId'
      fullPath: '/company/blocked/$groupId'
      preLoaderRoute: typeof CompanyBlockedGroupIdRouteImport
      parentRoute: typeof CompanyRouteRoute
    }
    '/company_/verify/$groupId': {
      id: '/company_/verify/$groupId'
      path: '/verify/$groupId'
      fullPath: '/company/verify/$groupId'
      preLoaderRoute: typeof CompanyVerifyGroupIdRouteImport
      parentRoute: typeof CompanyRouteRoute
    }
    '/partner_/$partnerId/information': {
      id: '/partner_/$partnerId/information'
      path: '/information'
      fullPath: '/partner/$partnerId/information'
      preLoaderRoute: typeof PartnerPartnerIdInformationRouteImport
      parentRoute: typeof PartnerPartnerIdRouteRoute
    }
    '/personal_/events/': {
      id: '/personal_/events/'
      path: '/events'
      fullPath: '/personal/events/'
      preLoaderRoute: typeof PersonalEventsIndexRouteImport
      parentRoute: typeof PersonalRouteRoute
    }
    '/personal_/events/$eventId': {
      id: '/personal_/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/personal/events/$eventId'
      preLoaderRoute: typeof PersonalEventsEventIdRouteRouteImport
      parentRoute: typeof PersonalRouteRoute
    }
    '/personal_/groups/': {
      id: '/personal_/groups/'
      path: '/groups'
      fullPath: '/personal/groups/'
      preLoaderRoute: typeof PersonalGroupsIndexRouteImport
      parentRoute: typeof PersonalRouteRoute
    }
    '/personal_/groups/$groupId': {
      id: '/personal_/groups/$groupId'
      path: '/groups/$groupId'
      fullPath: '/personal/groups/$groupId'
      preLoaderRoute: typeof PersonalGroupsGroupIdRouteRouteImport
      parentRoute: typeof PersonalRouteRoute
    }
    '/personal_/projects/': {
      id: '/personal_/projects/'
      path: '/projects'
      fullPath: '/personal/projects/'
      preLoaderRoute: typeof PersonalProjectsIndexRouteImport
      parentRoute: typeof PersonalRouteRoute
    }
    '/personal_/projects/$projectId': {
      id: '/personal_/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/personal/projects/$projectId'
      preLoaderRoute: typeof PersonalProjectsProjectIdRouteRouteImport
      parentRoute: typeof PersonalRouteRoute
    }
    '/_admin/$siteId/overview/': {
      id: '/_admin/$siteId/overview/'
      path: '/'
      fullPath: '/$siteId/overview/'
      preLoaderRoute: typeof AdminSiteIdOverviewIndexRouteImport
      parentRoute: typeof AdminSiteIdOverviewRouteRoute
    }
    '/_admin/$siteId/overview/approvals': {
      id: '/_admin/$siteId/overview/approvals'
      path: '/approvals'
      fullPath: '/$siteId/overview/approvals'
      preLoaderRoute: typeof AdminSiteIdOverviewApprovalsRouteImport
      parentRoute: typeof AdminSiteIdOverviewRouteRoute
    }
    '/_admin/$siteId/overview/attendance': {
      id: '/_admin/$siteId/overview/attendance'
      path: '/attendance'
      fullPath: '/$siteId/overview/attendance'
      preLoaderRoute: typeof AdminSiteIdOverviewAttendanceRouteImport
      parentRoute: typeof AdminSiteIdOverviewRouteRoute
    }
    '/_admin/$siteId/overview/to-review': {
      id: '/_admin/$siteId/overview/to-review'
      path: '/to-review'
      fullPath: '/$siteId/overview/to-review'
      preLoaderRoute: typeof AdminSiteIdOverviewToReviewRouteImport
      parentRoute: typeof AdminSiteIdOverviewRouteRoute
    }
    '/_admin/config/blocklist/': {
      id: '/_admin/config/blocklist/'
      path: '/config/blocklist'
      fullPath: '/config/blocklist/'
      preLoaderRoute: typeof AdminConfigBlocklistIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/config/devices/': {
      id: '/_admin/config/devices/'
      path: '/config/devices'
      fullPath: '/config/devices/'
      preLoaderRoute: typeof AdminConfigDevicesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/config/devices/$deviceId': {
      id: '/_admin/config/devices/$deviceId'
      path: '/config/devices/$deviceId'
      fullPath: '/config/devices/$deviceId'
      preLoaderRoute: typeof AdminConfigDevicesDeviceIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/config/devices/topology': {
      id: '/_admin/config/devices/topology'
      path: '/config/devices/topology'
      fullPath: '/config/devices/topology'
      preLoaderRoute: typeof AdminConfigDevicesTopologyRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/config/general/': {
      id: '/_admin/config/general/'
      path: '/config/general'
      fullPath: '/config/general/'
      preLoaderRoute: typeof AdminConfigGeneralIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/config/integrations/': {
      id: '/_admin/config/integrations/'
      path: '/config/integrations'
      fullPath: '/config/integrations/'
      preLoaderRoute: typeof AdminConfigIntegrationsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/config/roles/': {
      id: '/_admin/config/roles/'
      path: '/config/roles'
      fullPath: '/config/roles/'
      preLoaderRoute: typeof AdminConfigRolesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/config/roles/$roleId': {
      id: '/_admin/config/roles/$roleId'
      path: '/config/roles/$roleId'
      fullPath: '/config/roles/$roleId'
      preLoaderRoute: typeof AdminConfigRolesRoleIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/config/roles/access': {
      id: '/_admin/config/roles/access'
      path: '/config/roles/access'
      fullPath: '/config/roles/access'
      preLoaderRoute: typeof AdminConfigRolesAccessRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/config/tasks/': {
      id: '/_admin/config/tasks/'
      path: '/config/tasks'
      fullPath: '/config/tasks/'
      preLoaderRoute: typeof AdminConfigTasksIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/events/$eventId/': {
      id: '/_admin/events/$eventId/'
      path: '/'
      fullPath: '/events/$eventId/'
      preLoaderRoute: typeof AdminEventsEventIdIndexRouteImport
      parentRoute: typeof AdminEventsEventIdRouteRoute
    }
    '/_admin/events/$eventId/details': {
      id: '/_admin/events/$eventId/details'
      path: '/details'
      fullPath: '/events/$eventId/details'
      preLoaderRoute: typeof AdminEventsEventIdDetailsRouteImport
      parentRoute: typeof AdminEventsEventIdRouteRoute
    }
    '/_admin/events/$eventId/logs': {
      id: '/_admin/events/$eventId/logs'
      path: '/logs'
      fullPath: '/events/$eventId/logs'
      preLoaderRoute: typeof AdminEventsEventIdLogsRouteImport
      parentRoute: typeof AdminEventsEventIdRouteRoute
    }
    '/_admin/events/$eventId/subcontracting': {
      id: '/_admin/events/$eventId/subcontracting'
      path: '/subcontracting'
      fullPath: '/events/$eventId/subcontracting'
      preLoaderRoute: typeof AdminEventsEventIdSubcontractingRouteImport
      parentRoute: typeof AdminEventsEventIdRouteRoute
    }
    '/_admin/events/$eventId/users': {
      id: '/_admin/events/$eventId/users'
      path: '/users'
      fullPath: '/events/$eventId/users'
      preLoaderRoute: typeof AdminEventsEventIdUsersRouteImport
      parentRoute: typeof AdminEventsEventIdRouteRoute
    }
    '/_admin/groups/$groupId/': {
      id: '/_admin/groups/$groupId/'
      path: '/'
      fullPath: '/groups/$groupId/'
      preLoaderRoute: typeof AdminGroupsGroupIdIndexRouteImport
      parentRoute: typeof AdminGroupsGroupIdRouteRoute
    }
    '/_admin/groups/$groupId/contact-details': {
      id: '/_admin/groups/$groupId/contact-details'
      path: '/contact-details'
      fullPath: '/groups/$groupId/contact-details'
      preLoaderRoute: typeof AdminGroupsGroupIdContactDetailsRouteImport
      parentRoute: typeof AdminGroupsGroupIdRouteRoute
    }
    '/_admin/groups/$groupId/details': {
      id: '/_admin/groups/$groupId/details'
      path: '/details'
      fullPath: '/groups/$groupId/details'
      preLoaderRoute: typeof AdminGroupsGroupIdDetailsRouteImport
      parentRoute: typeof AdminGroupsGroupIdRouteRoute
    }
    '/_admin/groups/$groupId/events': {
      id: '/_admin/groups/$groupId/events'
      path: '/events'
      fullPath: '/groups/$groupId/events'
      preLoaderRoute: typeof AdminGroupsGroupIdEventsRouteImport
      parentRoute: typeof AdminGroupsGroupIdRouteRoute
    }
    '/_admin/groups/$groupId/logs': {
      id: '/_admin/groups/$groupId/logs'
      path: '/logs'
      fullPath: '/groups/$groupId/logs'
      preLoaderRoute: typeof AdminGroupsGroupIdLogsRouteImport
      parentRoute: typeof AdminGroupsGroupIdRouteRoute
    }
    '/_admin/groups/$groupId/users': {
      id: '/_admin/groups/$groupId/users'
      path: '/users'
      fullPath: '/groups/$groupId/users'
      preLoaderRoute: typeof AdminGroupsGroupIdUsersRouteImport
      parentRoute: typeof AdminGroupsGroupIdRouteRoute
    }
    '/_admin/projects/$projectId/': {
      id: '/_admin/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof AdminProjectsProjectIdIndexRouteImport
      parentRoute: typeof AdminProjectsProjectIdRouteRoute
    }
    '/_admin/projects/$projectId/events': {
      id: '/_admin/projects/$projectId/events'
      path: '/events'
      fullPath: '/projects/$projectId/events'
      preLoaderRoute: typeof AdminProjectsProjectIdEventsRouteImport
      parentRoute: typeof AdminProjectsProjectIdRouteRoute
    }
    '/_admin/projects/$projectId/logs': {
      id: '/_admin/projects/$projectId/logs'
      path: '/logs'
      fullPath: '/projects/$projectId/logs'
      preLoaderRoute: typeof AdminProjectsProjectIdLogsRouteImport
      parentRoute: typeof AdminProjectsProjectIdRouteRoute
    }
    '/_admin/system/forms/': {
      id: '/_admin/system/forms/'
      path: '/system/forms'
      fullPath: '/system/forms/'
      preLoaderRoute: typeof AdminSystemFormsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/system/forms/$id': {
      id: '/_admin/system/forms/$id'
      path: '/system/forms/$id'
      fullPath: '/system/forms/$id'
      preLoaderRoute: typeof AdminSystemFormsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/system/sites/': {
      id: '/_admin/system/sites/'
      path: '/system/sites'
      fullPath: '/system/sites/'
      preLoaderRoute: typeof AdminSystemSitesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/system/sites/$id': {
      id: '/_admin/system/sites/$id'
      path: '/system/sites/$id'
      fullPath: '/system/sites/$id'
      preLoaderRoute: typeof AdminSystemSitesIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/system/templates/': {
      id: '/_admin/system/templates/'
      path: '/system/templates'
      fullPath: '/system/templates/'
      preLoaderRoute: typeof AdminSystemTemplatesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/system/templates/$id': {
      id: '/_admin/system/templates/$id'
      path: '/system/templates/$id'
      fullPath: '/system/templates/$id'
      preLoaderRoute: typeof AdminSystemTemplatesIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/users/$userId/': {
      id: '/_admin/users/$userId/'
      path: '/'
      fullPath: '/users/$userId/'
      preLoaderRoute: typeof AdminUsersUserIdIndexRouteImport
      parentRoute: typeof AdminUsersUserIdRouteRoute
    }
    '/_admin/users/$userId/access': {
      id: '/_admin/users/$userId/access'
      path: '/access'
      fullPath: '/users/$userId/access'
      preLoaderRoute: typeof AdminUsersUserIdAccessRouteImport
      parentRoute: typeof AdminUsersUserIdRouteRoute
    }
    '/_admin/users/$userId/badges': {
      id: '/_admin/users/$userId/badges'
      path: '/badges'
      fullPath: '/users/$userId/badges'
      preLoaderRoute: typeof AdminUsersUserIdBadgesRouteImport
      parentRoute: typeof AdminUsersUserIdRouteRoute
    }
    '/_admin/users/$userId/details': {
      id: '/_admin/users/$userId/details'
      path: '/details'
      fullPath: '/users/$userId/details'
      preLoaderRoute: typeof AdminUsersUserIdDetailsRouteImport
      parentRoute: typeof AdminUsersUserIdRouteRoute
    }
    '/_admin/users/$userId/events': {
      id: '/_admin/users/$userId/events'
      path: '/events'
      fullPath: '/users/$userId/events'
      preLoaderRoute: typeof AdminUsersUserIdEventsRouteImport
      parentRoute: typeof AdminUsersUserIdRouteRoute
    }
    '/_admin/users/$userId/logs': {
      id: '/_admin/users/$userId/logs'
      path: '/logs'
      fullPath: '/users/$userId/logs'
      preLoaderRoute: typeof AdminUsersUserIdLogsRouteImport
      parentRoute: typeof AdminUsersUserIdRouteRoute
    }
    '/_admin/users/$userId/roles': {
      id: '/_admin/users/$userId/roles'
      path: '/roles'
      fullPath: '/users/$userId/roles'
      preLoaderRoute: typeof AdminUsersUserIdRolesRouteImport
      parentRoute: typeof AdminUsersUserIdRouteRoute
    }
    '/company_/$groupId/approvals/': {
      id: '/company_/$groupId/approvals/'
      path: '/approvals'
      fullPath: '/company/$groupId/approvals/'
      preLoaderRoute: typeof CompanyGroupIdApprovalsIndexRouteImport
      parentRoute: typeof CompanyGroupIdRouteRoute
    }
    '/company_/$groupId/approvals/$taskId': {
      id: '/company_/$groupId/approvals/$taskId'
      path: '/approvals/$taskId'
      fullPath: '/company/$groupId/approvals/$taskId'
      preLoaderRoute: typeof CompanyGroupIdApprovalsTaskIdRouteImport
      parentRoute: typeof CompanyGroupIdRouteRoute
    }
    '/company_/$groupId/documents/': {
      id: '/company_/$groupId/documents/'
      path: '/documents'
      fullPath: '/company/$groupId/documents/'
      preLoaderRoute: typeof CompanyGroupIdDocumentsIndexRouteImport
      parentRoute: typeof CompanyGroupIdRouteRoute
    }
    '/company_/$groupId/documents/$documentId': {
      id: '/company_/$groupId/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/company/$groupId/documents/$documentId'
      preLoaderRoute: typeof CompanyGroupIdDocumentsDocumentIdRouteImport
      parentRoute: typeof CompanyGroupIdRouteRoute
    }
    '/company_/$groupId/events/': {
      id: '/company_/$groupId/events/'
      path: '/events'
      fullPath: '/company/$groupId/events/'
      preLoaderRoute: typeof CompanyGroupIdEventsIndexRouteImport
      parentRoute: typeof CompanyGroupIdRouteRoute
    }
    '/company_/$groupId/events/$eventId': {
      id: '/company_/$groupId/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/company/$groupId/events/$eventId'
      preLoaderRoute: typeof CompanyGroupIdEventsEventIdRouteRouteImport
      parentRoute: typeof CompanyGroupIdRouteRoute
    }
    '/company_/$groupId/projects/': {
      id: '/company_/$groupId/projects/'
      path: '/projects'
      fullPath: '/company/$groupId/projects/'
      preLoaderRoute: typeof CompanyGroupIdProjectsIndexRouteImport
      parentRoute: typeof CompanyGroupIdRouteRoute
    }
    '/company_/$groupId/projects/$projectId': {
      id: '/company_/$groupId/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/company/$groupId/projects/$projectId'
      preLoaderRoute: typeof CompanyGroupIdProjectsProjectIdRouteRouteImport
      parentRoute: typeof CompanyGroupIdRouteRoute
    }
    '/company_/$groupId/tasks/': {
      id: '/company_/$groupId/tasks/'
      path: '/tasks'
      fullPath: '/company/$groupId/tasks/'
      preLoaderRoute: typeof CompanyGroupIdTasksIndexRouteImport
      parentRoute: typeof CompanyGroupIdRouteRoute
    }
    '/company_/$groupId/tasks/$taskId': {
      id: '/company_/$groupId/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/company/$groupId/tasks/$taskId'
      preLoaderRoute: typeof CompanyGroupIdTasksTaskIdRouteImport
      parentRoute: typeof CompanyGroupIdRouteRoute
    }
    '/company_/$groupId/users/': {
      id: '/company_/$groupId/users/'
      path: '/users'
      fullPath: '/company/$groupId/users/'
      preLoaderRoute: typeof CompanyGroupIdUsersIndexRouteImport
      parentRoute: typeof CompanyGroupIdRouteRoute
    }
    '/partner_/$partnerId/approvals/': {
      id: '/partner_/$partnerId/approvals/'
      path: '/approvals'
      fullPath: '/partner/$partnerId/approvals/'
      preLoaderRoute: typeof PartnerPartnerIdApprovalsIndexRouteImport
      parentRoute: typeof PartnerPartnerIdRouteRoute
    }
    '/partner_/$partnerId/approvals/$approvalId': {
      id: '/partner_/$partnerId/approvals/$approvalId'
      path: '/approvals/$approvalId'
      fullPath: '/partner/$partnerId/approvals/$approvalId'
      preLoaderRoute: typeof PartnerPartnerIdApprovalsApprovalIdRouteImport
      parentRoute: typeof PartnerPartnerIdRouteRoute
    }
    '/partner_/$partnerId/documents/': {
      id: '/partner_/$partnerId/documents/'
      path: '/documents'
      fullPath: '/partner/$partnerId/documents/'
      preLoaderRoute: typeof PartnerPartnerIdDocumentsIndexRouteImport
      parentRoute: typeof PartnerPartnerIdRouteRoute
    }
    '/partner_/$partnerId/documents/$documentId': {
      id: '/partner_/$partnerId/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/partner/$partnerId/documents/$documentId'
      preLoaderRoute: typeof PartnerPartnerIdDocumentsDocumentIdRouteImport
      parentRoute: typeof PartnerPartnerIdRouteRoute
    }
    '/partner_/$partnerId/events/': {
      id: '/partner_/$partnerId/events/'
      path: '/events'
      fullPath: '/partner/$partnerId/events/'
      preLoaderRoute: typeof PartnerPartnerIdEventsIndexRouteImport
      parentRoute: typeof PartnerPartnerIdRouteRoute
    }
    '/partner_/$partnerId/events/$eventId': {
      id: '/partner_/$partnerId/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/partner/$partnerId/events/$eventId'
      preLoaderRoute: typeof PartnerPartnerIdEventsEventIdRouteRouteImport
      parentRoute: typeof PartnerPartnerIdRouteRoute
    }
    '/partner_/$partnerId/projects/': {
      id: '/partner_/$partnerId/projects/'
      path: '/projects'
      fullPath: '/partner/$partnerId/projects/'
      preLoaderRoute: typeof PartnerPartnerIdProjectsIndexRouteImport
      parentRoute: typeof PartnerPartnerIdRouteRoute
    }
    '/partner_/$partnerId/projects/$projectId': {
      id: '/partner_/$partnerId/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/partner/$partnerId/projects/$projectId'
      preLoaderRoute: typeof PartnerPartnerIdProjectsProjectIdRouteImport
      parentRoute: typeof PartnerPartnerIdRouteRoute
    }
    '/partner_/$partnerId/tasks/': {
      id: '/partner_/$partnerId/tasks/'
      path: '/tasks'
      fullPath: '/partner/$partnerId/tasks/'
      preLoaderRoute: typeof PartnerPartnerIdTasksIndexRouteImport
      parentRoute: typeof PartnerPartnerIdRouteRoute
    }
    '/partner_/$partnerId/tasks/$taskId': {
      id: '/partner_/$partnerId/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/partner/$partnerId/tasks/$taskId'
      preLoaderRoute: typeof PartnerPartnerIdTasksTaskIdRouteImport
      parentRoute: typeof PartnerPartnerIdRouteRoute
    }
    '/partner_/$partnerId/users/': {
      id: '/partner_/$partnerId/users/'
      path: '/users'
      fullPath: '/partner/$partnerId/users/'
      preLoaderRoute: typeof PartnerPartnerIdUsersIndexRouteImport
      parentRoute: typeof PartnerPartnerIdRouteRoute
    }
    '/personal_/events/$eventId/': {
      id: '/personal_/events/$eventId/'
      path: '/'
      fullPath: '/personal/events/$eventId/'
      preLoaderRoute: typeof PersonalEventsEventIdIndexRouteImport
      parentRoute: typeof PersonalEventsEventIdRouteRoute
    }
    '/personal_/events/$eventId/details': {
      id: '/personal_/events/$eventId/details'
      path: '/details'
      fullPath: '/personal/events/$eventId/details'
      preLoaderRoute: typeof PersonalEventsEventIdDetailsRouteImport
      parentRoute: typeof PersonalEventsEventIdRouteRoute
    }
    '/personal_/events/$eventId/logs': {
      id: '/personal_/events/$eventId/logs'
      path: '/logs'
      fullPath: '/personal/events/$eventId/logs'
      preLoaderRoute: typeof PersonalEventsEventIdLogsRouteImport
      parentRoute: typeof PersonalEventsEventIdRouteRoute
    }
    '/personal_/events/$eventId/subcontracting': {
      id: '/personal_/events/$eventId/subcontracting'
      path: '/subcontracting'
      fullPath: '/personal/events/$eventId/subcontracting'
      preLoaderRoute: typeof PersonalEventsEventIdSubcontractingRouteImport
      parentRoute: typeof PersonalEventsEventIdRouteRoute
    }
    '/personal_/events/$eventId/users': {
      id: '/personal_/events/$eventId/users'
      path: '/users'
      fullPath: '/personal/events/$eventId/users'
      preLoaderRoute: typeof PersonalEventsEventIdUsersRouteImport
      parentRoute: typeof PersonalEventsEventIdRouteRoute
    }
    '/personal_/groups/$groupId/': {
      id: '/personal_/groups/$groupId/'
      path: '/'
      fullPath: '/personal/groups/$groupId/'
      preLoaderRoute: typeof PersonalGroupsGroupIdIndexRouteImport
      parentRoute: typeof PersonalGroupsGroupIdRouteRoute
    }
    '/personal_/groups/$groupId/details': {
      id: '/personal_/groups/$groupId/details'
      path: '/details'
      fullPath: '/personal/groups/$groupId/details'
      preLoaderRoute: typeof PersonalGroupsGroupIdDetailsRouteImport
      parentRoute: typeof PersonalGroupsGroupIdRouteRoute
    }
    '/personal_/groups/$groupId/events': {
      id: '/personal_/groups/$groupId/events'
      path: '/events'
      fullPath: '/personal/groups/$groupId/events'
      preLoaderRoute: typeof PersonalGroupsGroupIdEventsRouteImport
      parentRoute: typeof PersonalGroupsGroupIdRouteRoute
    }
    '/personal_/groups/$groupId/logs': {
      id: '/personal_/groups/$groupId/logs'
      path: '/logs'
      fullPath: '/personal/groups/$groupId/logs'
      preLoaderRoute: typeof PersonalGroupsGroupIdLogsRouteImport
      parentRoute: typeof PersonalGroupsGroupIdRouteRoute
    }
    '/personal_/groups/$groupId/users': {
      id: '/personal_/groups/$groupId/users'
      path: '/users'
      fullPath: '/personal/groups/$groupId/users'
      preLoaderRoute: typeof PersonalGroupsGroupIdUsersRouteImport
      parentRoute: typeof PersonalGroupsGroupIdRouteRoute
    }
    '/personal_/projects/$projectId/': {
      id: '/personal_/projects/$projectId/'
      path: '/'
      fullPath: '/personal/projects/$projectId/'
      preLoaderRoute: typeof PersonalProjectsProjectIdIndexRouteImport
      parentRoute: typeof PersonalProjectsProjectIdRouteRoute
    }
    '/personal_/projects/$projectId/events': {
      id: '/personal_/projects/$projectId/events'
      path: '/events'
      fullPath: '/personal/projects/$projectId/events'
      preLoaderRoute: typeof PersonalProjectsProjectIdEventsRouteImport
      parentRoute: typeof PersonalProjectsProjectIdRouteRoute
    }
    '/personal_/projects/$projectId/logs': {
      id: '/personal_/projects/$projectId/logs'
      path: '/logs'
      fullPath: '/personal/projects/$projectId/logs'
      preLoaderRoute: typeof PersonalProjectsProjectIdLogsRouteImport
      parentRoute: typeof PersonalProjectsProjectIdRouteRoute
    }
    '/_admin/config/forms/$slugOrId/build': {
      id: '/_admin/config/forms/$slugOrId/build'
      path: '/config/forms/$slugOrId/build'
      fullPath: '/config/forms/$slugOrId/build'
      preLoaderRoute: typeof AdminConfigFormsSlugOrIdBuildRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/config/tasks/$slug/': {
      id: '/_admin/config/tasks/$slug/'
      path: '/config/tasks/$slug'
      fullPath: '/config/tasks/$slug/'
      preLoaderRoute: typeof AdminConfigTasksSlugIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/config/tasks/$slug/translate': {
      id: '/_admin/config/tasks/$slug/translate'
      path: '/config/tasks/$slug/translate'
      fullPath: '/config/tasks/$slug/translate'
      preLoaderRoute: typeof AdminConfigTasksSlugTranslateRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/config/types/event/': {
      id: '/_admin/config/types/event/'
      path: '/config/types/event'
      fullPath: '/config/types/event/'
      preLoaderRoute: typeof AdminConfigTypesEventIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/config/types/event/$typeId': {
      id: '/_admin/config/types/event/$typeId'
      path: '/config/types/event/$typeId'
      fullPath: '/config/types/event/$typeId'
      preLoaderRoute: typeof AdminConfigTypesEventTypeIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/config/types/group/': {
      id: '/_admin/config/types/group/'
      path: '/config/types/group'
      fullPath: '/config/types/group/'
      preLoaderRoute: typeof AdminConfigTypesGroupIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/config/types/group/$typeId': {
      id: '/_admin/config/types/group/$typeId'
      path: '/config/types/group/$typeId'
      fullPath: '/config/types/group/$typeId'
      preLoaderRoute: typeof AdminConfigTypesGroupTypeIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/events/$eventId/approvals/': {
      id: '/_admin/events/$eventId/approvals/'
      path: '/approvals'
      fullPath: '/events/$eventId/approvals/'
      preLoaderRoute: typeof AdminEventsEventIdApprovalsIndexRouteImport
      parentRoute: typeof AdminEventsEventIdRouteRoute
    }
    '/_admin/events/$eventId/approvals/$taskId': {
      id: '/_admin/events/$eventId/approvals/$taskId'
      path: '/approvals/$taskId'
      fullPath: '/events/$eventId/approvals/$taskId'
      preLoaderRoute: typeof AdminEventsEventIdApprovalsTaskIdRouteImport
      parentRoute: typeof AdminEventsEventIdRouteRoute
    }
    '/_admin/events/$eventId/documents/': {
      id: '/_admin/events/$eventId/documents/'
      path: '/documents'
      fullPath: '/events/$eventId/documents/'
      preLoaderRoute: typeof AdminEventsEventIdDocumentsIndexRouteImport
      parentRoute: typeof AdminEventsEventIdRouteRoute
    }
    '/_admin/events/$eventId/documents/$documentId': {
      id: '/_admin/events/$eventId/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/events/$eventId/documents/$documentId'
      preLoaderRoute: typeof AdminEventsEventIdDocumentsDocumentIdRouteImport
      parentRoute: typeof AdminEventsEventIdRouteRoute
    }
    '/_admin/events/$eventId/tasks/': {
      id: '/_admin/events/$eventId/tasks/'
      path: '/tasks'
      fullPath: '/events/$eventId/tasks/'
      preLoaderRoute: typeof AdminEventsEventIdTasksIndexRouteImport
      parentRoute: typeof AdminEventsEventIdRouteRoute
    }
    '/_admin/events/$eventId/tasks/$taskId': {
      id: '/_admin/events/$eventId/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/events/$eventId/tasks/$taskId'
      preLoaderRoute: typeof AdminEventsEventIdTasksTaskIdRouteImport
      parentRoute: typeof AdminEventsEventIdRouteRoute
    }
    '/_admin/groups/$groupId/approvals/': {
      id: '/_admin/groups/$groupId/approvals/'
      path: '/approvals'
      fullPath: '/groups/$groupId/approvals/'
      preLoaderRoute: typeof AdminGroupsGroupIdApprovalsIndexRouteImport
      parentRoute: typeof AdminGroupsGroupIdRouteRoute
    }
    '/_admin/groups/$groupId/approvals/$approvalId': {
      id: '/_admin/groups/$groupId/approvals/$approvalId'
      path: '/approvals/$approvalId'
      fullPath: '/groups/$groupId/approvals/$approvalId'
      preLoaderRoute: typeof AdminGroupsGroupIdApprovalsApprovalIdRouteImport
      parentRoute: typeof AdminGroupsGroupIdRouteRoute
    }
    '/_admin/groups/$groupId/documents/': {
      id: '/_admin/groups/$groupId/documents/'
      path: '/documents'
      fullPath: '/groups/$groupId/documents/'
      preLoaderRoute: typeof AdminGroupsGroupIdDocumentsIndexRouteImport
      parentRoute: typeof AdminGroupsGroupIdRouteRoute
    }
    '/_admin/groups/$groupId/documents/$documentId': {
      id: '/_admin/groups/$groupId/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/groups/$groupId/documents/$documentId'
      preLoaderRoute: typeof AdminGroupsGroupIdDocumentsDocumentIdRouteImport
      parentRoute: typeof AdminGroupsGroupIdRouteRoute
    }
    '/_admin/groups/$groupId/tasks/': {
      id: '/_admin/groups/$groupId/tasks/'
      path: '/tasks'
      fullPath: '/groups/$groupId/tasks/'
      preLoaderRoute: typeof AdminGroupsGroupIdTasksIndexRouteImport
      parentRoute: typeof AdminGroupsGroupIdRouteRoute
    }
    '/_admin/groups/$groupId/tasks/$taskId': {
      id: '/_admin/groups/$groupId/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/groups/$groupId/tasks/$taskId'
      preLoaderRoute: typeof AdminGroupsGroupIdTasksTaskIdRouteImport
      parentRoute: typeof AdminGroupsGroupIdRouteRoute
    }
    '/_admin/users/$userId/approvals/': {
      id: '/_admin/users/$userId/approvals/'
      path: '/approvals'
      fullPath: '/users/$userId/approvals/'
      preLoaderRoute: typeof AdminUsersUserIdApprovalsIndexRouteImport
      parentRoute: typeof AdminUsersUserIdRouteRoute
    }
    '/_admin/users/$userId/approvals/$approvalId': {
      id: '/_admin/users/$userId/approvals/$approvalId'
      path: '/approvals/$approvalId'
      fullPath: '/users/$userId/approvals/$approvalId'
      preLoaderRoute: typeof AdminUsersUserIdApprovalsApprovalIdRouteImport
      parentRoute: typeof AdminUsersUserIdRouteRoute
    }
    '/_admin/users/$userId/documents/': {
      id: '/_admin/users/$userId/documents/'
      path: '/documents'
      fullPath: '/users/$userId/documents/'
      preLoaderRoute: typeof AdminUsersUserIdDocumentsIndexRouteImport
      parentRoute: typeof AdminUsersUserIdRouteRoute
    }
    '/_admin/users/$userId/documents/$documentId': {
      id: '/_admin/users/$userId/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/users/$userId/documents/$documentId'
      preLoaderRoute: typeof AdminUsersUserIdDocumentsDocumentIdRouteImport
      parentRoute: typeof AdminUsersUserIdRouteRoute
    }
    '/_admin/users/$userId/tasks/': {
      id: '/_admin/users/$userId/tasks/'
      path: '/tasks'
      fullPath: '/users/$userId/tasks/'
      preLoaderRoute: typeof AdminUsersUserIdTasksIndexRouteImport
      parentRoute: typeof AdminUsersUserIdRouteRoute
    }
    '/_admin/users/$userId/tasks/$taskId': {
      id: '/_admin/users/$userId/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/users/$userId/tasks/$taskId'
      preLoaderRoute: typeof AdminUsersUserIdTasksTaskIdRouteImport
      parentRoute: typeof AdminUsersUserIdRouteRoute
    }
    '/company_/$groupId/events/$eventId/details': {
      id: '/company_/$groupId/events/$eventId/details'
      path: '/details'
      fullPath: '/company/$groupId/events/$eventId/details'
      preLoaderRoute: typeof CompanyGroupIdEventsEventIdDetailsRouteImport
      parentRoute: typeof CompanyGroupIdEventsEventIdRouteRoute
    }
    '/company_/$groupId/events/$eventId/groups': {
      id: '/company_/$groupId/events/$eventId/groups'
      path: '/groups'
      fullPath: '/company/$groupId/events/$eventId/groups'
      preLoaderRoute: typeof CompanyGroupIdEventsEventIdGroupsRouteImport
      parentRoute: typeof CompanyGroupIdEventsEventIdRouteRoute
    }
    '/company_/$groupId/events/$eventId/logs': {
      id: '/company_/$groupId/events/$eventId/logs'
      path: '/logs'
      fullPath: '/company/$groupId/events/$eventId/logs'
      preLoaderRoute: typeof CompanyGroupIdEventsEventIdLogsRouteImport
      parentRoute: typeof CompanyGroupIdEventsEventIdRouteRoute
    }
    '/company_/$groupId/events/$eventId/subcontracting': {
      id: '/company_/$groupId/events/$eventId/subcontracting'
      path: '/subcontracting'
      fullPath: '/company/$groupId/events/$eventId/subcontracting'
      preLoaderRoute: typeof CompanyGroupIdEventsEventIdSubcontractingRouteImport
      parentRoute: typeof CompanyGroupIdEventsEventIdRouteRoute
    }
    '/company_/$groupId/events/$eventId/users': {
      id: '/company_/$groupId/events/$eventId/users'
      path: '/users'
      fullPath: '/company/$groupId/events/$eventId/users'
      preLoaderRoute: typeof CompanyGroupIdEventsEventIdUsersRouteImport
      parentRoute: typeof CompanyGroupIdEventsEventIdRouteRoute
    }
    '/company_/$groupId/projects/$projectId/events': {
      id: '/company_/$groupId/projects/$projectId/events'
      path: '/events'
      fullPath: '/company/$groupId/projects/$projectId/events'
      preLoaderRoute: typeof CompanyGroupIdProjectsProjectIdEventsRouteImport
      parentRoute: typeof CompanyGroupIdProjectsProjectIdRouteRoute
    }
    '/partner_/$partnerId/events/$eventId/details': {
      id: '/partner_/$partnerId/events/$eventId/details'
      path: '/details'
      fullPath: '/partner/$partnerId/events/$eventId/details'
      preLoaderRoute: typeof PartnerPartnerIdEventsEventIdDetailsRouteImport
      parentRoute: typeof PartnerPartnerIdEventsEventIdRouteRoute
    }
    '/partner_/$partnerId/events/$eventId/logs': {
      id: '/partner_/$partnerId/events/$eventId/logs'
      path: '/logs'
      fullPath: '/partner/$partnerId/events/$eventId/logs'
      preLoaderRoute: typeof PartnerPartnerIdEventsEventIdLogsRouteImport
      parentRoute: typeof PartnerPartnerIdEventsEventIdRouteRoute
    }
    '/partner_/$partnerId/events/$eventId/subcontracting': {
      id: '/partner_/$partnerId/events/$eventId/subcontracting'
      path: '/subcontracting'
      fullPath: '/partner/$partnerId/events/$eventId/subcontracting'
      preLoaderRoute: typeof PartnerPartnerIdEventsEventIdSubcontractingRouteImport
      parentRoute: typeof PartnerPartnerIdEventsEventIdRouteRoute
    }
    '/partner_/$partnerId/events/$eventId/users': {
      id: '/partner_/$partnerId/events/$eventId/users'
      path: '/users'
      fullPath: '/partner/$partnerId/events/$eventId/users'
      preLoaderRoute: typeof PartnerPartnerIdEventsEventIdUsersRouteImport
      parentRoute: typeof PartnerPartnerIdEventsEventIdRouteRoute
    }
    '/partner_/$partnerId/users/$userId/$documentId': {
      id: '/partner_/$partnerId/users/$userId/$documentId'
      path: '/users/$userId/$documentId'
      fullPath: '/partner/$partnerId/users/$userId/$documentId'
      preLoaderRoute: typeof PartnerPartnerIdUsersUserIdDocumentIdRouteImport
      parentRoute: typeof PartnerPartnerIdRouteRoute
    }
    '/personal_/events/$eventId/approvals/': {
      id: '/personal_/events/$eventId/approvals/'
      path: '/approvals'
      fullPath: '/personal/events/$eventId/approvals/'
      preLoaderRoute: typeof PersonalEventsEventIdApprovalsIndexRouteImport
      parentRoute: typeof PersonalEventsEventIdRouteRoute
    }
    '/personal_/events/$eventId/approvals/$taskId': {
      id: '/personal_/events/$eventId/approvals/$taskId'
      path: '/approvals/$taskId'
      fullPath: '/personal/events/$eventId/approvals/$taskId'
      preLoaderRoute: typeof PersonalEventsEventIdApprovalsTaskIdRouteImport
      parentRoute: typeof PersonalEventsEventIdRouteRoute
    }
    '/personal_/events/$eventId/documents/': {
      id: '/personal_/events/$eventId/documents/'
      path: '/documents'
      fullPath: '/personal/events/$eventId/documents/'
      preLoaderRoute: typeof PersonalEventsEventIdDocumentsIndexRouteImport
      parentRoute: typeof PersonalEventsEventIdRouteRoute
    }
    '/personal_/events/$eventId/documents/$documentId': {
      id: '/personal_/events/$eventId/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/personal/events/$eventId/documents/$documentId'
      preLoaderRoute: typeof PersonalEventsEventIdDocumentsDocumentIdRouteImport
      parentRoute: typeof PersonalEventsEventIdRouteRoute
    }
    '/personal_/events/$eventId/tasks/': {
      id: '/personal_/events/$eventId/tasks/'
      path: '/tasks'
      fullPath: '/personal/events/$eventId/tasks/'
      preLoaderRoute: typeof PersonalEventsEventIdTasksIndexRouteImport
      parentRoute: typeof PersonalEventsEventIdRouteRoute
    }
    '/personal_/events/$eventId/tasks/$taskId': {
      id: '/personal_/events/$eventId/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/personal/events/$eventId/tasks/$taskId'
      preLoaderRoute: typeof PersonalEventsEventIdTasksTaskIdRouteImport
      parentRoute: typeof PersonalEventsEventIdRouteRoute
    }
    '/personal_/groups/$groupId/documents/': {
      id: '/personal_/groups/$groupId/documents/'
      path: '/documents'
      fullPath: '/personal/groups/$groupId/documents/'
      preLoaderRoute: typeof PersonalGroupsGroupIdDocumentsIndexRouteImport
      parentRoute: typeof PersonalGroupsGroupIdRouteRoute
    }
    '/personal_/groups/$groupId/documents/$documentId': {
      id: '/personal_/groups/$groupId/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/personal/groups/$groupId/documents/$documentId'
      preLoaderRoute: typeof PersonalGroupsGroupIdDocumentsDocumentIdRouteImport
      parentRoute: typeof PersonalGroupsGroupIdRouteRoute
    }
    '/personal_/groups/$groupId/tasks/': {
      id: '/personal_/groups/$groupId/tasks/'
      path: '/tasks'
      fullPath: '/personal/groups/$groupId/tasks/'
      preLoaderRoute: typeof PersonalGroupsGroupIdTasksIndexRouteImport
      parentRoute: typeof PersonalGroupsGroupIdRouteRoute
    }
    '/personal_/groups/$groupId/tasks/$taskId': {
      id: '/personal_/groups/$groupId/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/personal/groups/$groupId/tasks/$taskId'
      preLoaderRoute: typeof PersonalGroupsGroupIdTasksTaskIdRouteImport
      parentRoute: typeof PersonalGroupsGroupIdRouteRoute
    }
    '/company_/$groupId/events/$eventId/documents/': {
      id: '/company_/$groupId/events/$eventId/documents/'
      path: '/documents'
      fullPath: '/company/$groupId/events/$eventId/documents/'
      preLoaderRoute: typeof CompanyGroupIdEventsEventIdDocumentsIndexRouteImport
      parentRoute: typeof CompanyGroupIdEventsEventIdRouteRoute
    }
    '/company_/$groupId/events/$eventId/documents/$documentId': {
      id: '/company_/$groupId/events/$eventId/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/company/$groupId/events/$eventId/documents/$documentId'
      preLoaderRoute: typeof CompanyGroupIdEventsEventIdDocumentsDocumentIdRouteImport
      parentRoute: typeof CompanyGroupIdEventsEventIdRouteRoute
    }
    '/company_/$groupId/events/$eventId/tasks/': {
      id: '/company_/$groupId/events/$eventId/tasks/'
      path: '/tasks'
      fullPath: '/company/$groupId/events/$eventId/tasks/'
      preLoaderRoute: typeof CompanyGroupIdEventsEventIdTasksIndexRouteImport
      parentRoute: typeof CompanyGroupIdEventsEventIdRouteRoute
    }
    '/company_/$groupId/events/$eventId/tasks/$taskId': {
      id: '/company_/$groupId/events/$eventId/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/company/$groupId/events/$eventId/tasks/$taskId'
      preLoaderRoute: typeof CompanyGroupIdEventsEventIdTasksTaskIdRouteImport
      parentRoute: typeof CompanyGroupIdEventsEventIdRouteRoute
    }
    '/partner_/$partnerId/events/$eventId/approvals/': {
      id: '/partner_/$partnerId/events/$eventId/approvals/'
      path: '/approvals'
      fullPath: '/partner/$partnerId/events/$eventId/approvals/'
      preLoaderRoute: typeof PartnerPartnerIdEventsEventIdApprovalsIndexRouteImport
      parentRoute: typeof PartnerPartnerIdEventsEventIdRouteRoute
    }
    '/partner_/$partnerId/events/$eventId/approvals/$taskId': {
      id: '/partner_/$partnerId/events/$eventId/approvals/$taskId'
      path: '/approvals/$taskId'
      fullPath: '/partner/$partnerId/events/$eventId/approvals/$taskId'
      preLoaderRoute: typeof PartnerPartnerIdEventsEventIdApprovalsTaskIdRouteImport
      parentRoute: typeof PartnerPartnerIdEventsEventIdRouteRoute
    }
    '/partner_/$partnerId/events/$eventId/documents/': {
      id: '/partner_/$partnerId/events/$eventId/documents/'
      path: '/documents'
      fullPath: '/partner/$partnerId/events/$eventId/documents/'
      preLoaderRoute: typeof PartnerPartnerIdEventsEventIdDocumentsIndexRouteImport
      parentRoute: typeof PartnerPartnerIdEventsEventIdRouteRoute
    }
    '/partner_/$partnerId/events/$eventId/documents/$documentId': {
      id: '/partner_/$partnerId/events/$eventId/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/partner/$partnerId/events/$eventId/documents/$documentId'
      preLoaderRoute: typeof PartnerPartnerIdEventsEventIdDocumentsDocumentIdRouteImport
      parentRoute: typeof PartnerPartnerIdEventsEventIdRouteRoute
    }
    '/partner_/$partnerId/events/$eventId/tasks/': {
      id: '/partner_/$partnerId/events/$eventId/tasks/'
      path: '/tasks'
      fullPath: '/partner/$partnerId/events/$eventId/tasks/'
      preLoaderRoute: typeof PartnerPartnerIdEventsEventIdTasksIndexRouteImport
      parentRoute: typeof PartnerPartnerIdEventsEventIdRouteRoute
    }
    '/partner_/$partnerId/events/$eventId/tasks/$taskId': {
      id: '/partner_/$partnerId/events/$eventId/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/partner/$partnerId/events/$eventId/tasks/$taskId'
      preLoaderRoute: typeof PartnerPartnerIdEventsEventIdTasksTaskIdRouteImport
      parentRoute: typeof PartnerPartnerIdEventsEventIdRouteRoute
    }
  }
}

interface AccessRouteRouteChildren {
  Access401Route: typeof Access401Route
  AccessAuthenticationRoute: typeof AccessAuthenticationRoute
  AccessErrorRoute: typeof AccessErrorRoute
  AccessOverviewRoute: typeof AccessOverviewRoute
  AccessIndexRoute: typeof AccessIndexRoute
  AccessTasksTaskIdRoute: typeof AccessTasksTaskIdRoute
}

const AccessRouteRouteChildren: AccessRouteRouteChildren = {
  Access401Route: Access401Route,
  AccessAuthenticationRoute: AccessAuthenticationRoute,
  AccessErrorRoute: AccessErrorRoute,
  AccessOverviewRoute: AccessOverviewRoute,
  AccessIndexRoute: AccessIndexRoute,
  AccessTasksTaskIdRoute: AccessTasksTaskIdRoute,
}

const AccessRouteRouteWithChildren = AccessRouteRoute._addFileChildren(
  AccessRouteRouteChildren,
)

interface CompanyGroupIdEventsEventIdRouteRouteChildren {
  CompanyGroupIdEventsEventIdDetailsRoute: typeof CompanyGroupIdEventsEventIdDetailsRoute
  CompanyGroupIdEventsEventIdGroupsRoute: typeof CompanyGroupIdEventsEventIdGroupsRoute
  CompanyGroupIdEventsEventIdLogsRoute: typeof CompanyGroupIdEventsEventIdLogsRoute
  CompanyGroupIdEventsEventIdSubcontractingRoute: typeof CompanyGroupIdEventsEventIdSubcontractingRoute
  CompanyGroupIdEventsEventIdUsersRoute: typeof CompanyGroupIdEventsEventIdUsersRoute
  CompanyGroupIdEventsEventIdDocumentsDocumentIdRoute: typeof CompanyGroupIdEventsEventIdDocumentsDocumentIdRoute
  CompanyGroupIdEventsEventIdTasksTaskIdRoute: typeof CompanyGroupIdEventsEventIdTasksTaskIdRoute
  CompanyGroupIdEventsEventIdDocumentsIndexRoute: typeof CompanyGroupIdEventsEventIdDocumentsIndexRoute
  CompanyGroupIdEventsEventIdTasksIndexRoute: typeof CompanyGroupIdEventsEventIdTasksIndexRoute
}

const CompanyGroupIdEventsEventIdRouteRouteChildren: CompanyGroupIdEventsEventIdRouteRouteChildren =
  {
    CompanyGroupIdEventsEventIdDetailsRoute:
      CompanyGroupIdEventsEventIdDetailsRoute,
    CompanyGroupIdEventsEventIdGroupsRoute:
      CompanyGroupIdEventsEventIdGroupsRoute,
    CompanyGroupIdEventsEventIdLogsRoute: CompanyGroupIdEventsEventIdLogsRoute,
    CompanyGroupIdEventsEventIdSubcontractingRoute:
      CompanyGroupIdEventsEventIdSubcontractingRoute,
    CompanyGroupIdEventsEventIdUsersRoute:
      CompanyGroupIdEventsEventIdUsersRoute,
    CompanyGroupIdEventsEventIdDocumentsDocumentIdRoute:
      CompanyGroupIdEventsEventIdDocumentsDocumentIdRoute,
    CompanyGroupIdEventsEventIdTasksTaskIdRoute:
      CompanyGroupIdEventsEventIdTasksTaskIdRoute,
    CompanyGroupIdEventsEventIdDocumentsIndexRoute:
      CompanyGroupIdEventsEventIdDocumentsIndexRoute,
    CompanyGroupIdEventsEventIdTasksIndexRoute:
      CompanyGroupIdEventsEventIdTasksIndexRoute,
  }

const CompanyGroupIdEventsEventIdRouteRouteWithChildren =
  CompanyGroupIdEventsEventIdRouteRoute._addFileChildren(
    CompanyGroupIdEventsEventIdRouteRouteChildren,
  )

interface CompanyGroupIdProjectsProjectIdRouteRouteChildren {
  CompanyGroupIdProjectsProjectIdEventsRoute: typeof CompanyGroupIdProjectsProjectIdEventsRoute
}

const CompanyGroupIdProjectsProjectIdRouteRouteChildren: CompanyGroupIdProjectsProjectIdRouteRouteChildren =
  {
    CompanyGroupIdProjectsProjectIdEventsRoute:
      CompanyGroupIdProjectsProjectIdEventsRoute,
  }

const CompanyGroupIdProjectsProjectIdRouteRouteWithChildren =
  CompanyGroupIdProjectsProjectIdRouteRoute._addFileChildren(
    CompanyGroupIdProjectsProjectIdRouteRouteChildren,
  )

interface CompanyGroupIdRouteRouteChildren {
  CompanyGroupIdInformationRoute: typeof CompanyGroupIdInformationRoute
  CompanyGroupIdEventsEventIdRouteRoute: typeof CompanyGroupIdEventsEventIdRouteRouteWithChildren
  CompanyGroupIdProjectsProjectIdRouteRoute: typeof CompanyGroupIdProjectsProjectIdRouteRouteWithChildren
  CompanyGroupIdApprovalsTaskIdRoute: typeof CompanyGroupIdApprovalsTaskIdRoute
  CompanyGroupIdDocumentsDocumentIdRoute: typeof CompanyGroupIdDocumentsDocumentIdRoute
  CompanyGroupIdTasksTaskIdRoute: typeof CompanyGroupIdTasksTaskIdRoute
  CompanyGroupIdApprovalsIndexRoute: typeof CompanyGroupIdApprovalsIndexRoute
  CompanyGroupIdDocumentsIndexRoute: typeof CompanyGroupIdDocumentsIndexRoute
  CompanyGroupIdEventsIndexRoute: typeof CompanyGroupIdEventsIndexRoute
  CompanyGroupIdProjectsIndexRoute: typeof CompanyGroupIdProjectsIndexRoute
  CompanyGroupIdTasksIndexRoute: typeof CompanyGroupIdTasksIndexRoute
  CompanyGroupIdUsersIndexRoute: typeof CompanyGroupIdUsersIndexRoute
}

const CompanyGroupIdRouteRouteChildren: CompanyGroupIdRouteRouteChildren = {
  CompanyGroupIdInformationRoute: CompanyGroupIdInformationRoute,
  CompanyGroupIdEventsEventIdRouteRoute:
    CompanyGroupIdEventsEventIdRouteRouteWithChildren,
  CompanyGroupIdProjectsProjectIdRouteRoute:
    CompanyGroupIdProjectsProjectIdRouteRouteWithChildren,
  CompanyGroupIdApprovalsTaskIdRoute: CompanyGroupIdApprovalsTaskIdRoute,
  CompanyGroupIdDocumentsDocumentIdRoute:
    CompanyGroupIdDocumentsDocumentIdRoute,
  CompanyGroupIdTasksTaskIdRoute: CompanyGroupIdTasksTaskIdRoute,
  CompanyGroupIdApprovalsIndexRoute: CompanyGroupIdApprovalsIndexRoute,
  CompanyGroupIdDocumentsIndexRoute: CompanyGroupIdDocumentsIndexRoute,
  CompanyGroupIdEventsIndexRoute: CompanyGroupIdEventsIndexRoute,
  CompanyGroupIdProjectsIndexRoute: CompanyGroupIdProjectsIndexRoute,
  CompanyGroupIdTasksIndexRoute: CompanyGroupIdTasksIndexRoute,
  CompanyGroupIdUsersIndexRoute: CompanyGroupIdUsersIndexRoute,
}

const CompanyGroupIdRouteRouteWithChildren =
  CompanyGroupIdRouteRoute._addFileChildren(CompanyGroupIdRouteRouteChildren)

interface CompanyRouteRouteChildren {
  CompanyGroupIdRouteRoute: typeof CompanyGroupIdRouteRouteWithChildren
  CompanyIndexRoute: typeof CompanyIndexRoute
  CompanyBlockedGroupIdRoute: typeof CompanyBlockedGroupIdRoute
  CompanyVerifyGroupIdRoute: typeof CompanyVerifyGroupIdRoute
}

const CompanyRouteRouteChildren: CompanyRouteRouteChildren = {
  CompanyGroupIdRouteRoute: CompanyGroupIdRouteRouteWithChildren,
  CompanyIndexRoute: CompanyIndexRoute,
  CompanyBlockedGroupIdRoute: CompanyBlockedGroupIdRoute,
  CompanyVerifyGroupIdRoute: CompanyVerifyGroupIdRoute,
}

const CompanyRouteRouteWithChildren = CompanyRouteRoute._addFileChildren(
  CompanyRouteRouteChildren,
)

interface PartnerPartnerIdEventsEventIdRouteRouteChildren {
  PartnerPartnerIdEventsEventIdDetailsRoute: typeof PartnerPartnerIdEventsEventIdDetailsRoute
  PartnerPartnerIdEventsEventIdLogsRoute: typeof PartnerPartnerIdEventsEventIdLogsRoute
  PartnerPartnerIdEventsEventIdSubcontractingRoute: typeof PartnerPartnerIdEventsEventIdSubcontractingRoute
  PartnerPartnerIdEventsEventIdUsersRoute: typeof PartnerPartnerIdEventsEventIdUsersRoute
  PartnerPartnerIdEventsEventIdApprovalsTaskIdRoute: typeof PartnerPartnerIdEventsEventIdApprovalsTaskIdRoute
  PartnerPartnerIdEventsEventIdDocumentsDocumentIdRoute: typeof PartnerPartnerIdEventsEventIdDocumentsDocumentIdRoute
  PartnerPartnerIdEventsEventIdTasksTaskIdRoute: typeof PartnerPartnerIdEventsEventIdTasksTaskIdRoute
  PartnerPartnerIdEventsEventIdApprovalsIndexRoute: typeof PartnerPartnerIdEventsEventIdApprovalsIndexRoute
  PartnerPartnerIdEventsEventIdDocumentsIndexRoute: typeof PartnerPartnerIdEventsEventIdDocumentsIndexRoute
  PartnerPartnerIdEventsEventIdTasksIndexRoute: typeof PartnerPartnerIdEventsEventIdTasksIndexRoute
}

const PartnerPartnerIdEventsEventIdRouteRouteChildren: PartnerPartnerIdEventsEventIdRouteRouteChildren =
  {
    PartnerPartnerIdEventsEventIdDetailsRoute:
      PartnerPartnerIdEventsEventIdDetailsRoute,
    PartnerPartnerIdEventsEventIdLogsRoute:
      PartnerPartnerIdEventsEventIdLogsRoute,
    PartnerPartnerIdEventsEventIdSubcontractingRoute:
      PartnerPartnerIdEventsEventIdSubcontractingRoute,
    PartnerPartnerIdEventsEventIdUsersRoute:
      PartnerPartnerIdEventsEventIdUsersRoute,
    PartnerPartnerIdEventsEventIdApprovalsTaskIdRoute:
      PartnerPartnerIdEventsEventIdApprovalsTaskIdRoute,
    PartnerPartnerIdEventsEventIdDocumentsDocumentIdRoute:
      PartnerPartnerIdEventsEventIdDocumentsDocumentIdRoute,
    PartnerPartnerIdEventsEventIdTasksTaskIdRoute:
      PartnerPartnerIdEventsEventIdTasksTaskIdRoute,
    PartnerPartnerIdEventsEventIdApprovalsIndexRoute:
      PartnerPartnerIdEventsEventIdApprovalsIndexRoute,
    PartnerPartnerIdEventsEventIdDocumentsIndexRoute:
      PartnerPartnerIdEventsEventIdDocumentsIndexRoute,
    PartnerPartnerIdEventsEventIdTasksIndexRoute:
      PartnerPartnerIdEventsEventIdTasksIndexRoute,
  }

const PartnerPartnerIdEventsEventIdRouteRouteWithChildren =
  PartnerPartnerIdEventsEventIdRouteRoute._addFileChildren(
    PartnerPartnerIdEventsEventIdRouteRouteChildren,
  )

interface PartnerPartnerIdRouteRouteChildren {
  PartnerPartnerIdInformationRoute: typeof PartnerPartnerIdInformationRoute
  PartnerPartnerIdEventsEventIdRouteRoute: typeof PartnerPartnerIdEventsEventIdRouteRouteWithChildren
  PartnerPartnerIdApprovalsApprovalIdRoute: typeof PartnerPartnerIdApprovalsApprovalIdRoute
  PartnerPartnerIdDocumentsDocumentIdRoute: typeof PartnerPartnerIdDocumentsDocumentIdRoute
  PartnerPartnerIdProjectsProjectIdRoute: typeof PartnerPartnerIdProjectsProjectIdRoute
  PartnerPartnerIdTasksTaskIdRoute: typeof PartnerPartnerIdTasksTaskIdRoute
  PartnerPartnerIdApprovalsIndexRoute: typeof PartnerPartnerIdApprovalsIndexRoute
  PartnerPartnerIdDocumentsIndexRoute: typeof PartnerPartnerIdDocumentsIndexRoute
  PartnerPartnerIdEventsIndexRoute: typeof PartnerPartnerIdEventsIndexRoute
  PartnerPartnerIdProjectsIndexRoute: typeof PartnerPartnerIdProjectsIndexRoute
  PartnerPartnerIdTasksIndexRoute: typeof PartnerPartnerIdTasksIndexRoute
  PartnerPartnerIdUsersIndexRoute: typeof PartnerPartnerIdUsersIndexRoute
  PartnerPartnerIdUsersUserIdDocumentIdRoute: typeof PartnerPartnerIdUsersUserIdDocumentIdRoute
}

const PartnerPartnerIdRouteRouteChildren: PartnerPartnerIdRouteRouteChildren = {
  PartnerPartnerIdInformationRoute: PartnerPartnerIdInformationRoute,
  PartnerPartnerIdEventsEventIdRouteRoute:
    PartnerPartnerIdEventsEventIdRouteRouteWithChildren,
  PartnerPartnerIdApprovalsApprovalIdRoute:
    PartnerPartnerIdApprovalsApprovalIdRoute,
  PartnerPartnerIdDocumentsDocumentIdRoute:
    PartnerPartnerIdDocumentsDocumentIdRoute,
  PartnerPartnerIdProjectsProjectIdRoute:
    PartnerPartnerIdProjectsProjectIdRoute,
  PartnerPartnerIdTasksTaskIdRoute: PartnerPartnerIdTasksTaskIdRoute,
  PartnerPartnerIdApprovalsIndexRoute: PartnerPartnerIdApprovalsIndexRoute,
  PartnerPartnerIdDocumentsIndexRoute: PartnerPartnerIdDocumentsIndexRoute,
  PartnerPartnerIdEventsIndexRoute: PartnerPartnerIdEventsIndexRoute,
  PartnerPartnerIdProjectsIndexRoute: PartnerPartnerIdProjectsIndexRoute,
  PartnerPartnerIdTasksIndexRoute: PartnerPartnerIdTasksIndexRoute,
  PartnerPartnerIdUsersIndexRoute: PartnerPartnerIdUsersIndexRoute,
  PartnerPartnerIdUsersUserIdDocumentIdRoute:
    PartnerPartnerIdUsersUserIdDocumentIdRoute,
}

const PartnerPartnerIdRouteRouteWithChildren =
  PartnerPartnerIdRouteRoute._addFileChildren(
    PartnerPartnerIdRouteRouteChildren,
  )

interface PartnerRouteRouteChildren {
  PartnerPartnerIdRouteRoute: typeof PartnerPartnerIdRouteRouteWithChildren
}

const PartnerRouteRouteChildren: PartnerRouteRouteChildren = {
  PartnerPartnerIdRouteRoute: PartnerPartnerIdRouteRouteWithChildren,
}

const PartnerRouteRouteWithChildren = PartnerRouteRoute._addFileChildren(
  PartnerRouteRouteChildren,
)

interface PersonalEventsEventIdRouteRouteChildren {
  PersonalEventsEventIdDetailsRoute: typeof PersonalEventsEventIdDetailsRoute
  PersonalEventsEventIdLogsRoute: typeof PersonalEventsEventIdLogsRoute
  PersonalEventsEventIdSubcontractingRoute: typeof PersonalEventsEventIdSubcontractingRoute
  PersonalEventsEventIdUsersRoute: typeof PersonalEventsEventIdUsersRoute
  PersonalEventsEventIdIndexRoute: typeof PersonalEventsEventIdIndexRoute
  PersonalEventsEventIdApprovalsTaskIdRoute: typeof PersonalEventsEventIdApprovalsTaskIdRoute
  PersonalEventsEventIdDocumentsDocumentIdRoute: typeof PersonalEventsEventIdDocumentsDocumentIdRoute
  PersonalEventsEventIdTasksTaskIdRoute: typeof PersonalEventsEventIdTasksTaskIdRoute
  PersonalEventsEventIdApprovalsIndexRoute: typeof PersonalEventsEventIdApprovalsIndexRoute
  PersonalEventsEventIdDocumentsIndexRoute: typeof PersonalEventsEventIdDocumentsIndexRoute
  PersonalEventsEventIdTasksIndexRoute: typeof PersonalEventsEventIdTasksIndexRoute
}

const PersonalEventsEventIdRouteRouteChildren: PersonalEventsEventIdRouteRouteChildren =
  {
    PersonalEventsEventIdDetailsRoute: PersonalEventsEventIdDetailsRoute,
    PersonalEventsEventIdLogsRoute: PersonalEventsEventIdLogsRoute,
    PersonalEventsEventIdSubcontractingRoute:
      PersonalEventsEventIdSubcontractingRoute,
    PersonalEventsEventIdUsersRoute: PersonalEventsEventIdUsersRoute,
    PersonalEventsEventIdIndexRoute: PersonalEventsEventIdIndexRoute,
    PersonalEventsEventIdApprovalsTaskIdRoute:
      PersonalEventsEventIdApprovalsTaskIdRoute,
    PersonalEventsEventIdDocumentsDocumentIdRoute:
      PersonalEventsEventIdDocumentsDocumentIdRoute,
    PersonalEventsEventIdTasksTaskIdRoute:
      PersonalEventsEventIdTasksTaskIdRoute,
    PersonalEventsEventIdApprovalsIndexRoute:
      PersonalEventsEventIdApprovalsIndexRoute,
    PersonalEventsEventIdDocumentsIndexRoute:
      PersonalEventsEventIdDocumentsIndexRoute,
    PersonalEventsEventIdTasksIndexRoute: PersonalEventsEventIdTasksIndexRoute,
  }

const PersonalEventsEventIdRouteRouteWithChildren =
  PersonalEventsEventIdRouteRoute._addFileChildren(
    PersonalEventsEventIdRouteRouteChildren,
  )

interface PersonalGroupsGroupIdRouteRouteChildren {
  PersonalGroupsGroupIdDetailsRoute: typeof PersonalGroupsGroupIdDetailsRoute
  PersonalGroupsGroupIdEventsRoute: typeof PersonalGroupsGroupIdEventsRoute
  PersonalGroupsGroupIdLogsRoute: typeof PersonalGroupsGroupIdLogsRoute
  PersonalGroupsGroupIdUsersRoute: typeof PersonalGroupsGroupIdUsersRoute
  PersonalGroupsGroupIdIndexRoute: typeof PersonalGroupsGroupIdIndexRoute
  PersonalGroupsGroupIdDocumentsDocumentIdRoute: typeof PersonalGroupsGroupIdDocumentsDocumentIdRoute
  PersonalGroupsGroupIdTasksTaskIdRoute: typeof PersonalGroupsGroupIdTasksTaskIdRoute
  PersonalGroupsGroupIdDocumentsIndexRoute: typeof PersonalGroupsGroupIdDocumentsIndexRoute
  PersonalGroupsGroupIdTasksIndexRoute: typeof PersonalGroupsGroupIdTasksIndexRoute
}

const PersonalGroupsGroupIdRouteRouteChildren: PersonalGroupsGroupIdRouteRouteChildren =
  {
    PersonalGroupsGroupIdDetailsRoute: PersonalGroupsGroupIdDetailsRoute,
    PersonalGroupsGroupIdEventsRoute: PersonalGroupsGroupIdEventsRoute,
    PersonalGroupsGroupIdLogsRoute: PersonalGroupsGroupIdLogsRoute,
    PersonalGroupsGroupIdUsersRoute: PersonalGroupsGroupIdUsersRoute,
    PersonalGroupsGroupIdIndexRoute: PersonalGroupsGroupIdIndexRoute,
    PersonalGroupsGroupIdDocumentsDocumentIdRoute:
      PersonalGroupsGroupIdDocumentsDocumentIdRoute,
    PersonalGroupsGroupIdTasksTaskIdRoute:
      PersonalGroupsGroupIdTasksTaskIdRoute,
    PersonalGroupsGroupIdDocumentsIndexRoute:
      PersonalGroupsGroupIdDocumentsIndexRoute,
    PersonalGroupsGroupIdTasksIndexRoute: PersonalGroupsGroupIdTasksIndexRoute,
  }

const PersonalGroupsGroupIdRouteRouteWithChildren =
  PersonalGroupsGroupIdRouteRoute._addFileChildren(
    PersonalGroupsGroupIdRouteRouteChildren,
  )

interface PersonalProjectsProjectIdRouteRouteChildren {
  PersonalProjectsProjectIdEventsRoute: typeof PersonalProjectsProjectIdEventsRoute
  PersonalProjectsProjectIdLogsRoute: typeof PersonalProjectsProjectIdLogsRoute
  PersonalProjectsProjectIdIndexRoute: typeof PersonalProjectsProjectIdIndexRoute
}

const PersonalProjectsProjectIdRouteRouteChildren: PersonalProjectsProjectIdRouteRouteChildren =
  {
    PersonalProjectsProjectIdEventsRoute: PersonalProjectsProjectIdEventsRoute,
    PersonalProjectsProjectIdLogsRoute: PersonalProjectsProjectIdLogsRoute,
    PersonalProjectsProjectIdIndexRoute: PersonalProjectsProjectIdIndexRoute,
  }

const PersonalProjectsProjectIdRouteRouteWithChildren =
  PersonalProjectsProjectIdRouteRoute._addFileChildren(
    PersonalProjectsProjectIdRouteRouteChildren,
  )

interface PersonalRouteRouteChildren {
  PersonalOverviewRoute: typeof PersonalOverviewRoute
  PersonalTasksRoute: typeof PersonalTasksRoute
  PersonalIndexRoute: typeof PersonalIndexRoute
  PersonalEventsEventIdRouteRoute: typeof PersonalEventsEventIdRouteRouteWithChildren
  PersonalGroupsGroupIdRouteRoute: typeof PersonalGroupsGroupIdRouteRouteWithChildren
  PersonalProjectsProjectIdRouteRoute: typeof PersonalProjectsProjectIdRouteRouteWithChildren
  PersonalEventsIndexRoute: typeof PersonalEventsIndexRoute
  PersonalGroupsIndexRoute: typeof PersonalGroupsIndexRoute
  PersonalProjectsIndexRoute: typeof PersonalProjectsIndexRoute
}

const PersonalRouteRouteChildren: PersonalRouteRouteChildren = {
  PersonalOverviewRoute: PersonalOverviewRoute,
  PersonalTasksRoute: PersonalTasksRoute,
  PersonalIndexRoute: PersonalIndexRoute,
  PersonalEventsEventIdRouteRoute: PersonalEventsEventIdRouteRouteWithChildren,
  PersonalGroupsGroupIdRouteRoute: PersonalGroupsGroupIdRouteRouteWithChildren,
  PersonalProjectsProjectIdRouteRoute:
    PersonalProjectsProjectIdRouteRouteWithChildren,
  PersonalEventsIndexRoute: PersonalEventsIndexRoute,
  PersonalGroupsIndexRoute: PersonalGroupsIndexRoute,
  PersonalProjectsIndexRoute: PersonalProjectsIndexRoute,
}

const PersonalRouteRouteWithChildren = PersonalRouteRoute._addFileChildren(
  PersonalRouteRouteChildren,
)

interface SupervisorRouteRouteChildren {
  SupervisorLogsRoute: typeof SupervisorLogsRoute
  SupervisorUsersRoute: typeof SupervisorUsersRoute
  SupervisorIndexRoute: typeof SupervisorIndexRoute
}

const SupervisorRouteRouteChildren: SupervisorRouteRouteChildren = {
  SupervisorLogsRoute: SupervisorLogsRoute,
  SupervisorUsersRoute: SupervisorUsersRoute,
  SupervisorIndexRoute: SupervisorIndexRoute,
}

const SupervisorRouteRouteWithChildren = SupervisorRouteRoute._addFileChildren(
  SupervisorRouteRouteChildren,
)

interface AdminSiteIdOverviewRouteRouteChildren {
  AdminSiteIdOverviewApprovalsRoute: typeof AdminSiteIdOverviewApprovalsRoute
  AdminSiteIdOverviewAttendanceRoute: typeof AdminSiteIdOverviewAttendanceRoute
  AdminSiteIdOverviewToReviewRoute: typeof AdminSiteIdOverviewToReviewRoute
  AdminSiteIdOverviewIndexRoute: typeof AdminSiteIdOverviewIndexRoute
}

const AdminSiteIdOverviewRouteRouteChildren: AdminSiteIdOverviewRouteRouteChildren =
  {
    AdminSiteIdOverviewApprovalsRoute: AdminSiteIdOverviewApprovalsRoute,
    AdminSiteIdOverviewAttendanceRoute: AdminSiteIdOverviewAttendanceRoute,
    AdminSiteIdOverviewToReviewRoute: AdminSiteIdOverviewToReviewRoute,
    AdminSiteIdOverviewIndexRoute: AdminSiteIdOverviewIndexRoute,
  }

const AdminSiteIdOverviewRouteRouteWithChildren =
  AdminSiteIdOverviewRouteRoute._addFileChildren(
    AdminSiteIdOverviewRouteRouteChildren,
  )

interface AdminSiteIdRouteRouteChildren {
  AdminSiteIdOverviewRouteRoute: typeof AdminSiteIdOverviewRouteRouteWithChildren
}

const AdminSiteIdRouteRouteChildren: AdminSiteIdRouteRouteChildren = {
  AdminSiteIdOverviewRouteRoute: AdminSiteIdOverviewRouteRouteWithChildren,
}

const AdminSiteIdRouteRouteWithChildren =
  AdminSiteIdRouteRoute._addFileChildren(AdminSiteIdRouteRouteChildren)

interface AdminEventsEventIdRouteRouteChildren {
  AdminEventsEventIdDetailsRoute: typeof AdminEventsEventIdDetailsRoute
  AdminEventsEventIdLogsRoute: typeof AdminEventsEventIdLogsRoute
  AdminEventsEventIdSubcontractingRoute: typeof AdminEventsEventIdSubcontractingRoute
  AdminEventsEventIdUsersRoute: typeof AdminEventsEventIdUsersRoute
  AdminEventsEventIdIndexRoute: typeof AdminEventsEventIdIndexRoute
  AdminEventsEventIdApprovalsTaskIdRoute: typeof AdminEventsEventIdApprovalsTaskIdRoute
  AdminEventsEventIdDocumentsDocumentIdRoute: typeof AdminEventsEventIdDocumentsDocumentIdRoute
  AdminEventsEventIdTasksTaskIdRoute: typeof AdminEventsEventIdTasksTaskIdRoute
  AdminEventsEventIdApprovalsIndexRoute: typeof AdminEventsEventIdApprovalsIndexRoute
  AdminEventsEventIdDocumentsIndexRoute: typeof AdminEventsEventIdDocumentsIndexRoute
  AdminEventsEventIdTasksIndexRoute: typeof AdminEventsEventIdTasksIndexRoute
}

const AdminEventsEventIdRouteRouteChildren: AdminEventsEventIdRouteRouteChildren =
  {
    AdminEventsEventIdDetailsRoute: AdminEventsEventIdDetailsRoute,
    AdminEventsEventIdLogsRoute: AdminEventsEventIdLogsRoute,
    AdminEventsEventIdSubcontractingRoute:
      AdminEventsEventIdSubcontractingRoute,
    AdminEventsEventIdUsersRoute: AdminEventsEventIdUsersRoute,
    AdminEventsEventIdIndexRoute: AdminEventsEventIdIndexRoute,
    AdminEventsEventIdApprovalsTaskIdRoute:
      AdminEventsEventIdApprovalsTaskIdRoute,
    AdminEventsEventIdDocumentsDocumentIdRoute:
      AdminEventsEventIdDocumentsDocumentIdRoute,
    AdminEventsEventIdTasksTaskIdRoute: AdminEventsEventIdTasksTaskIdRoute,
    AdminEventsEventIdApprovalsIndexRoute:
      AdminEventsEventIdApprovalsIndexRoute,
    AdminEventsEventIdDocumentsIndexRoute:
      AdminEventsEventIdDocumentsIndexRoute,
    AdminEventsEventIdTasksIndexRoute: AdminEventsEventIdTasksIndexRoute,
  }

const AdminEventsEventIdRouteRouteWithChildren =
  AdminEventsEventIdRouteRoute._addFileChildren(
    AdminEventsEventIdRouteRouteChildren,
  )

interface AdminGroupsGroupIdRouteRouteChildren {
  AdminGroupsGroupIdContactDetailsRoute: typeof AdminGroupsGroupIdContactDetailsRoute
  AdminGroupsGroupIdDetailsRoute: typeof AdminGroupsGroupIdDetailsRoute
  AdminGroupsGroupIdEventsRoute: typeof AdminGroupsGroupIdEventsRoute
  AdminGroupsGroupIdLogsRoute: typeof AdminGroupsGroupIdLogsRoute
  AdminGroupsGroupIdUsersRoute: typeof AdminGroupsGroupIdUsersRoute
  AdminGroupsGroupIdIndexRoute: typeof AdminGroupsGroupIdIndexRoute
  AdminGroupsGroupIdApprovalsApprovalIdRoute: typeof AdminGroupsGroupIdApprovalsApprovalIdRoute
  AdminGroupsGroupIdDocumentsDocumentIdRoute: typeof AdminGroupsGroupIdDocumentsDocumentIdRoute
  AdminGroupsGroupIdTasksTaskIdRoute: typeof AdminGroupsGroupIdTasksTaskIdRoute
  AdminGroupsGroupIdApprovalsIndexRoute: typeof AdminGroupsGroupIdApprovalsIndexRoute
  AdminGroupsGroupIdDocumentsIndexRoute: typeof AdminGroupsGroupIdDocumentsIndexRoute
  AdminGroupsGroupIdTasksIndexRoute: typeof AdminGroupsGroupIdTasksIndexRoute
}

const AdminGroupsGroupIdRouteRouteChildren: AdminGroupsGroupIdRouteRouteChildren =
  {
    AdminGroupsGroupIdContactDetailsRoute:
      AdminGroupsGroupIdContactDetailsRoute,
    AdminGroupsGroupIdDetailsRoute: AdminGroupsGroupIdDetailsRoute,
    AdminGroupsGroupIdEventsRoute: AdminGroupsGroupIdEventsRoute,
    AdminGroupsGroupIdLogsRoute: AdminGroupsGroupIdLogsRoute,
    AdminGroupsGroupIdUsersRoute: AdminGroupsGroupIdUsersRoute,
    AdminGroupsGroupIdIndexRoute: AdminGroupsGroupIdIndexRoute,
    AdminGroupsGroupIdApprovalsApprovalIdRoute:
      AdminGroupsGroupIdApprovalsApprovalIdRoute,
    AdminGroupsGroupIdDocumentsDocumentIdRoute:
      AdminGroupsGroupIdDocumentsDocumentIdRoute,
    AdminGroupsGroupIdTasksTaskIdRoute: AdminGroupsGroupIdTasksTaskIdRoute,
    AdminGroupsGroupIdApprovalsIndexRoute:
      AdminGroupsGroupIdApprovalsIndexRoute,
    AdminGroupsGroupIdDocumentsIndexRoute:
      AdminGroupsGroupIdDocumentsIndexRoute,
    AdminGroupsGroupIdTasksIndexRoute: AdminGroupsGroupIdTasksIndexRoute,
  }

const AdminGroupsGroupIdRouteRouteWithChildren =
  AdminGroupsGroupIdRouteRoute._addFileChildren(
    AdminGroupsGroupIdRouteRouteChildren,
  )

interface AdminProjectsProjectIdRouteRouteChildren {
  AdminProjectsProjectIdEventsRoute: typeof AdminProjectsProjectIdEventsRoute
  AdminProjectsProjectIdLogsRoute: typeof AdminProjectsProjectIdLogsRoute
  AdminProjectsProjectIdIndexRoute: typeof AdminProjectsProjectIdIndexRoute
}

const AdminProjectsProjectIdRouteRouteChildren: AdminProjectsProjectIdRouteRouteChildren =
  {
    AdminProjectsProjectIdEventsRoute: AdminProjectsProjectIdEventsRoute,
    AdminProjectsProjectIdLogsRoute: AdminProjectsProjectIdLogsRoute,
    AdminProjectsProjectIdIndexRoute: AdminProjectsProjectIdIndexRoute,
  }

const AdminProjectsProjectIdRouteRouteWithChildren =
  AdminProjectsProjectIdRouteRoute._addFileChildren(
    AdminProjectsProjectIdRouteRouteChildren,
  )

interface AdminUsersUserIdRouteRouteChildren {
  AdminUsersUserIdAccessRoute: typeof AdminUsersUserIdAccessRoute
  AdminUsersUserIdBadgesRoute: typeof AdminUsersUserIdBadgesRoute
  AdminUsersUserIdDetailsRoute: typeof AdminUsersUserIdDetailsRoute
  AdminUsersUserIdEventsRoute: typeof AdminUsersUserIdEventsRoute
  AdminUsersUserIdLogsRoute: typeof AdminUsersUserIdLogsRoute
  AdminUsersUserIdRolesRoute: typeof AdminUsersUserIdRolesRoute
  AdminUsersUserIdIndexRoute: typeof AdminUsersUserIdIndexRoute
  AdminUsersUserIdApprovalsApprovalIdRoute: typeof AdminUsersUserIdApprovalsApprovalIdRoute
  AdminUsersUserIdDocumentsDocumentIdRoute: typeof AdminUsersUserIdDocumentsDocumentIdRoute
  AdminUsersUserIdTasksTaskIdRoute: typeof AdminUsersUserIdTasksTaskIdRoute
  AdminUsersUserIdApprovalsIndexRoute: typeof AdminUsersUserIdApprovalsIndexRoute
  AdminUsersUserIdDocumentsIndexRoute: typeof AdminUsersUserIdDocumentsIndexRoute
  AdminUsersUserIdTasksIndexRoute: typeof AdminUsersUserIdTasksIndexRoute
}

const AdminUsersUserIdRouteRouteChildren: AdminUsersUserIdRouteRouteChildren = {
  AdminUsersUserIdAccessRoute: AdminUsersUserIdAccessRoute,
  AdminUsersUserIdBadgesRoute: AdminUsersUserIdBadgesRoute,
  AdminUsersUserIdDetailsRoute: AdminUsersUserIdDetailsRoute,
  AdminUsersUserIdEventsRoute: AdminUsersUserIdEventsRoute,
  AdminUsersUserIdLogsRoute: AdminUsersUserIdLogsRoute,
  AdminUsersUserIdRolesRoute: AdminUsersUserIdRolesRoute,
  AdminUsersUserIdIndexRoute: AdminUsersUserIdIndexRoute,
  AdminUsersUserIdApprovalsApprovalIdRoute:
    AdminUsersUserIdApprovalsApprovalIdRoute,
  AdminUsersUserIdDocumentsDocumentIdRoute:
    AdminUsersUserIdDocumentsDocumentIdRoute,
  AdminUsersUserIdTasksTaskIdRoute: AdminUsersUserIdTasksTaskIdRoute,
  AdminUsersUserIdApprovalsIndexRoute: AdminUsersUserIdApprovalsIndexRoute,
  AdminUsersUserIdDocumentsIndexRoute: AdminUsersUserIdDocumentsIndexRoute,
  AdminUsersUserIdTasksIndexRoute: AdminUsersUserIdTasksIndexRoute,
}

const AdminUsersUserIdRouteRouteWithChildren =
  AdminUsersUserIdRouteRoute._addFileChildren(
    AdminUsersUserIdRouteRouteChildren,
  )

interface AdminRouteChildren {
  AdminSiteIdRouteRoute: typeof AdminSiteIdRouteRouteWithChildren
  Admin401Route: typeof Admin401Route
  Admin404Route: typeof Admin404Route
  AdminErrorRoute: typeof AdminErrorRoute
  AdminOverviewRoute: typeof AdminOverviewRoute
  AdminEventsEventIdRouteRoute: typeof AdminEventsEventIdRouteRouteWithChildren
  AdminGroupsGroupIdRouteRoute: typeof AdminGroupsGroupIdRouteRouteWithChildren
  AdminProjectsProjectIdRouteRoute: typeof AdminProjectsProjectIdRouteRouteWithChildren
  AdminUsersUserIdRouteRoute: typeof AdminUsersUserIdRouteRouteWithChildren
  AdminConfigZonesRoute: typeof AdminConfigZonesRoute
  AdminReportsAccessLogsRoute: typeof AdminReportsAccessLogsRoute
  AdminReportsDocumentsRoute: typeof AdminReportsDocumentsRoute
  AdminReportsOccupancyRoute: typeof AdminReportsOccupancyRoute
  AdminReportsSiteStatusRoute: typeof AdminReportsSiteStatusRoute
  AdminReportsTimeOnSiteRoute: typeof AdminReportsTimeOnSiteRoute
  AdminSystemAgenticParsingRoute: typeof AdminSystemAgenticParsingRoute
  AdminSystemAssetsRoute: typeof AdminSystemAssetsRoute
  AdminSystemDatasourcesRoute: typeof AdminSystemDatasourcesRoute
  AdminSystemDocumentTypesRoute: typeof AdminSystemDocumentTypesRoute
  AdminSystemImportRoute: typeof AdminSystemImportRoute
  AdminSystemIntegrationsRoute: typeof AdminSystemIntegrationsRoute
  AdminSystemOverviewRoute: typeof AdminSystemOverviewRoute
  AdminSystemSettingsRoute: typeof AdminSystemSettingsRoute
  AdminEventsIndexRoute: typeof AdminEventsIndexRoute
  AdminGroupsIndexRoute: typeof AdminGroupsIndexRoute
  AdminLogsIndexRoute: typeof AdminLogsIndexRoute
  AdminProjectsIndexRoute: typeof AdminProjectsIndexRoute
  AdminReportsIndexRoute: typeof AdminReportsIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
  AdminConfigDevicesDeviceIdRoute: typeof AdminConfigDevicesDeviceIdRoute
  AdminConfigDevicesTopologyRoute: typeof AdminConfigDevicesTopologyRoute
  AdminConfigRolesRoleIdRoute: typeof AdminConfigRolesRoleIdRoute
  AdminConfigRolesAccessRoute: typeof AdminConfigRolesAccessRoute
  AdminSystemFormsIdRoute: typeof AdminSystemFormsIdRoute
  AdminSystemSitesIdRoute: typeof AdminSystemSitesIdRoute
  AdminSystemTemplatesIdRoute: typeof AdminSystemTemplatesIdRoute
  AdminConfigBlocklistIndexRoute: typeof AdminConfigBlocklistIndexRoute
  AdminConfigDevicesIndexRoute: typeof AdminConfigDevicesIndexRoute
  AdminConfigGeneralIndexRoute: typeof AdminConfigGeneralIndexRoute
  AdminConfigIntegrationsIndexRoute: typeof AdminConfigIntegrationsIndexRoute
  AdminConfigRolesIndexRoute: typeof AdminConfigRolesIndexRoute
  AdminConfigTasksIndexRoute: typeof AdminConfigTasksIndexRoute
  AdminSystemFormsIndexRoute: typeof AdminSystemFormsIndexRoute
  AdminSystemSitesIndexRoute: typeof AdminSystemSitesIndexRoute
  AdminSystemTemplatesIndexRoute: typeof AdminSystemTemplatesIndexRoute
  AdminConfigFormsSlugOrIdBuildRoute: typeof AdminConfigFormsSlugOrIdBuildRoute
  AdminConfigTasksSlugTranslateRoute: typeof AdminConfigTasksSlugTranslateRoute
  AdminConfigTypesEventTypeIdRoute: typeof AdminConfigTypesEventTypeIdRoute
  AdminConfigTypesGroupTypeIdRoute: typeof AdminConfigTypesGroupTypeIdRoute
  AdminConfigTasksSlugIndexRoute: typeof AdminConfigTasksSlugIndexRoute
  AdminConfigTypesEventIndexRoute: typeof AdminConfigTypesEventIndexRoute
  AdminConfigTypesGroupIndexRoute: typeof AdminConfigTypesGroupIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminSiteIdRouteRoute: AdminSiteIdRouteRouteWithChildren,
  Admin401Route: Admin401Route,
  Admin404Route: Admin404Route,
  AdminErrorRoute: AdminErrorRoute,
  AdminOverviewRoute: AdminOverviewRoute,
  AdminEventsEventIdRouteRoute: AdminEventsEventIdRouteRouteWithChildren,
  AdminGroupsGroupIdRouteRoute: AdminGroupsGroupIdRouteRouteWithChildren,
  AdminProjectsProjectIdRouteRoute:
    AdminProjectsProjectIdRouteRouteWithChildren,
  AdminUsersUserIdRouteRoute: AdminUsersUserIdRouteRouteWithChildren,
  AdminConfigZonesRoute: AdminConfigZonesRoute,
  AdminReportsAccessLogsRoute: AdminReportsAccessLogsRoute,
  AdminReportsDocumentsRoute: AdminReportsDocumentsRoute,
  AdminReportsOccupancyRoute: AdminReportsOccupancyRoute,
  AdminReportsSiteStatusRoute: AdminReportsSiteStatusRoute,
  AdminReportsTimeOnSiteRoute: AdminReportsTimeOnSiteRoute,
  AdminSystemAgenticParsingRoute: AdminSystemAgenticParsingRoute,
  AdminSystemAssetsRoute: AdminSystemAssetsRoute,
  AdminSystemDatasourcesRoute: AdminSystemDatasourcesRoute,
  AdminSystemDocumentTypesRoute: AdminSystemDocumentTypesRoute,
  AdminSystemImportRoute: AdminSystemImportRoute,
  AdminSystemIntegrationsRoute: AdminSystemIntegrationsRoute,
  AdminSystemOverviewRoute: AdminSystemOverviewRoute,
  AdminSystemSettingsRoute: AdminSystemSettingsRoute,
  AdminEventsIndexRoute: AdminEventsIndexRoute,
  AdminGroupsIndexRoute: AdminGroupsIndexRoute,
  AdminLogsIndexRoute: AdminLogsIndexRoute,
  AdminProjectsIndexRoute: AdminProjectsIndexRoute,
  AdminReportsIndexRoute: AdminReportsIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
  AdminConfigDevicesDeviceIdRoute: AdminConfigDevicesDeviceIdRoute,
  AdminConfigDevicesTopologyRoute: AdminConfigDevicesTopologyRoute,
  AdminConfigRolesRoleIdRoute: AdminConfigRolesRoleIdRoute,
  AdminConfigRolesAccessRoute: AdminConfigRolesAccessRoute,
  AdminSystemFormsIdRoute: AdminSystemFormsIdRoute,
  AdminSystemSitesIdRoute: AdminSystemSitesIdRoute,
  AdminSystemTemplatesIdRoute: AdminSystemTemplatesIdRoute,
  AdminConfigBlocklistIndexRoute: AdminConfigBlocklistIndexRoute,
  AdminConfigDevicesIndexRoute: AdminConfigDevicesIndexRoute,
  AdminConfigGeneralIndexRoute: AdminConfigGeneralIndexRoute,
  AdminConfigIntegrationsIndexRoute: AdminConfigIntegrationsIndexRoute,
  AdminConfigRolesIndexRoute: AdminConfigRolesIndexRoute,
  AdminConfigTasksIndexRoute: AdminConfigTasksIndexRoute,
  AdminSystemFormsIndexRoute: AdminSystemFormsIndexRoute,
  AdminSystemSitesIndexRoute: AdminSystemSitesIndexRoute,
  AdminSystemTemplatesIndexRoute: AdminSystemTemplatesIndexRoute,
  AdminConfigFormsSlugOrIdBuildRoute: AdminConfigFormsSlugOrIdBuildRoute,
  AdminConfigTasksSlugTranslateRoute: AdminConfigTasksSlugTranslateRoute,
  AdminConfigTypesEventTypeIdRoute: AdminConfigTypesEventTypeIdRoute,
  AdminConfigTypesGroupTypeIdRoute: AdminConfigTypesGroupTypeIdRoute,
  AdminConfigTasksSlugIndexRoute: AdminConfigTasksSlugIndexRoute,
  AdminConfigTypesEventIndexRoute: AdminConfigTypesEventIndexRoute,
  AdminConfigTypesGroupIndexRoute: AdminConfigTypesGroupIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AuthenticationRouteChildren {
  AuthenticationForgotPasswordRoute: typeof AuthenticationForgotPasswordRoute
  AuthenticationLoginRoute: typeof AuthenticationLoginRoute
  AuthenticationLogoutRoute: typeof AuthenticationLogoutRoute
  AuthenticationResetPasswordRoute: typeof AuthenticationResetPasswordRoute
}

const AuthenticationRouteChildren: AuthenticationRouteChildren = {
  AuthenticationForgotPasswordRoute: AuthenticationForgotPasswordRoute,
  AuthenticationLoginRoute: AuthenticationLoginRoute,
  AuthenticationLogoutRoute: AuthenticationLogoutRoute,
  AuthenticationResetPasswordRoute: AuthenticationResetPasswordRoute,
}

const AuthenticationRouteWithChildren = AuthenticationRoute._addFileChildren(
  AuthenticationRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccessRouteRoute: AccessRouteRouteWithChildren,
  CompanyRouteRoute: CompanyRouteRouteWithChildren,
  PartnerRouteRoute: PartnerRouteRouteWithChildren,
  PersonalRouteRoute: PersonalRouteRouteWithChildren,
  SupervisorRouteRoute: SupervisorRouteRouteWithChildren,
  R403Route: R403Route,
  AdminRoute: AdminRouteWithChildren,
  AuthenticationRoute: AuthenticationRouteWithChildren,
  ProfileRoute: ProfileRoute,
  WelcomeRoute: WelcomeRoute,
  AppOnboardingRoute: AppOnboardingRoute,
  AppRegistrationFixedRoute: AppRegistrationFixedRoute,
  AppTasksTaskIdRoute: AppTasksTaskIdRoute,
  AppRegistrationIndexRoute: AppRegistrationIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
